import Vue from "vue";
import { MLCreate, MLInstaller, MLanguage } from "vue-multilanguage";

Vue.use(MLInstaller);

// Atenção - utilizar craze (`) para delimitar as strings e sempre colocar uma virgula no final da linha!
//         - não utilizar variáveis em multiplas linhas!

export default new MLCreate({
  initial: "english",
  save: true,
  languages: [
    new MLanguage("portuguese").create({
      ln: "br",
      //translation_script_start_pt
      agreementText: `Você concorda com os termos do contrato de confidencialidade?`,
      agree: `Concordo`,
      doNotAgree: `Não Concordo`,
      programWithNda: `Este programa possui um NDA vinculado!`,
      ndaAccepted: `NDA aceito!`,
      programWithoutNda: `Este programa ainda não possui um NDA vinculado!`,
      menuProgram: `Programas`,
      menuReport: `Relatórios`,
      menuAccount: `Minha conta`,
      navInvitations: `Convites`,
      navPayments: `Pagamentos`,
      navCreateNda: `Criar um Modelo NDA`,
      navEditNda: `Editar NDA`,
      navPrograms: `Todos`,
      navPublished: `Publicados`,
      navClosed: `Inativos`,
      navNda: `NDAs`,
      navAll: `Todos`,
      navPending: `Pendente`,
      navRetest: `Reteste`,
      dashTitle: `Bem vindo {0}!`,
      dashSubTitle: `Uma visão geral e acesso rápido da sua conta só para você`,
      dashReportResolv: `Relatórios aprovados`,
      navAverage: `Média de Recompensas`,
      dashMsgYouHave: `Você possui`,
      dashMsgYouDHave: `Você não possui`,
      msgProgramPu: `programas publicos!`,
      msgProgramPr: `programas privados!`,
      dashMsgGP: `Gerenciar seus programas.`,
      dashMsgCP: `Cadastrar um programa agora?`,
      dashInvTitle: `Convide Especialistas!`,
      dashInvSubTitle: `Faça o convite à especialistas para participar dos seus programas.`,
      dashPayTitle: `Pagamentos!`,
      dashPaySubTitle: `Resumo financeiro e solicitações de pagamentos.`,
      dashNdaTitle: `Contratos de Confidencialidade!`,
      dashNdaSubTitle: `Gerencie os contratos de confidencialidade dos seus programas.`,
      dashCreatNdaTitle: `Modelo Padrão de NDA!`,
      dashCreatNdaSubTitle: `Crie um modelo padrão para gerenciar os contratos de confidencialidade dos seus programas.`,
      dashCreatNdaAbriefsummary: `Um breve sumário pra o especialista entender do que se trata ...`,
      dashCreatNdaDesc: `NDA é uma sigla em inglês para Non-Disclosure-Agreements, ou simplesmente acordo de sigilo de informações. Ele tem a intenção de proteger segredos industriais, comerciais, ou ainda qualquer informação que não pode ser divulgada e deve manter-se em sigilo entre aqueles que têm acesso a ela.`,
      dashCreatNdaWriteTerms: `Redija os termos do seu contrato de confidencialidade e suas peculiaridades.`,
      dashCreatNdawritePaste: `Vamos começar, redija ou cole os seus termos!`,
      dashCreatNdaWantAttach: `Quer anexar um documento à ser assinado?`,
      progTitle: `Visão Geral!`,
      progSubTitle: `Acompanhe e gerencie seus programas na BugHunt.`,
      progPubTitle: `Programas Publicados!`,
      progPubSubTitle: `Gerencie seus programas publicados! Acompanhe todos os detalhes.`,
      progCampTitle: `Campanhas`,
      progClosTitle: `Programas Inativos!`,
      progClosSubTitle: `Bateu saudade? Veja os dados dos programas inativos.`,
      progCreateTitle: `Criar um Programa`,
      progCreateSubTitle: `Momento emocionante, hora de começar a criar o seu programa!`,
      progRankTitle: `Ranking de Contribuições!`,
      progRankSubTitle: `Veja quem mais contribui com seus programas.`,
      progRankSendThank: `Envie um Agradecimento!`,
      progRankBtnSendThank: `Enviar Agradecimento`,
      progTimelineTitle: `Programas Timeline!`,
      progTimelineSubTitle: `Acompanhe a timeline dos seus programas`,
      repTitle: `Relatórios!`,
      repSubTitle: `Gerencie os relatórios enviados por especialistas aos seus programas.`,
      repSubTitleHacker: `Gerencie os relatórios enviados aos programas.`,
      repDetMsgAlter: `Alterações feitas no relatório não podem ser desfeitas!`,
      ccpTitle: `Vamos criar um programa ?`,
      ccpProgPubli: `Programa Público`,
      ccpProgPubliDesc: `Criar um programa onde todos os especialistas cadastrados podem ver e enviar relatórios!`,
      ccpProgVDPDesc: `Criar um programa onde todos os especialistas podem ver e enviar relatórios!`,
      ccpProgPriv: `Programa Privado`,
      ccpProgPrivDesc: `Criar um programa onde somente os especialistas selecionados podem ver e enviar relatórios!`,
      managedProgram: `Programa Gerenciado`,
      protectedByNDA: `Protegido por um NDA`,
      helpTitle: `Precisando de ajuda ?`,
      helpProgram: `Como funciona um programa ?`,
      helpDifference: `Qual a diferença entre privado e público ?`,
      helpaverage: `Qual a média aplicada em um bounty ?`,
      rankTitle: `Ranking de Contribuições`,
      retest_confirmed: `Corrigido`,
      retest_denied: `Falha persiste`,
      accountSubTitle: `Uma visão geral e acesso rápido da sua conta só para você.`,
      accountAcSubTitle: `Quem, quando e como acessaram sua conta`,
      accountTerSubTitle: `Acesse nossos termos e política de privacidade`,
      accountUserSubTitle: `Gerencie quem tem acesso a organização.`,
      accountSettSubTitle: `Como deseja receber seus e-mails, política de privacidade e outros.`,
      aboutUs: `Sobre nós`,
      aboutYou: `Sobre você`,
      aboutYourAccount: `Sobre sua conta`,
      aboutTheProgramPolicy: `Sobre a política do programa!`,
      add: `Adicionar`,
      addUser: `Adicionar Usuário`,
      addAcomment: `Adicione um comentário`,
      addExpertToBlacklist: `Adicionar especialista à Blacklist`,
      addTheScopesHere: `Adicione os escopos aqui!`,
      addOutOfScopesHere: `Adicione aqui as aplicações que devem ser evitadas durante os testes de segurança!`,
      addYourPayPalAccount: `Adicione sua conta do PayPal`,
      adjustedTheImpactTo: `ajustou o impacto para`,
      adjustedTheImpactFrom: `ajustou o impacto de`,
      adjustMetrics: `Ajustar Métricas`,
      allowedFiles: `Arquivos permitidos: vídeos, imagens e arquivos de texto .jpg .jpeg .png .txt .rar .zip .7z`,
      alreadyHaveAccount: `Já possui uma conta?`,
      accepted: `Aceito`,
      acceptThisInvitation: `Aceitar este Convite!`,
      access: `Acessos`,
      accessControl: `Controle de Acesso`,
      accessMyAccount: `Acessar minha conta!`,
      accessProfile: `Perfil de Acesso`,
      accessInformation: `Informações de Acesso`,
      accountCreatedSuccessfully: `Conta criada com sucesso!`,
      accountDeleted: `Conta deletada`,
      accountRecovery: `Recuperação de conta`,
      accurate: `Apurado`,
      activate: `Ativar`,
      activated: ` Ativado`,
      additionalServices: `Serviços Adicionais`,
      addOtherRewardsHere: `Adicione outras recompensas aqui!`,
      addToBlacklist: `Adicionar a Blacklist`,
      agreementSpecialists: `Especialistas em acordo`,
      ago: `há {0}`,
      aGoodPolicAvoids: `Uma boa política evita problemas, caso tenha algum problema nos consulte.`,
      all: `Todos`,
      gatTagOptDescription: `Apenas relatórios quem contenham a tag GAT`,
      gatTagDescription: `Quais relatórios serão enviados para a plataforma GAT?`,
      allowMobileAccess: `Permitir acessos de celular`,
      allowedToPayReward: `Tem permissão para pagar recompensas.`,
      allThePrograms: `Todos os programas`,
      allStatus: `Todos os Status`,
      aLowercaseLetter: `uma letra minúscula`,
      anEmailContainingPasswordReset: `Um email contendo instruções para o reset de senha foi enviado.`,
      aNewValidationEmailHasBeenSenToYou: `Um novo e-mail de validação foi enviado para você, verique sua caixa postal`,
      aNewSuperStrongPassword: `Uma nova senha super forte!`,
      annotation: `Anotação`,
      aNumber: `um número`,
      anUppercaseLetter: `uma letra maiúscula`,
      thePasswordMustHave: `A senha deve ter`,
      anyQuestionsAboutIntegration: `Dúvidas sobre essa integração?`,
      application: `Aplicativo`,
      applicableReport: `Relatório aplicável`,
      approveWithoutRetest: `Você deseja mesmo encerrar o relatório como aprovado antes de solicitar um reteste?`,
      approveRetest: `Aprovar reteste`,
      approvedRetest: `aprovou o reteste`,
      areYouSureYouWantToDeleteThisUser: `Tem certeza de que deseja excluir este usuário ?`,
      as: `como`,
      aSuperStrongPasswordNow: `Uma senha super forte agora!`,
      atBugHuntYouWillFindPrograms: `Na BugHunt você vai encontrar programas para testar diferentes tipos de tecnologias, coloque em prática seus conhecimentos, testando aplicações reais de forma ética e legalizada.`,
      attention: `Atenção!`,
      atLeastCharacters: `no mínimo 6 caracteres`,
      authentication: `Autenticação`,
      averageTicket: `Ticket Médio`,
      average_time_to_bounty: `Tempo médio para pagar recompensa`,
      average_time_to_first_response: `Tempo médio para a primeira resposta`,
      average_time_to_resolution: `Tempo médio para encerramento do relatório`,
      averageTimeToBounty: `Tempo médio para pagamento`,
      avgTimeToBounty: `O tempo médio decorrido desde a primeira interação da empresa com um relatório até a solicitação de pagamento de uma recompensa.`,
      avgTimeToFirstResponse: `O tempo médio decorrido desde o envio do relatório até a primeira interação da empresa com um relatório.`,
      avgTimeToResolution: `O tempo médio decorrido desde a abertura de um relatório até o seu encerramento.`,
      avgTimeToBunty: `Tempo médio entre a solicitação e a efetivação do pagamento.`,
      awaitingAcceptance: `Aguardando aceitação`,
      awaitingPayment: `aguardando pagamento`,
      paymentReceived: `recebeu o pagamento`,
      awaitingResponse: `Aguardando Resposta`,
      award: `Premiação`,
      backupCodesLeft: `códigos de backup restantes`,
      balance: `Saldo`,
      basedLast90Day: `Baseado nos últimos 90 dias`,
      beforeActivatingTwoFactorAuthentication: `Antes de ativar o Two-factor authentication é preciso validar o seu telefone.`,
      beforeContinuingYouNeed: `Antes de continuar é preciso validar seu e-mail!`,
      billingCreditCard: `Cartão de Crédito de faturamento`,
      billingForms: `Formas de Faturamento`,
      billingInformation: `Informações de Faturamento`,
      byActivatingTheProgramSpecialistsWill: `Ao ativar o programa os especialistas poderão enviar novos relatórios!`,
      byPausingTheProgramExpertsWill: `Ao pausar o programa os especialistas não poderão mais enviar novos relatórios!`,
      bounty: `Financeira`,
      bountyAwarded: `Recompensa concedida`,
      bugBountyAndTheSecurityParadox: `Bug Bounty e o paradoxo da Segurança`,
      bugHuntIsTheFirstBrazilianBugBounty: `<b>BugHunt</b> é a primeira plataforma brasileira de Bug Bounty, e agora está em parceria com a <b>AME Digital</b> com propósito de democratizar o acesso a segurança da informação e com isso tornar a Internet um lugar mais seguro.`,
      bugHuntIsTheFirstBrazilianBugBountyAvenue: `<b>BugHunt</b> é a primeira plataforma brasileira de Bug Bounty, e agora está em parceria com a <b>Avenue</b> com propósito de democratizar o acesso a segurança da informação e com isso tornar a Internet um lugar mais seguro.`,
      ongoingProfileVerification: `Seu perfil está sendo verificado!`,
      cancel: `Cancelar`,
      cannotEnterEqualScopes: `Não é possível inserir escopos iguais`,
      cannotEnterSpecialCharacters: `Não é possível inserir caracteres especiais`,
      cautionNDA1: `Ao redigir o NDA da sua empresa certifique-se de que ele contemple os seguintes itens:`,
      cautionNDA2: `conter ao menos uma cláusula com a penalidade, em caso de descumprimento;`,
      cautionNDA3: `informar as partes que assumem aquele compromisso;`,
      cautionNDA4: `conter prazo de validade;`,
      cautionNDA5: `detalhar especificamente sobre o que se refere aquele NDA, pois informações genéricas e ambíguas descaracterizam o documento legal;`,
      cautionNDA6: `utilizar a tag `,
      cautionNDA7: `para se referir ao nome do especialista;`,
      cautionNDA8: `O modelo de NDA abaixo é ilustrativo. Certifique-se de informar corretamente os dados da sua empresa ao redigir o contrato de confidencialidade `,
      changeAccessPassword: `Alterar senha de acesso`,
      changePassword: `Alterar Senha`,
      changePermission: `Alterar permissão`,
      changedReportSeverity: `Severidade do relatório alterada`,
      changedReportStatus: `Situação do relatório alterada`,
      changedTheStatusFrom: `alterou a situação de {f} para {l}`,
      changedTheSituationTo: `alterou a situação para {0}`,
      changedTheTitleOf: `alterou o título do relatório de {f} para {l}`,
      changedTheTitleTo: `alterou o título do relatório para {0}`,
      changedTheVisibilityOf: `alterou a visibilidade de {f} para {l}`,
      changedTheVisibilityTo: `alterou a visibilidade para {0}`,
      checkOutAllFieldsHighlightedInRed: `Confira todos os campos destacados em vermelho!`,
      chooseANicknameYoursAlone: `Escolha um apelido para ser só seu!`,
      city: `Cidade`,
      clickHereToLearn: `Saiba mais.`,
      clearData: `Limpar dados`,
      clearlyDefine: `Defina claramente sua política do programa.`,
      close: `Encerrar`,
      closed: `Encerrado`,
      closedAgo: `Encerrado {0} dias`,
      closedIn: `Encerrado em`,
      closedReport: `Relatório fechado`,
      closedReports: `Relatórios encerrados`,
      closedTheReportAs: `fechou o relatório como`,
      reopenedTheReport: `reabriu o relatório`,
      code: `Código`,
      conclude: `Concluir`,
      connectionDenied: `Conexão negada`,
      connectionTime: `Tempo aproximado de conexão`,
      connectionRefusedUserDisabled: `Conexão recusada, usuário desativado!`,
      connectionsPerUser: `Conexões por usuário`,
      contacts: `Contatos`,
      company: `Empresa`,
      completed: `Concluídos`,
      confirm: `Confirmar!`,
      confirmAccountRemoval: `Confirmar Remoção de Conta`,
      confirmYourPassword: `Confirme sua senha!`,
      token2fa: `Informe o token da autenticação de 2 fatores`,
      confirmProgramChanges: `Descreva as alterações feitas no programa`,
      congratulationsYourUsernameIsNowVerified: `Parabéns, agora seu usuário é verificado.`,
      invalidEmail: `Email inválido, verifique e tente novamente.`,
      continueReport: `Continuar Relatório`,
      copiedId: `Id copiado`,
      copyLink: `Copiar link`,
      continue: `Continuar`,
      creatAccountInvit: `Criou a conta pelo convite`,
      createA: `Criar um`,
      created: `Criado!`,
      createMyAccount: `Criar minha conta!`,
      critical: `Crítico`,
      request_response: `Resposta`,
      request_closure: `Encerramento`,
      responseRequestReport: `solicitou uma resposta para este relatório.`,
      reportClosureRequest: `solicitou encerramento deste relatório.`,
      day: `dia`,
      days: `dias`,
      dateTime: `Data/Hora`,
      declined: `Recusado`,
      dataChanged: `Dados alterados!`,
      dataWillBeRemovedWithPhoneValidation: `Ao desativar o telefone, os dados do 2FA serão removidos automaticamente.`,
      date: `Data`,
      declineThisInvitation: `Recusar este Convite!`,
      delimitDomains: `Delimite domínios, subdomínios, aplicativos e muito mais`,
      delimitItems: `Delimite itens`,
      deleteUser: `Excluir usuário`,
      depositedAmount: `Total de Aportes`,
      delimitationOfDomainsSubdomains: `Delimitação de domínios, subdomínios, aplicativos e outros`,
      describeALittleMoreAboutTheImpact: `Descreva um pouco mais sobre o impacto!`,
      describeChangesMadeInProgram: `Este resumo ficará disponível para todos os especialistas que participam deste programa!`,
      describeClearlyHowTheVulnerabilityWorks: `Descreva claramente como funciona a vulnerabilidade.`,
      describeInDetailTheImpactOfThisRepor: `Descreva em detalhes o impacto deste relatório.`,
      describeThePerformedTests: `Descreva os testes realizados`,
      describeTheTitleOfTheReport: `Descreva o título do relatório`,
      describeTheScope: `Qual é a url da aplicação vulnerável?`,
      description: `Descrição`,
      descriptionSubmitReport: `##### 1. Resumo \n(adicionar resumo da vulnerabilidade)\n\n##### 2. Descrição\n(adicione mais detalhes sobre esta vulnerabilidade)\n 1. [adicionar etapa]\n\n##### 3. Passos para reproduzir\n(Adicione detalhes de como podemos reproduzir o problema)\n 1. [adicionar etapa]\n 2. [adicionar etapa]\n 3. [adicionar etapa]\n\n##### 4. Material de apoio / referências\n(por exemplo, capturas de tela, registros, etc.)\n 1. Liste qualquer material adicional\n `,
      descriptionCannotContainSpecialCharacters: `A descrição não pode conter caracteres especiais`,
      descriptionMustBeFromToCharacters: `A descrição deve ter de {f} a {l} caracteres.`,
      describeEditsMade: `Descreva as edições feitas.`,
      details: `Detalhes`,
      directoryName: `Nome do Diretório`,
      disable: `Desativar`,
      domain: `Domínio`,
      done: `Pago`,
      doNotUseSpecialCharactersAndMalicious: `Não use caracteres especiais e payloads maliciosos no título, impacto e resumo, esses itens devem ser anexados como .zip, .rar ou .7z no final do relatório.`,
      doNotUseSpecialCharacters: `Não envie payloads com possíveis códigos maliciosos, esses itens devem ser anexados como .zip, .rar ou .7z!`,
      dontForgetToSaveYourChanges: `Não esqueça de salvar as alterações!`,
      downloadTheReportPDF: `Download do Relatório em PDF`,
      doYouHaveOrganizationAndDidYou: `Gostaria de proteger sua empresa?`,
      doYouWantToRemoveThePhone: `Remover telefone`,
      doyoureallyWanttoDeleteVacancy: `Deseja mesmo excluir esta vaga ?`,
      doYouReallyWantToRemoveTwoFactor: `Remover o Two-factor authentication`,
      doYouReallyWantToRemoveThisAccount: `Deseja mesmo remover esta conta ?`,
      doYouReallyWantToRemoveThis: `Deseja mesmo remover esta {0} ?`,
      doYouWantToActivateTheProgram: `Deseja ativar o programa ?`,
      doYouWantToContinue: `Deseja continuar com os campos já preenchidos ?`,
      doYouWantDisableProgram: `Deseja desativar o programa ?`,
      doYouWantToPauseTheProgram: `Deseja pausar o programa ?`,
      doYouWantToAddVPNToYourNewProgram: `Você deseja adicionar VPN ao seu novo programa?`,
      editProgram: `Editar Programa`,
      editNda: `Editar NDA`,
      eligible: `Elegível`,
      efficiencyMetrics: `Métricas de eficiência`,
      emailAlreadyRegistered: `E-mail já esta cadastrado`,
      emailAlreadyValidatedNonExistent: `E-mail já validado ou expirado!`,
      emailConfirmation: `Confirmação de e-mail`,
      emailDoesNotAppearToBeValid: `O e-mail não parece ser válido`,
      emailSuccessfullyValidated: `Email validado com sucesso!`,
      enableTwoFactorAuthentication: `Habilitar autenticação de dois fatores`,
      end: `Final`,
      enterNewTags: `Digite novas tags separando as por virgula`,
      enterPasswordConfirmation: `Digite a confirmação da senha`,
      enterTheCode: `Digite o código`,
      enterTheCodeReceivedBySms: `Informe o código recebido por sms`,
      enterTheCompletePhone: `Informe o Telefone completo`,
      enterTheDescriptionOfTheOrganization: `Informe a descrição da organização`,
      enterTheEmail: `Informe o e-mail`,
      enterTheNameOfTheOrganization: `Informe o nome da organização`,
      enterThePassword: `Digite a senha`,
      enterTheUsername: `Informe o username`,
      enterTheScope: `Informe o escopo do programa!`,
      enterUserName: `Informe o nome do usuário`,
      enterYourEmail: `Informe seu e-mail`,
      enterYourFullName: `Escreva seu nome completo`,
      enterYourPayPalAccountEmail: `Informe o email da conta PayPal`,
      enterYourPrimaryEmailAddress: `Informe seu e-mail primário!`,
      enterYourUserPassword: `Informe sua senha de usuário`,
      enterYourRewardDetails: `Digite os detalhes da recompensa!`,
      evaluate_retest: `Avaliar reteste`,
      evaluatedRetest: `Reteste avaliado`,
      executiveSummary: `Sumário executivo da organização`,
      exit: `Sair`,
      expertSuccessfullCreated: `Especialista {0} criado com sucesso`,
      export: `Exportar`,
      exportLogs: `Exportar logs`,
      exportInCsv: `Exportar em .csv`,
      exportReports: `Exportar relatórios`,
      externalLinkNotice: `Aviso de link externo`,
      extract: `Extrato`,
      extractedBy: `Extraido por`,
      fillInTheDetailsBelowTo: `Preencha os detalhes abaixo para alterar sua senha.`,
      fillInAllFieldHighlightedInRed: `Preencha todos os campos destacados em vermelho!`,
      filterByTags: `Tags`,
      findSecurityJobsOnOurDashboard: `BugHunt conectando a comunidade com as melhores empresas.`,
      forgotYourPassword: `Esqueceu sua senha ?`,
      forSecurityWeRequestYourPassword: `Por segurança solicitamos sua senha para esta operação.`,
      forYourSecurityToPDF: `Para sua segurança é necessario adicionar uma senha ao PDF.`,
      fullName: `Nome completo`,
      generateNewCodes: `Gerar novos códigos`,
      getAccessToExclusiveRewards: `Tenha acesso à recompensas exclusivas deste programa!`,
      gift: `Brinde`,
      giftsAndAcknowledgments: `Brindes e Agradecimentos`,
      guests: `Convidados`,
      hackerControl: `Controle de Hackers`,
      haveYouRevised: `Revisou seu modelo? Então pronto!`,
      haveYouReviewedYourReportNow: `Revisou seu relatório? Então pronto, vamos enviá-lo para análise!`,
      here: `aqui`,
      hereYouCanSetUpYourAccount: `Aqui você pode configurar a sua conta para receber suas recompensas.`,
      high: `Alto`,
      historic: `Histórico`,
      features: `Funcionalidades`,
      iAlreadyHaveAnSccount: `Eu já tenho conta!`,
      iAlreadyRemembered: `Eu já lembrei!`,
      iAgreeWithThe: `Eu concordo com os `,
      ifYouDontReceiveIt: `Caso não receba, poderá tentar de novo em`,
      ifYouNeedToSubmitMoreComment: `Se precisar enviar mais, é só escrever outro comentário`,
      impact: `Impacto`,
      impactDescriptionCannotContainSpecialCharacters: `A descrição do impacto não pode conter caracteres especiais!`,
      inactivated: ` desativado`,
      inactiveUsers: `Usuários Inativos`,
      initProgramMessage: `Programa iniciado dia `,
      informBugHuntPassword: `Informe a senha da plataforma BugHunt para confirmar esta operação.`,
      informThePhoneWithAreaCode: `Informe o telefone com DDD`,
      informTheRecommendations: `Informe as recomensas que o especialista vai obter caso tenha sucesso!`,
      informTheScope: `Informe o escopo`,
      informTheScopeWhereTheThreatsAre: `Informe o escopo onde estão as ameaças`,
      selectTheScopeType: `Selecione o tipo do escopo inspecionado`,
      informTheImpact: `Informe o impacto`,
      informTheUser: `Informe o usuário`,
      informTheWebsite: `Informe o website`,
      interationIdealTime: `O tempo médio ideal para {interationType} é de `,
      interviewWithExpertIgorRincon: `Entrevista com especialista Igor Rincon`,
      invalidBackupCodeOrToken: `Código ou token de backup inválidos`,
      invalidCode: `Código inválido`,
      invalidCodeOrToken: `Código ou token inválido`,
      invalidDate: `Data inválida`,
      invalidData: `Dados inválidos`,
      invalidRegistrationData: `Dados para cadastro {0} inválidos!`,
      invalidEmailOrPassword: `E-mail ou senha inválida!`,
      invalidPassword: `Senha inválida`,
      invite: `Convidar`,
      invitationAccepted: `Convite aceito`,
      invitationDeclined: `Convite recusado`,
      invitationLimitManagersReached: `O limite de convites para gestores foi atingido.`,
      invitationProgramLimitReached: `O limite de convites do programa {program} foi atingido.`,
      invitationNotFoundOrExpired: `Convite não encontrado ou expirado!`,
      invitationsAccepted: `Convite aceito`,
      invitationsReceived: `Convites Recebidos!`,
      invitationRevoked: `Convite revogado`,
      invitationSent: `Convite enviado`,
      invoiceValue: `Total da nota fiscal`,
      NdaCreated: `NDA criado`,
      inProgress: `Em andamento`,
      inRelationToTheReport: `Referente ao relatório`,
      inSomeCasesTheEmailMayFallAsSpam: `Em alguns casos, o e-mail pode ser considerado spam.`,
      integration: `Integração`,
      integrations: `Integrações`,
      integrationsNotAvailable: `Integrações não disponíveis!`,
      inTheProgram: `no programa`,
      internal: `Interno`,
      invoices: `Faturamentos`,
      iPAdress: `Endereço IP`,
      issued: `Emitido`,
      itHappensInTheBestFamilies: `Acontece nas melhores famílias! Não se preocupe, basta colocar seu e-mail e enviaremos uma nova senha.`,
      itHappensInTheBestFamiliesDonotworry: `Acontece nas melhores famílias! Não se preocupe.`,
      itIsNotPossibleToEnterEqualRewards: `Não é possível inserir recompensas iguais!`,
      itIsNotPossibleToEnterMore: `Não é possível inserir mais que 30 tags!`,
      itIsNotPossibleToSubmitAnotherRetest: `Não foi possível submeter a avaliação do reteste!<br /> Aguarde o reteste do especialista.`,
      iWantToCreateAnAccount: `Quero criar uma conta!`,
      jobBoard: `Painel de Vagas`,
      jobDescription: `##### Sobre a Empresa \n Descreva aqui os detalhes sobre sua **empresa**\n \n ##### Sobre a Vaga\n Estamos procurando por um Profissional que terá como principais responsabilidades:\n - Responsabilidade 1.\n - Responsabilidade 2.\n - Responsabilidade 3.\n \n ##### Requisitos\n - **Requisito 1:** Acima de x anos de experiência.\n - **Requisito 2:** Acima de x anos de experiência.\n - **Requisito 3:** Acima de x anos de experiência.`,
      jobTitle: `Título da Vaga`,
      joinedThePlatform: `Entrou na plataforma`,
      lastReviewSubmittedAgo: `Última revisão enviada há {0}`,
      lastInvitations: `Últimos Convites Enviados`,
      last7daysOfAccess: `Últimos 7 dias de acesso`,
      latestReports: `Últimos relatórios`,
      letStartYourRegistrationAnd: `Vamos iniciar seu cadastro e em breve iremos entrar em contato com você para esclarecer qualquer dúvida e finalizar seu cadastro!`,
      letsCompleteYourRegistration: `Vamos concluir seu cadastro!`,
      letsCreateYourAccount: `Vamos criar sua conta!`,
      letsCreateYourPreRegistration: `Vamos criar seu pré-cadastro!`,
      lessThanMonthAgo: `há menos de um mês`,
      like: `do tipo`,
      limitScope: `Delimite o escopo e somente os acessos que serão recopensados!`,
      limitOutOfScope: `Quais aplicações não devem ser testadas?`,
      limitOfScopesPerProgramReached: `Limite de {0} escopos por programa atingido!`,
      linkToJob: `Link para vaga`,
      location: `Localidade`,
      longPeriodsImpactSpecialists: `Longos períodos de espera podem impactar o engajamento dos especialistas neste programa.`,
      low: `Baixo`,
      makePayment: `Realize um Pagamento`,
      makeAPayment: `Realizar um Pagamento`,
      makeSureYouHaveACompatibleAppLike: `Certifique-se de ter um aplicativo compatível como `,
      makeYourAccessEvenMoreSecure: `Torne seu acesso ainda mais seguro`,
      manageAccess: `Gerencie quem tem acesso ao programa.`,
      managementInvitations: `Gerenciamento de convites recebidos.`,
      manageVPNforUsers: `Gerencie a VPN dos usuários de cada programa`,
      manageYourPlanInformation: `Gerencie as informações do seu plano.`,
      manageYourProgressPlatform: `Gerencie seu progresso na plataforma BugHunt`,
      maximumLengthIsCharacters: `Tamanho máximo é de {0} caracteres`,
      maximumFilesPerComment: `O máximo é de 10 arquivos por comentário`,
      medianTimeToResolution: `Tempo médio para resolução`,
      medianTimeToFirstResponse: `Tempo médio até a primeira resposta`,
      medium: `Médio`,
      metricDoesNotHaveEnoughDataYet: `Não existem dados suficientes para cálculo desta métrica`,
      metricsDoesNotHaveEnoughDataYet: `Ainda não existem dados suficientes para cálculo das métricas`,
      message: `Mensagem`,
      messagePostedAgo: `mensagem publicada há {time}`,
      messagePublishedDay: `mensagem publicada dia {day}`,
      missedResponseTargetsReportsSent: `Respostas enviadas acima do tempo esperado`,
      missedResponseTargetsResolved: `Resolução de relatórios acima do tempo esperado`,
      missedResponseTargetsBounty: `Pagamentos efetuados acima do tempo esperado`,
      monthlyFee: `Valor da mensalidade`,
      monthlyPayment: `Mensalidade`,
      moreOptions: `Mais opções`,
      money: `Dinheiro`,
      myPlan: `Meu Plano`,
      myBusiness: `Minha empresa`,
      nameChanged: `Nome alterado!`,
      nameOfAccountHolder: `Nome do responsável pela conta!`,
      nameIsNotValid: `O nome não é válido`,
      navigation: `Navegação`,
      needChangeDescription: `Utilize o molde para fazer uma descrição detalhada.`,
      ndaVerificationRequired: `Seu perfil está apto a participar do processo de verificação!`,
      ndaChange: `Mudança de NDA`,
      next: `Próxima`,
      new: `Novo`,
      newComment: `Novo comentário`,
      newUsers: `Novos Usuários`,
      newPassword: `Nova Senha`,
      newPasswordAndConfirmation: `Nova senha e confirmação não são iguais!`,
      newReport: `Novo relatório`,
      none: `Nenhum`,
      noActivePrograms: `Nenhum programa ativo`,
      noInvitationAvailable: `Nenhum convite disponível`,
      noNotificationsAvailable: `Nenhuma notificação disponível`,
      noPaymentsFound: `Nenhum pagamento encontrado`,
      noProgramAvailable: `Nenhum programa disponível`,
      noReportsFound: `Nenhum relatório encontrado`,
      noScopeAvailable: `Nenhum escopo disponível!`,
      noSuggestionsAvailable: `Nenhuma sugestão disponível`,
      noteValue: `Valor da Nota`,
      notAvailableForThisPlan: `Não disponível para este Plano!`,
      notAuthorized: `Não autorizado!`,
      shutdownRequested: `O encerramento deste relatório já foi solicitado!`,
      replyNotificationTitle: `Solicitação de resposta`,
      closingRequestTitle: `Solicitação de encerramento`,
      replyRequestMessage: `Já foi solicitada uma resposta para este relatório!`,
      notificationResponseReport: `Atenção! Uma resposta foi solicitada para este relatório.`,
      shutdownNotificationMessage: `Atenção! Foi solicitado o fechamento deste relatório.`,
      notificationSeeRequest: `Ver solicitação`,
      requestSent: `Solicitação enviada com sucesso!`,
      reportResponseNotification: `Atenção! Foi solicitado uma resposta deste relatório.`,
      notEligible: `Não elegível`,
      noExpertsFound: `Nenhum especialista encontrado`,
      notificationUpdatedNDA: `O contrato de confidencialidade do programa {programName} foi atualizado! Para continuar participando deste programa é necesário você revise e aceite o NDA.`,
      noUserAvailable: `Nenhum usuário disponível`,
      noVpnAccessLogFound: `Nenhum log de acesso a vpn encontrado!`,
      nowTellUsLittle: `Agora nos fale um pouco da política do programa!`,
      nowTellUsALittleBitAboutTheThreat: `Agora conte-nos um pouco sobre a ameaça!`,
      ofReward: `de recompensa`,
      oneDayAgo: `há um dia`,
      oldPassword: `Senha atual`,
      outstandingPayments: `Pagamentos pendentes`,
      open: `Aberto`,
      opssMatiDidntApproveYourData: `Opss, a Mati não aprovou seus dados.`,
      others: `Outros`,
      other: `Outros`,
      otherTypes: `Outros tipos`,
      outOfScope: `fora de escopo`,
      outOfScopeTitle: `Fora de Escopo`,
      participating: `Participando`,
      password: `Senha`,
      passwordChanged: `Senha alterada!`,
      passwordConfirmation: `Confirmação da Nova Senha`,
      passwordsMustMatch: `As senhas devem ser iguais`,
      expirePasswordConfig: `As senhas dos usuários serão válidas por`,
      passwordUpdateRequired: `Atenção! Altere sua senha para evitar o bloqueio desta conta!`,
      remainingDaysToUpdateYourPassword: `dias restantes para atualizar sua senha.`,
      passwordExpiredNotificationTitle: `Atenção! Sua senha expirou!`,
      passwordExpiredInstructions: `Sua conta será bloqueada temporariamente. Mantenha sua senha atualizada e siga as instruções enviadas ao e-mail associado a esta conta.`,
      enablePasswordExpiration: `Habilitar expiração de senha`,
      configSuccess: `Configuração atualizada com sucesso!`,
      pasteTheLinkIntoTheBodyOfTheDescription: `Cole o link no corpo da descrição.`,
      pause: `Pausar`,
      paused: `Pausado`,
      pauseProgram: `Pausar programa`,
      paymentFor: `Pagamento para`,
      paymentHistory: `Histórico de Pagamentos`,
      paymentSummary: `Resumo de pagamentos`,
      paymentRequested: `Pagamento solicitado`,
      pending: `Pendente`,
      pendingSubscription: `Pendente de Assinatura`,
      permission: `Permissão`,
      permissions: `Permissões`,
      pleaseMakeSureThatThisEmail: `Por favor, certifique-se que este email esteja correto e que pertença a você.`,
      phoneNumber: `Número de telefone`,
      phoneSuccessfullyRemoved: `Telefone removido com sucesso!`,
      phoneValidation: `Validação de telefone`,
      platform: `Plataforma`,
      points: `Pontos`,
      pointsIn: `pontos em`,
      possibleDup: `Relatório possivelmente duplicado - O escopo {scope} já recebeu relatórios referentes a {CWE}`,
      possibleSpam: `Possível SPAM - Verificamos que o especialista {expert} enviou vários relatórios referentes a {CWE} no escopo {scope}.`,
      postedComment: `postou um comentário `,
      postedImage: `Postou uma imagem`,
      previous: `Anterior`,
      primaryEmail: `e-mail principal`,
      primaryEmailReceiving: `E-Mail primário para recebimento de informações`,
      privacy: `Privacidade`,
      privacyPolicy: `Política de Privacidade`,
      private: `Privado`,
      privateProgram: `programa privado`,
      profileInformation: `Informações do Perfil`,
      profileVerifiedReleased: `Verificação de perfil solicitada`,
      program: `Programa`,
      programs: `Programas`,
      programDetails: `Detalhes do programa`,
      program_management: `Gerenciamento de programas`,
      programLifeCycle: `Ciclo de vida do programa`,
      programsLimitReached: `Limite de programas {0} atingido!`,
      programsIhaveAlreadyContributed: `Programas que já contribuí`,
      programPolicy: `Política do Programa`,
      programPolicyMustBeInformed: `A política do programa deve ser informada`,
      programPolicyMustBeBetweenAndCharacters: `A política do programa deve ter entre {f} e {l} caracteres`,
      programRanking: `Ranking do programa`,
      programNdaMustBeBetweenAndCharacters: `O conteúdo do NDA deve ter entre {f} e {l} caracteres`,
      programsPublishedOnTheWeb: `Programas publicados na web podem ser acessados por especialistas não cadastrados na plataforma.`,
      programSuccessfullyChanged: `Programa alterado com sucesso`,
      programType: `Tipo de Programa`,
      programWith: `Programa com {0}`,
      proofOfConceptLinks: `Links para prova de conceito são geralmente benignos, mas muitas vezes podem ser acompanhados por consequências não intencionais.`,
      setProgramNda: `Você deseja adicionar o contrato de confidencialidade ao seu novo programa?`,
      public: `Público`,
      publicInformation: `Dados Públicos`,
      publicOrPrivateProgram: `Programa público ou privado`,
      publicProgram: `programa público`,
      publish: `Publicar`,
      published: `Publicado`,
      publishedDaysAgo: `Publicado há {0}`,
      publishProgramOnTheWeb: `Publicar programa na Web ?`,
      publishToTheWeb: `Publicar na Web `,
      questionsAboutUrl: `Dúvidas sobre {0}`,
      rankingDoesNotHaveEnoughDataYet: `O Ranking ainda não tem dados suficientes`,
      rankingPosition: `{0}° no Ranking`,
      received: `Recebido`,
      receiveAdvertising: `Receive advertising emails`,
      receiveEmails: `Recebimento de E-Mails`,
      receiveAdvertisingEmails: `Receber e-mails de propaganda`,
      receiveNotificationsAboutNewReports: `Receba notificações sobre novos relatórios diretamente em suas plataformas de gestão`,
      referenceDate: `Data de referência`,
      refuseRetest: `Recusar reteste`,
      refusedRetest: `recusou o reteste`,
      registerBelowTheTags: `Gerenciamento de tags`,
      registeredUsers: `Usuários Registrados`,
      registeredVacancies: `Vagas`,
      registration: `Cadastro`,
      removeAccount: `Remover Conta`,
      remove: `Remover`,
      removeFromWhitelist: `Remover da Whitelist`,
      removeFromBlacklist: `Remover da Blacklist`,
      removed: `Removido`,
      reportAllPossibleThreatData: `Informe todos os dados possíveis das ameaças`,
      report: `Relatório`,
      reportID: `ID do relatório`,
      reportCreatedSuccessfully: `Relatório criado com sucesso`,
      reportEvaluation: `Avaliação do relatório`,
      reportPayments: `Pagamentos de relatórios`,
      reports: `Relatórios`,
      reportSent: `Relatório enviado`,
      reportsSent: `Relatórios enviados`,
      reportTitle: `Título do relatório`,
      reportedThatTheVulnerabilityIsFixed: `informou que a vulnerabilidade está corrigida`,
      reportedThatTheVulnerabilityIsNotPatched: `informou que a vulnerabilidade não está corrigida`,
      reportedVulnerabilities: `Vulnerabilidades reportadas`,
      approvedVulnerabilities: `Vulnerabilidades aprovadas`,
      vulnerabilities: `Vulnerabilidades`,
      overviewSubTitle: `Uma visão gerencial da sua conta só para você`,
      summaryCard: `Resumo dos relatórios`,
      requestedPayment: `solicitou um pagamento`,
      requestedPaymentOf: `solicitou o pagamento de`,
      requestedANewTestOfTheReport: `solicitou um novo teste do relatório`,
      reset: `Limpar`,
      rewardValue: `Valor da recompensa`,
      whatIsAnNda: `O que é um NDA?`,
      whatIsAnNda2: `NDA é uma sigla em inglês para Non-Disclosure-Agreements, ou simplesmente acordo de sigilo de informações.`,
      whatIsAnNda3: `Ele tem a intenção de proteger segredos industriais, comerciais, ou ainda qualquer informação que não pode ser divulgada e deve manter-se em sigilo entre aqueles que têm acesso a ela.`,
      whatIsaVPNAndHow: `O que é uma VPN e como ele pode ajudar em seus programas ?`,
      reportTags: `Adicionar tag(s) no relatório`,
      requestNewPassword: `Solicitar nova senha!`,
      requestRetest: `Solicitar Reteste`,
      requestSubscription: `Solicitar Assinatura`,
      requiredField: `Campo obrigatório`,
      retestRequested: `Reteste Solicitado`,
      requestedRetestPayment: `solicitou o pagamento do reteste`,
      retestId: `Reteste id`,
      retestSent: `Reteste enviado`,
      return: `Voltar`,
      resolved: `Resolvidos`,
      revoke: `Revogar`,
      revokeWebAccessToTheProgram: `Revogar acesso Web ao programa ?`,
      revoked: `Revogado`,
      revokeAccess: `Revogar Acesso`,
      rewardAmount: `Valor da Recompensa`,
      reward: `Recompensa`,
      rewardDetails: `Detalhes da recompensa`,
      rewards: `Recompensas`,
      rewardsReceived: `Recompensas Recebidas`,
      rewardsWithFinancialValues: `Recompensas com valores financeiros`,
      save: `Salvar`,
      saveEditions: `Salvar alterações`,
      saveNda: `Salvar contrato de confidencialidade`,
      saveInformation: `Salvar`,
      scopePerProgram: `Escopo por programa`,
      scopesPerProgram: `Escopos por programa`,
      search: `Pesquisar`,
      seconds: `segundos`,
      select: `Selecione`,
      selectAddAccount: `Selecione "Adicionar conta" ou "+" e digitalize o código QR abaixo`,
      selectAScoreForTheReport: `Selecione uma pontuação para o relatório`,
      selectFile: `Selecione o arquivo!`,
      selectLanguage: `Selecione um idioma`,
      selectScopeType: `Selecione o tipo de escopo`,
      selectTheThreat: `Selecione a ameaça!`,
      selectTheProgramScope: `Selecione o escopo do programa!`,
      selectTheProgramImpact: `Selecione o impacto do programa!`,
      selectTheReport: `Selecione o relatório`,
      selectTheScope: `Selecione o escopo`,
      selectTheCWE: `Selecione o CWE`,
      selectTheVulnerability: `Selecione a vulnerabilidade`,
      securityAnalyst: `Ex. Analista de segurança`,
      send: `Enviar`,
      sentTheRetest: `Enviou o reteste`,
      sendMessage: `Enviar Mensagem`,
      sent: `Enviou`,
      sentTo: `Enviado`,
      sentTheReport: `enviou o relatório`,
      settings: `Configurações`,
      severityReports: `Relatórios por severidade`,
      severity: `Severidade`,
      currentValue: `Valor atual`,
      finalValue: `Valor final`,
      showingResultsOfTotal: `Mostrando {results} de {totalResults} resultados.`,
      since: `Desde {0}`,
      sinceLastMonth: `desde mês passado`,
      situation: `Situação`,
      scope: `Escopo`,
      scopeLimitExceeded: `O limite de escopos do programa foi excedido.`,
      scopeListOfTheProgram: `Lista de escopo do programa!`,
      score: `Pontuação`,
      scoreHistory: `Histórico de pontuação`,
      scopeType: `Tipo do Escopo`,
      share: `Compartilhar`,
      smsCode: `Código SMS`,
      smsCodeSent: `Código SMS enviado`,
      specialist: `Especialista`,
      specialistNotFound: `Especialista não encontrado!`,
      standard: `Padrão`,
      standoutCreate: `Destaque-se! Crie um título motivador.`,
      start: `Início`,
      pauseMessage: `Não foi possível executar a ação, uma vez que a campanha ainda não teve início.`,
      startAnAccountForOrganization: `Criar uma conta para organização`,
      startWithRewards: `Começe pelas recomensas que possuem valor financeiro`,
      statistics: `Estatísticas`,
      stateCity: `Estado`,
      status: `Status`,
      statusChanged: `Status alterado!`,
      storeYourBackupCodes: `Armazene seus códigos de backup`,
      subdomain: `Subdomínio`,
      submittedDays: `Enviado tem {0} dias`,
      submitComment: `Enviar Comentário`,
      submitForReview: `Enviar para Análise`,
      rewardNotice: `Lembrete: Esse programa oferece recompensa em dobro`,
      submitReport: `Submeter Relatório`,
      submit_retest: `Submeter reteste`,
      successfullyGeneratedKeys: `Keys geradas com sucesso!`,
      suggestions: `Sugestões`,
      suggestedReward: `Recompensa sugerida`,
      summary: `Resumo`,
      superSimpleItDoesntEvenTake: `É simples, não leva nem 1 minuto. Basta informar os dados abaixo e pronto! Sua conta está criada.`,
      superSimpleItDoesntEvenTakeCompany: `É simples, não leva nem 1 minuto. Basta informar os dados comuns da organização e pronto! Sua conta será enviada para análise.`,
      support: `Suporte`,
      sureAddExpertBlacklist: `Tem certeza de que deseja adicionar este especialista a blacklist ?`,
      sureAddExpertWhiteList: `Tem certeza de que deseja adicionar este especialista a Whitelist ?`,
      sureRemoveExpertBlacklist: `Tem certeza de que deseja retirar este especialista da Blacklist ?`,
      sureRemoveExpertWhitelist: `Tem certeza de que deseja remover este especialista da Whitelist ?`,
      successfullyCreatedProgram: `Programa criado com sucesso`,
      successfullyCreated: `criada com sucesso`,
      acceptedNda: `NDA aceito com sucesso!`,
      openReports: `Relatórios abertos`,
      openYourApp: `Abra seu aplicativo.`,
      or: `ou`,
      organizationName: `Nome da organização`,
      overallRanking: `Ranking Geral`,
      paidRetest: `Se o&nbsp;<b>reteste for aprovado</b>, você receberá mais&nbsp;<b>{0}</b>&nbsp;do valor do bounty.`,
      tagsAreUsedToHelpIdentifyReports: `As Tags são utilizadas para auxiliar na identificação dos relatórios.`,
      tagsForReports: `Tags para relatórios`,
      takeAction: `Realizar Ação`,
      takeTheOpportunityToAcquireMoreComplete: `Aproveite a oportunidade para adquirir planos mais completos para sua empresa`,
      talkDirectlyToOurOperators: `Fale diretamente com nossos operadores.`,
      target: `Tempo esperado: {0}`,
      telephone: `Telefone`,
      testDescriptionsMustBetweenCharacters: `A descrição dos testes deve ter entre {f} e {l} caracteres`,
      tests: `Testes`,
      terms: `Termos`,
      termsAPolicy: `Termos e Política`,
      termsOfUse: `Termos de Uso`,
      thanksForRegistering: `Obrigado por se cadastrar!`,
      thankByEmail: `Agradecimento por e-mail`,
      theActionsTakenOnTheReportCannotBe: `As ações feitas no relatório não poderão ser removidas`,
      theCommentNeedsToBeInformed: `O comentário precisa ser informado!`,
      theDescriptionTestsMustBeInformed: `A descrição dos testes precisa ser informada`,
      theDescriptionOfTheProgramMustBeInformed: `A descrição do programa deve ser informado`,
      theImpactDescriptionMustBeInformed: `A descrição do impacto precisa ser informada`,
      theImpactDescriptionMustBetweenCharacters: `A descrição do impacto deve ter entre {f} e {l} caracteres`,
      theIsNotValid: `O {0} não válido`,
      theFileIsNotValid: `O arquivo não é válido!`,
      theNameMustBeFromToCharacters: `O nome deve ter de {f} a {l} caracteres`,
      theNameOfThePersonResponsibleIsMandatory: `O nome do responsável é obrigatório.`,
      theNameOfTheProgramMustBInformed: `O nome do programa deve ser informado`,
      theNameWillBeAssignedToYourProgramsURL: `O nome será atribuido a URL do seu programa.`,
      thenUseYourEmail: `Então utilize seu e-mail, sua senha e acesse nossa plataforma. Caso tenha esquecido da senha ou seu usuário, utilize a opção de recuperação abaixo!`,
      thePhoneIsNotValid: `O telefone não é valido.`,
      theProgramDescriptionMustBeBetweenAndCharacters: `A descrição do programa deve ter entre {f} e {l} caracteres!`,
      theProgramNameMustBeBetweenAndCharacters: `O nome do programa deve ter entre {f} e {l} caracteres`,
      thereIsAlreadyAprogram: `Já existe um programa cadastrado com esse nome!`,
      thereIsAlreadyProgramSlug: `Já existe um programa cadastrado com essa slug!`,
      theReportNeedsToBeInformed: `O relatório precisa ser informado`,
      theRetestMustBeSentWithinDays: `O reteste deve ser enviado em até {0} dias`,
      theRetestWasNotSubmitted: `O reteste não foi submetido!`,
      theRetestHaAlreadyAccepted: `O reteste já foi aceito!`,
      theseSettingsDirectlyImpactTheAccessOfExperts: `Essas configurações impactam diretamente no acesso dos especialistas.`,
      theScopeAddressMustBeInformed: `O endereço do escopo deve ser informado`,
      theThreatDescriptionMustBeInformed: `A descrição da ameaça deve ser informada!`,
      theThreatDescriptionMustBetweenCharacters: `A descrição da ameaça deve ter entre {f} e {l} caracteres`,
      theTitleMustBeInformed: `O título precisa ser informado`,
      theTitleMustBeBetweenCharacters: `O título deve ter entre {f} e {l} caracteres`,
      theWebhookIsNotValid: `O webhook não é válido!`,
      theWebsiteMustBeFromToCharacters: `O website deve ter de {f} a {l} caracteres`,
      thisChangeIsIrreversible: `Essa alteração é irreversível.`,
      thisInformationCanAppear: `Essas informações podem aparecer no perfil público da empresa, ao lado dos seus comentários e em qualquer um dos seus relatórios.`,
      thisIsAnInternalSurvey: `Esta é uma pesquisa interna, os especialistas não terão acesso aos dados deste questionário.`,
      thisServiceCreatesAVPNResponsible: `Este serviço cria uma VPN, responsável por conectar e monitorar o tráfego de dados dos testes do especialista aos seus escopos, e com isso maior rastreabilidade e segurança.`,
      thisWeek: `nesta semana`,
      threats: `Ameaças`,
      time: `Tempo`,
      timeToFirstResponse: `a primeira resposta`,
      timeToBounty: `pagar a recompensa`,
      timeToResolution: `encerrar o relatório`,
      title: `Título`,
      to: `para`,
      toAcceptThisInvitation: `Para aceitar este convite é necessário se verificar na Meta<b>Map</b> , após a verificação, aguarda alguns minutos e atualize a página.`,
      tokenIsInvalid: `O token é inválido ou já foi utilizado.`,
      toAddMorePrograms: `Para acrescentar mais programas confira nossos planos clicando`,
      toAddMoreScopesToThe: `Para acrescentar mais escopos no programa confira nossos planos clicando`,
      toAddMoreUsersCheck: `Para acrescentar mais usuários, confira nossos planos clicando`,
      toAddTheseIntegrations: `Para acrescentar estas integrações confira nossos planos clicando`,
      toAddThisFeatureCheck: `Para acrescentar este recurso, confira nossos planos clicando`,
      toChangeYourPlanContactSupport: `Para alterar seu plano, entre em contato com o suporte.`,
      toCheck: `Verificar`,
      toConfirmWeNeedYourPassword: `Para confirmar precisamos de sua senha`,
      toConfirmYourRegistrationOn: `Para confirmar seu cadastro em nossa plataforma é necessário clicar no botão abaixo.`,
      today: `Hoje`,
      toDoThisYouNeedToEnterYourAppCode: `Digite o código do aplicativo de autenticação ou um token de backup (cada token é válido uma única vez).`,
      topReportedCWE: `CWE mais relatado`,
      totalConnectedHours: `Total de horas conectadas`,
      totalEvents: `Total de eventos`,
      totalMonthlyFees: `Total das mensalidades`,
      totalReports: `Total de relatórios`,
      totalReceived: `Total Recebido`,
      totalRewards: `Total de recompensas`,
      toTheProgram: `ao programa`,
      totalSpent: `Total Pago`,
      totalSum: `Somatório Total`,
      trackYourOpenReports: `Acompanhe seus relatórios abertos`,
      twoFactorAuthentication: `Autenticação de dois fatores`,
      type: `Tipo`,
      typeOfContract: `Tipo de contrato`,
      typeOrPasteOneOfYourBackupTokens: `Digite ou cole um de seus tokens de backup, lembrando que cada token só pode ser usado uma vez!`,
      typeProgramLimitExceeded: `O limite de programas do tipo {programType} foi excedido`,
      unableToCompleteThisRequest: `Não foi possível concluir esta solicitação.`,
      unableToSubmittedTheReport: `Não foi possível submeter este relatório. Certifique-se que todos os campos foram preenchidos corretamente.`,
      undefinedRanking: `Ranking indefinido`,
      uninformed: `Não informado`,
      unshowPassword: `Esconder senha`,
      update: `Atualizar`,
      updates: `Atualizações ({numberOfUpdates})`,
      updated: `Atualizado`,
      uploadFiles: `Enviar arquivos`,
      upTo: `Até`,
      urlIsNotValid: `A url não é válida`,
      useBackupCode: `Usar código de backup ?`,
      user: `Usuário`,
      userBlockedForOverTrying: `Usuário bloqueado por excesso de tentativas, tente novamente mais tarde.`,
      userByCompany: `Usuário por empresa`,
      userDisconnected: `Usuário desconectado!`,
      userLimitReached: `Limite de usuários atingido!`,
      userLoggedIn: `Usuário conectado!`,
      usersByCompany: `Usuários por empresa`,
      userDoesNotHavPermissionToPerform: `Usuário não tem permissão para executar esta ação`,
      usernameHasInvalidCharacters: `O nome de usuário possui caracteres inválidos`,
      usernameIsNotAvailable: `O username não está disponível!`,
      usernameMustBeFromCharacters: `O nome de usuário deve ter de {f} a {l} caracteres.`,
      users: `Usuários`,
      userEmail: `Usuário ou e-mail`,
      usersOnTheBlacklist: `Usuários na Blacklist não terão acesso a este programa!`,
      userRemoved: `Usuário removido`,
      useYourAuthenticationAppToEnterTheCode: `Use seu aplicativo de autenticação para inserir o código`,
      validatePhone: `Validar telefone`,
      validatedPhone: `Telefone validado`,
      value: `Valor`,
      verified: `Verificado`,
      verifieds: `Verificados`,
      vpnIP: `IP da VPN`,
      waitingConfirmation: `Aguardando confirmação`,
      wantSaveChangesProgram: `Você deseja mesmo salvar as alterações feitas neste programa?`,
      waysExplore: `Formas de Explorar`,
      weLeaveThisPanel: `Deixamos esse painel para você publicar suas vagas para nossos especialistas`,
      whatIsBugBounty: `O que é Bug Bounty`,
      whatIsYourAction: `Qual sua ação?`,
      whatIsNdaHeader: `Fique atento!`,
      whatPrograms: `Quais programas?`,
      whatTypeOfVulnerability: `Qual o tipo de vulnerabilidade reportada`,
      whoDoYouWantInvite: `Quem deseja convidar?`,
      whiteMessage: `Escreva uma mensagem...`,
      weakPasswordContain: `Senha fraca! ela deve cont`,
      websiteInvitation: `Convite do site`,
      weSendAToast: `Enviamos um brinde`,
      weAreUnderMaintenance: `Estamos em manutenção! Retorne em breve!`,
      weTemporarilyStoreYourReport: `Armazenamos temporariamente os dados de seu relatório para o programa`,
      weWillContactYouShortly: `Em breve entraremos em contato para confirmar seus dados.`,
      wikiSubTitle: `Nós ajudamos como podemos e como não podemos.`,
      withoutWebAccessTheProgram: `Sem acesso Web o programa ficará disponível apenas para usuários da plataforma.`,
      workModel: `Modelo de trabalho`,
      workSchedule: `Horário de Trabalho`,
      yesIWantToRegister: `Sim, quero me cadastrar`,
      yes: `Sim`,
      no: `Não`,
      youAcceptedThisInvitation: `Você aceitou esse convite`,
      youAreAboutToVisitLink: `Você está prestes a visitar um link externo.`,
      youAreAllowedToViewTheReports: `Tem permissão para ver os relatórios.`,
      youCanUseOneOfTheseBackupCodes: `Você pode usar um desses códigos de backup para fazer o login, caso perca o acesso ao seu smartphone. Lembre-se de que cada código só pode ser usado uma vez.`,
      yourCurrentPlanIsThe: `Seu plano atual é`,
      youDoNotHaveAnyTagRegistered: `Você não possui nenhuma Tag cadastrada, para adicionar acesse o menu <a href="/account?tags">Minha Conta/Tags</a>`,
      youDontHaveAnyAcceptedInvitations: `Ainda não possui convites aceitos!`,
      youDontHaveAnyInvitationsWaiting: `Ainda não possui convites aguardando respostas!`,
      youDontHaveAnyNDAs: `Você ainda não possui um programa com contrato de confidencialidade!`,
      youDontHaveAnyNDAsHacker: `Você ainda não concordou com nenhum contrato de confidencialidade!`,
      youDontHaveAnyProgramsInThisCategoryYet: `Você ainda não possui programas nessa categoria`,
      youDontHaveSubmittedReports: `Ainda não possui relatórios aprovados!`,
      youHaveBeenInvitedToSend: `Você foi convidado para enviar relatórios à esse programa`,
      youHavePermissionToViewAndEditReports: `Tem permissão para ver e editar os relatórios.`,
      youMustAgreeToThe: `Você precisa concordar com os`,
      youMustAgreeToTheTermsOfUse: `Você precisa concordar com o termo de uso.`,
      youMustAgreeToTheTermsOfUseAndCodeOfConduct: `Você precisa concordar com o termo de uso e código de conduta.`,
      yourAccessPassword: `Sua senha de acesso!`,
      yourAccesEmail: `Seu e-mail de acesso ao {0}`,
      youReachedLimit: `Você atingiu o limite diário de envio de relatórios!`,
      yourEmail: `Seu email`,
      yourFullName: `Seu nome completo!`,
      yourNameMustBeBetweenAndCharacters: `Seu nome deve ter entre {f} e {l} caracteres!`,
      yourOrganizationNameIsRequired: `O nome da sua organização é obrigatório`,
      YourOrganizationTradeName: `Nome fantasia da sua organização!`,
      yourPassword: `Sua senha`,
      yourPhoneToGetInTouch: `Telefone para entrarmos em contato!`,
      yourProfileIsNowAbleTo: `Seu perfil está apto a participar do processo de verificação!`,
      ndaVerificationRequired1: `Você foi convidado para participar do programa `,
      ndaVerificationRequired2: `A verificação do seu perfil é necessária para aceitar este convite!`,
      ndaVerificationRequired3: `Confira a sua lista de notificações e prossiga com o processo de verificação.`,
      noJobsFound: `Nenhuma vaga encontrada`,
      registrationDone: `Cadastro efetuado!`,
      reportPaymentVerificationRequired1: `O pagamento de uma recompensa para o relatório `,
      reportPaymentVerificationRequired2: `foi solicitado!`,
      reportSummaryNotValid: `O resumo do relatório não é válido!`,
      reportContentIsNotValid: `O conteúdo do relatório não é válido!`,
      reportVulnerabilitIsNotValid: `O impacto da vulnerabilidade não é válido!`,
      reportCriticalityIsNotValid: `A criticidade da vulnerabilidade não é válida`,
      reportCantAcceptEspecialCaracter: `( Não é possível inserir caracteres especiais. )`,
      reportScopeIsNotValid: `O identificador do escopo do relatório não é válido!`,
      reportIdentifierIsNotValid: `O identificador do programa não é válido!`,
      reportVulnerabilityIdentifierIsNotValid: `O identificador da vulnerabilidade não é válido!`,
      ndaVerificationRequired6: `Complete a validação do seu perfil para que possamos prosseguir com o pagamento da recompensa!`,
      reportTitleIsNotValid: `O título do relatório não é válido!`,
      showPassword: `Mostrar senha`,
      companyNdaVerificationRequired: `Você precisa criar um NDA para o seu programa antes de convidar especialistas!`,
      taxesNotIncluded: `Tributos não inclusos`,
      youAcceptedParticipateInThisProgram: `Você aceitou participar deste programa.`,
      youCanCalculate: `Você pode calcular a severidade através da calculadora abaixo`,
      youShouldConsiderUsingSeparate: `Você deve considerar o uso de um navegador ou máquina virtual separada antes de continuar.`,
      yourSecurityPlatformAndBugReward: `A sua plataforma de Bug Bounty`,
      youWereInvitedPartOf: `Você foi convidado a fazer parte do time {0}, Basta informar os dados da sua conta.`,
      youWillBeRedirectedIn: ` Você será redirecionado em`,
      youWillReceiveReportsFromCommunity: `Você irá receber relatórios dos especialistas em segurança da nossa comunidade, sem nenhum custo adicional, minimizando os riscos de seus dados serem expostos ou vulnerabilidades exploradas.`,
      invitationsSummary: `Resumo dos convites`,
      doubleReward: `Recompensa em dobro`,
      boostedProgram: `Programa impulsionado!`,
      doubleCampaignNotificationStarted: `Campanha de bonificação iniciada`,
      doubleCampaignNotificationClosed: `Campanha de bonificação encerrada`,
      doubleCampaignNotificationPaused: `Campanha de bonificação pausada`,
      doubleCampaignNotificationResumed: `Campanha de bonificação retomada`,
      campSubTitle: `Gerencie suas campanhas! Acompanhe todos os detalhes.`,
      historicCampaign: `Histórico`,
      historicDoubleBounty: `Bounty em dobro`,
      historicDoubleScore: `Score em dobro`,
      inText: `De`,
      until: `Até`,
      finished: `Finalizado`,
      in_progress: `Em progresso`,
      situationCancel: `Cancelado`,
      createdTh: `Criado em`,
      periodTh: `Período`,
      rewardsTh: `Recompensas`,
      situationsTh: `Situações`,
      historicApproved: `Aprovados`,
      historicCancel: `Cancelados`,
      historicPaused: `Pausados`,
      historicFinished: `Finalizados`,
      notificationAttention: `Atenção!`,
      notificationYourCampaignHasStarted: `Sua campanha foi iniciada!`,
      notificationThisCampaign: `Esta campanha`,
      notificationHasClosed: `foi encerrada`,
      notificationHasBeenPaused: `foi pausada`,
      keepAnEyeOutNotification: `fique de olho`,
      notificationWillLetYouKnowWhenToStartAgain: `avisaremos quando iniciar novamente.`,
      notificationThisCampaignIsLiveAgain: `Esta campanha está no ar novamente!`,
      finalDate: `Fim`,
      remain: `Restam`,
      campaignStarted: `A campanha de recompensas dobradas foi iniciada!`,
      campaignClosed: `A campanha de recompensas dobradas foi finalizada!`,
      campaignPause: `A campanha de recompensas dobradas foi pausada!`,
      campaignReactivated: `A campanha de recompensas dobradas foi reativada!`,
      campaignFinalDays: `para o fim da campanha`,
      campaignInitialDays: `para o inicío da campanha`,
      dayCampaign: `dia`,
      daysCampaign: `dias`,
      daysGeneric: `dia(s)`,
      btnRegister: `Cadastrar`,
      btnLabel: `Selecione a data`,
      doubleBounties: `Dobrar bounties`,
      doubleScore: `Dobrar pontuação`,
      activeDoubleCampaign: `Impulsionar programa`,
      selectAPeriod: `Selecione um período:`,
      monthlyRanking: `Ranking Mensal`,
      generalRanking: `Ranking Geral`,
      expertRating: `Confira a classificação dos especialistas BugHunt`,
      bountyOffer: `Você está oferencendo: Bounties em dobro`,
      bountyScore: `Você está oferencendo: Pontuação em dobro`,
      bountyAndScoreOffer: `você está oferecendo: Bouties e Pontuação em dobro`,
      closeCampaign: `Encerrar Campanha de bonificação`,
      pauseCampaign: `Pausar Campanha de bonificação`,
      reactivateCampaign: `Reativar Campanha de bonificação`,
      boostCampaign: `Impulsionar programa`,
      doubleCheckCampaign: `Estou ciente das alterações feitas neste programa.`,
      successfullyCreatedCampaign: `Solicitação realizada com sucesso, por favor aguarde análise de aprovação da campanha!`,
      vpnMessage: `Não há uma vpn habilitada neste programa.`,
      campaignPaused: `Campanha pausada com sucesso!`,
      doubleCampaignClosed: `Campanha encerrada com sucesso!`,
      doubleCampaignResumed: `Campanha retomada com sucesso!`,
      registeredProgramWarning: `Este programa já possui uma campanha aprovada ou encerrada a menos de 15 dias.`,
      warningBoutiesOrScore: `A campanha deve oferecer bounties ou pontuação em dobro!`,
      invalidDateMessage: `Data inválida, por favor verifique se o campo foi preenchido corretamente!`,
      administrator: `Administrador`,
      viewer: `Visualizador`,
      analyst: `Analista`,
      needsInformation: `necessita de informações`,
      retest_done: `Reteste concluído`,
      pending_retest: `Reteste Pendente`,
      notImpact: `Severidade não informada`,
      lowImpact: `Severidade baixa`,
      mediumImpact: `Severidade média`,
      highImpact: `Severidade alta`,
      criticalImpact: `Severidade crítica`,
      approved: `Aprovado`,
      informative: `Informativo`,
      duplicated: `Duplicado`,
      not_applicable: `Não aplicável`,
      spam: `Spam`,
      comment: `Postar um comentário`,
      change_situation: `Alterar situação`,
      update_severity: `Alterar severidade`,
      request_update: `Solicitar atualização`,
      retest: `Solicitar reteste`,
      pay_bounty: `Pagar uma recompensa`,
      close_report: `Fechar o relatório`,
      reopen_report: `Reabrir o relatório`,
      needs_information: `Aguardando informações`,
      move_to_locker: `Mover para o cofre de relatórios`,
      move_out_of_locker: `Remover do cofre de relatórios`,
      under_review: `Em revisão`,
      triaged: `Triado`,
      plan_trial: `Plano Trial`,
      plan_bronze: `Plano Bronze`,
      plan_silver: `Plano Prata`,
      plan_gold: `Plano Ouro`,
      trial: `Trial`,
      bronze: `Bronze`,
      silver: `Prata`,
      gold: `Ouro`,
      fulltime: `Full-time`,
      parttime: `Part-time`,
      clt: `CLT`,
      pj: `PJ`,
      autonomous: `Autônomo`,
      cltflex: `CLT-Flex`,
      cooperative: `Cooperativo`,
      internship: `Estágio`,
      hybrid: `Híbrido`,
      office: `Presencial`,
      remote: `Remoto`,
      web: `Aplicação Web`,
      api: `API`,
      mobileapplication: `Aplicação Mobile`,
      mobileapplicationandroid: `Aplicação Mobile Android`,
      mobileapplicationios: `Aplicação Mobile IOS`,
      ip: `Endereço de IP`,
      january: `Janeiro`,
      february: `Fevereiro`,
      march: `Março`,
      april: `Abril`,
      may: `Maio`,
      june: `Junho`,
      july: `Julho`,
      august: `Agosto`,
      september: `Setembro`,
      october: `Outubro`,
      november: `Novembro`,
      december: `Dezembro`,
      seeOriginalText: `Texto original.`,
      waiting_for_information: `Aguardando informações`,
      severity_updated: `Severidade atualizada`,
      retest_requested: `Solicitação de resteste`,
      bounty_paid: `Recompensa paga`,
      close_as_approved: `Fechar como aprovado`,
      close_as_informative: `Fechar como informativo`,
      close_as_spam: `Fechar como spam`,
      close_as_duplicated: `Fechar como duplicado`,
      close_as_not_applicable: `Fechar como não aplicável`,
      select_option: `Selecione uma opção`,
      deleteMessageAlert: `Tem certeza de que deseja excluir esta mensagem?`,
      automaticMessage: `Ao selecionar a opção, a resposta automática será registrada como uma primeira interação no relatório.`,
      defaultMessageCenterMenu: `Central de Mensagens Padrão`,
      registerNotFound: `Nenhum registro foi encontrado.`,
      registeredMessageTitle: `Mensagens Cadastradas`,
      customSettingsTitle: `Configurações Personalizadas`,
      customSettingsSubtitle: `Configuração de mensagens para respostas padronizadas`,
      addMessageButton: `Adicionar mensagem`,
      existingMessageAlert: `É possível cadastrar apenas uma mensagem por tipo de mensagem. Atualmente, todas as mensagens já estão registradas!`,
      editMessage: `Editar Mensagem`,
      registerMessage: `Cadastrar Mensagem`,
      placeholderTitleMessage: `Titulo da mensagem`,
      placeholderTextAreaMessage: `Adicione uma descrição...`,
      labelAutomatic: `Automático`,
      alertMessageSuccess: `Mensagem cadastrada com sucesso!`,
      alertMessageUpdate: `Mensagem atualizada com sucesso!`,
      swalTokenRemoved: `O token foi excluído com sucesso.`,
      deleteTokenCompany: `Excluir token`,
      placeholderTokenCompany: `Digite um token`,
      errorToken: `O token deve conter no mínimo 20 caracteres e no máximo 500 caracteres!`,
      emailNotification: `A notificação por e-mail foi ativada com sucesso!`,
      enableEmailNotification: `Ativar o recebimento de atualizações do programa por meio de endereço eletrónico.`,
      emailNotificationDisabled: `A notificação enviada por e-mail foi desativada!`,
      china: `China`,
      india: `Índia`,
      estadosUnidos: `Estados Unidos`,
      indonesia: `Indonésia`,
      paquistao: `Paquistão`,
      brasil: `Brasil`,
      nigeria: `Nigéria`,
      bangladesh: `Bangladesh`,
      russia: `Rússia`,
      mexico: `México`,
      japao: `Japão`,
      etiopia: `Etiópia`,
      filipinas: `Filipinas`,
      egito: `Egito`,
      vietna: `Vietnã`,
      repuplicaDemocraticaDoCongo: `República Democrática do Congo`,
      turquia: `Turquia`,
      ira: `Irã`,
      alemanha: `Alemanha`,
      tailandia: `Tailândia`,
      reinoUnido: `Reino Unido`,
      franca: `França`,
      italia: `Itália`,
      tanzania: `Tanzânia`,
      africaDoSul: `África do Sul`,
      mianmar: `Mianmar (Birmânia)`,
      coreiaDoSul: `Coreia do Sul`,
      colombia: `Colômbia`,
      quenia: `Quênia`,
      espanha: `Espanha`,
      ucrania: `Ucrânia`,
      uganda: `Uganda`,
      sudao: `Sudão`,
      angertina: `Argentina`,
      angelia: `Argélia`,
      iraque: `Iraque`,
      polonia: `Polônia`,
      canada: `Canadá`,
      uzbequistao: `Uzbequistão`,
      arabiaSaudita: `Arábia Saudita`,
      br: `Português`,
      en: `Inglês`,
      es: `Espanhol`,
      fr: `Francês`,
      it: `Italiano`,
      ru: `Russo`,
      de: `Alemão`,
      jp: `Japonês`,
      cn: `Chinês`,
      pl: `Polonês`,
      ua: `Ucraniano`,
      sd: `Árabe`,
      kr: `Coreano`,
      in: `Hindi`,
      id: `Indonésio`,
      pk: `Urdu`,
      bd: `Bengali`,
      et: `Amárico`,
      ph: `Filipino (Tagalo)`,
      vn: `Vietnamita`,
      tr: `Turco`,
      ir: `Persa`,
      th: `Tailandês`,
      za: `Africâner`,
      mm: `Birmanês`,
      ug: `Suaíli`,
      uz: `Uzbeque`,
      sa: `Árabe`,
      additionalMoreLanguages: `Adicionar mais idioma`,
      country: `País`,
      language: `Idioma`,
      clearText: `Utilizar a mensagem padrão`,
      selectCountry: `Selecione um país`,
      basic: `Básico`,
      proficiency: `Proficiência`,
      conversational: `Conversacional`,
      fluent: `Fluente`,
      native: `Nativo ou bilingue`,
      AreYouSureYouWantToCompleteTheRequest: `Tem certeza de que deseja concluir esta solicitação?`,
      managers: `Gestores`,
      manageProgram: `Defina quem irá gerenciar o seu novo programa.`,
      config: `Configurações`,
      programSettings: `Configurações do programa`,
      programEditAlert: `Atenção! Não é possível editar programas inativos ou aguardando aprovação.`,
      changeSettings: `Alterar configurações`,
      managersWithAccesToTheProgram: `Gestores com acesso ao programa`,
      freeAccess: `Acesso liberado`,
      pendingInviteAlert: `Atenção! Já existe um convite pendente associado a este endereço de email.`,
      USDT: `Dólar`,
      BRL: `Real`,
      selectCurrencyType: `Selecione o tipo de moeda`,
      passwordSuccess: `Senha cadastrada com sucesso!`,
      isNan: `O valor informado deve ser numérico.`,
      filterScope: `Filtrar por escopo`,
      selectScope: `Selecione uma opção de escopo`,
      filterScopeTitle: `Filtro por escopo`,
      scopeSelected: `Escopo selecionado`,
      summaryFinancialCard: `Resumo financeiro`,
      summaryTotalCard: `Aportes`,
      summaryTotalPgCard: `Total pago`,
      projectedValueLabel: `Quantidade de meses a serem projetados`,
      totalMonthlyPayments: `Mensalidades`,
      totalManagedServices: `Serviços gerenciados`,
      totalRewardsPaid: `Recompensas pagas`,
      monthAndyear: `Mês/Ano`,
      contribution: `Aporte`,
      managed: `Gerenciado`,
      costProjection: `Projeção de custos`,
      contributionBalance: `Saldo do aporte`,
      detailsNF: `Detalhes NF`,
      total: `Total`,
      expenseNotification: `Fique no controle! Configure notificações para quando você atingir "70%" do seu orçamento de gasto.`,
      errorValueBudget: `Informe o limite do budget`,
      errorBudgetNotification: `Informe o percentual desejado`,
      labelInvalidValue: `Valor inválido. Por favor, insira um valor entre 0 e 100`,
      labelCurrencyValue: `Valor inválido: Não é possível cadastrar valores negativos.`,
      titleBudgetActive: `Limitar custos mensais de recompensas`,
      budgetLimitProgram: `O budget limite para este programa é`,
      errorBudgetLimit: `Informe o limite do budget`,
      invalidValueBudget: `Valor inválido: Não é possível cadastrar valores negativos.`,
      notificationBudget: `Notificar quando atingir o valor de`,
      percentageBudget: `Informe o percentual desejado`,
      percentageErrorBudget: `Valor inválido. Por favor, insira um valor entre 0 e 100`,
      pauseProgramBudget: `Pausar o programa antes de atingir o total do budget?`,
      percentagePauseBudget: `Porcentagem de pausa (0-99%)`,
      createCredentialTooltip: `Definir credencial`,
      confirmBtn: `Confirmar`,
      swalCredential: `Credencial salva com sucesso.`,
      labelCredentialForTest: `As credenciais para testar o sistema e o escopo do programa`,
      labelCredentialForTestContinued: `estão listadas abaixo`,
      labelCredentialIndividual: `Uso individual. Não compartilhe para garantir a sua segurança.`,
      labelCredentialShared: `Uso compartilhado. Todos os especialistas possuem o mesmo acesso.`,
      credentials: `Credenciais`,
      confirmPassword: `Confirmar Senha`,
      confirmPasswordToViewCredential: `Confirme sua senha de acesso à plataforma para visualizar as `,
      confirmPasswordToViewCredentialContinued: `credenciais disponíveis`,
      hello: `Olá`,
      doYouHaveCredentials: `você tem credenciais para usar nos sistemas e escopos que serão testados`,
      manageYourCredentials: `Gerencie suas credenciais genéricas cadastradas para facilitar o acesso dos especialistas que realizarão testes em seus sistemas`,
      manageYourCredentialsTooltip: `Gerencie suas credenciais`,
      credentialPublica: `Credencial Genérica`,
      credentialPrivate: `Credencial Exclusiva`,
      credentialPublicaDescription: `As credenciais genéricas cadastradas serão enviadas para todos os especialistas que estão participando do programa, com o objetivo de serem utilizadas para realizar os testes de segurança.`,
      credentialSentToSpecialist: `As credenciais exclusivas cadastradas serão enviadas apenas para o especilista de destino`,
      credentialSentToSpecialistContinued: `com o objetivo de serem utilizadas para realizar os testes de segurança.`,
      request_review: `Solicitar revisão da triagem`,
      request_review_report: `solicitou revisão da triagem`,
      reviewRequestedNotification: `Solicitação de revisão`,
      availableCredential: `Credencial disponível`,
      allActionsAllowed: `Tem permissão para gerenciar todos os programas e usuários.`,
      owner: `Owner`,
      AreYouSureYouWantToUpdateTheUserRole: `Você deseja aplicar as alterações nas permissões deste usuário?`,
      manageCredentials: `Gerencie as credencias cadastradas.`,
      setPublicCredential: `Gerencie suas credenciais públicas`,
      programSpellers: `Especialistas do programa`,
      viewCredentials: `Visualizar Credenciais`,
      informPassword: `Informe sua senha`,
      credentialDeleted: `Credencial deletada com sucesso!`,
      genericError: `Algo deu errado. Estamos resolvendo isso agora. Por favor, tente novamente mais tarde.`,
      delete: `Excluir`,
      toClose: `Fechar`,
      labelDeleteCredential: `Tem certeza de que deseja excluir esta credencial?`,
      credentialsTooltip: `Credenciais Disponíveis`,
      setPasswordExpiration: `Definir expiração de senha`,
      authenticationViaEmail: `Two-factor authentication (2FA) via Email`,
      accessValidation: `Validação de acesso`,
      invalidCodeError: `O código informado não é válido!`,
      confirmPasswordLabel: `Confirme a sua senha de acesso à plataforma para finalizar a ação desejada.`,
      emailAuthenticationInformation: `Aumente a segurança de todas as contas, habilitando a autenticação por e-mail, protegendo as informações dos usuários contra acessos indevidos.`,
      alertTwoFactory: `<div class="container-two-factory"><p class="two-factory-descrition">Para enviar um relatório neste programa, é necessário habilitar a autenticação de dois fatores. Sua segurança é nossa prioridade e essa camada extra de proteção é essencial para garantir a integridade de sua conta. <span>Siga as etapas de configuração para ativar a autenticação de 2 fatores agora.</span></p></div>`,
      twoFactoryNewUsersContinuation: `poderão interagir com os relatórios.`,
      restriction: `Restrição`,
      warningTwoFactorAuthentication: `Atenção! Configuração de autenticação de 2 fatores necessária.`,
      labelFeatureTwoFactorAuthentication: `Somente gestores com Two-factor Authentication podem interagir com relatórios de programas.`,
      labelFeatureTwoFactorAuthenticationHacker: `Apenas os especialistas com Two-Factor Authentication podem enviar novos relatórios para o programa.`,
      configureNow: `Configurar agora`,
      enable2fa: `ativada a obrigatoriedade de configurar a autenticação de duplo fator`,
      disable2faSwal: `desativada a obrigatoriedade de configurar a autenticação de duplo fator`,
      itWas: `Foi`,
      toProgram: `para o programa,`,
      translateText: `Traduzir texto`,
      openingDate: `Data de abertura:`,
      classification: `Classificação`,
      confidential: `Confidencial`,
      selectProgram: `Selecionar programa`,
      swalSuccess: `Alteração realizada com sucesso.`,
      dateDownloadReport: `de download`,
      setHallOfFame: `Você deseja ativar o hall da fama em seu novo programa?`,
      addHackerToHof: `Você deseja adicionar o especialista ao Hall da fama?`,
      hallOfFame: `Hall da Fama`,
      hallOfFameDoesNotHaveEnoughDataYet: `O Hall da Fama ainda não possui especialistas!`,
      hallOfFameThanksDescription: `gostaria de agradecer aos seguintes pesquisadores por reportarem falhas de segurança significativas.`,
      addedAt: `Adicionado em`,
      programByObjective: `Programa por objetivo`,
      programObjective: `Objetivo do Programa`,
      nowTellUsLittleObjective: `Agora nos fale um pouco do objetivo do programa!`,
      aGoodObjectiveAvoids: `Um objetivo bem definido evita problemas, caso tenha algum problema nos consulte.`,
      targetProgram: `Objetivo`,
      include: `Incluir`,
      infoTarget: `Atenção! É necessário informar pelo menos um objetivo.`,
      aboutTarget: `Sobre o objetivo do programa!`,
      setProgramReward: `Defina a recompensa do programa.`,
      maxProgram: `Atenção! É permitido no máximo 10 objetivos por programa.`,
      requiredProgram: `Por favor, cadastre um objetivo para o programa.`,
      targetRequired: `Por favor, preencha o objetivo do programa.`,
      requiredBounty: `Por favor, insira um valor.`,
      idConfirmation: `Falta pouco! Confirme sua identidade para prosseguir com o processo de troca de senha.`,
      titleTarget: `Título do objetivo`,
      targetPlaceholder: `Título do objetivo do programa!`,
      titleTargetError: `Por favor, preencha o título objetivo do programa.`,
      updateTarget: `Objetivo atualizado com sucesso!`,
      swalTarget: `Por favor, verifique se os campos estão preenchidos corretamente.`,
      areYouSureYouWantToDeleteThisTarget: `Tem certeza de que deseja remover este objetivo ?`,
      removeTargetProgram: `Objetivo removido com sucesso!`,
      selectAnObjectiveForTheReport: `Qual o tipo de objetivo reportado`,
      informTheTarget: `Informe o objetivo`,
      selectTheProgramTarget: `Selecione um objetivo do programa!`,
      achievedTheObjective: `O objetivo do programa foi atingido?`,
      reachedIn: `Objetivo atingido em`,
      noObjectivesAvailable: `Nenhum objetivo disponível!`,
      removeIn: `removido`,
      achievedIn: `alcançado pelo`,
      pauseProgramSwal: `Programa pausado por falta de objetivo(s) ativo.`,
      cBoostedProgram: `Programa impulsionado`,
      signedAgreements: `Contratos assinados`,
      ccpProgObj: `Programa por Objetivo`,
      ccpProgObjDesc: `Criar um programa com objetivos pré-definidos, onde você escolhe quem pode participar e enviar relatórios!`,
      objectiveProgram: `programa por objetivo`,
      publicPrograms: `programas públicos`,
      privatePrograms: `programas privados`,
      objectivePrograms: `programas por objetivo`,
      alertMessageRemoved: `Mensagem removida com sucesso!`,
      scopeNotFound: `Escopo não encontrado.`,
      usernameOrEmail: `Username ou E-Mail`,
      aboutTheProgramPolicyHacker: `As regras contidas na política do programa devem ser respeitadas!`,
      jiraIssueType: `Qual será o tipo da atividade que será cadastrada no jira?`,
      conceded: `concedeu`,
      toTheSpecialist: `ao especialista`,
      getToKnow: `Conheça`,
      solutions: `Soluções`,
      contact: `Contato`,
      ourBlog: `Nosso Blog`,
      doubts: `Dúvidas?`,
      inTheMedia: `Na mídia`,
      talkToUs: `Fale conosco`,
      understandHowItWorks: `Entenda como funciona!`,
      managedPrograms: `Programas gerenciados`,
      vdpPrograms: `Programas VDP`,
      howItWorks: `Como funciona!`,
      ranking: `Ranking`,
      url: `URL`,
      multipliedScore: `Bônus! score multiplicado`,
      codeOfConduct: `Código de Conduta`,
      and: `e`,
      reportConfidential: `Classificação do documento: Confidencial`,
      securitySystem: `Sistema de Segurança`,
      emailAlreadyRegisteredInOurDatabase: `Email já cadastrado em nossa base de dados`,
      theTokenMustBeEntered: `O token precisa ser informado`,
      actionAlreadyReported: `Ação já reportada!`,
      statusPauseProgram: `O programa foi pausado`,
      statusStartProgram: `O programa foi reativado`,
      by: `por`,
      inShort: `em`,
      invalidName: `O nome inserido não é válido!`,
      includeMoreDetails: `Acrescentar mais detalhes...`,
      maxTech: `O máximo permitido é de 10 tecnologias por escopo.`,
      maxLine: `Por favor, limite a mensagem a no máximo 10 quebras de linha.`,
      includeInfoScope: `Insira observações sobre o escopo... `,
      includeTech: `Insira as tecnologias`,
      editScope: `Editar escopo`,
      scopeDetails: `Detalhes do escopo`,
      minMaxScopeCaracter: `O escopo deve ter entre 3 e 40 caracteres`,
      characters: `Caracteres`,
      menuLocker: `Cofre de Relatórios`,
      useCodeEmail: `Use o código recebido por email`,
      authenticationByEmail: `Autenticação via email`,
      accessCredentials: `Credenciais de Acesso`,
      safePassword: `Configurar senha do cofre de relatórios`,
      beforeActivating2faAuthentication: `Antes de configurar a senha do cofre é preciso ativar o seu Two-factor authentication.`,
      beforeActivating2faEmailAuthentication: `Antes de configurar a senha do cofre é preciso ativar Two-factor authentication (2FA) via Email.`,
      beforeActivatingSafePassword: `Antes de ativar o cofre é preciso definir a senha do cofre.`,
      cardHeaderSafe: `Cofre de relatórios`,
      tryAgain: `Por favor, revise os dados fornecidos e tente novamente.`,
      btnNext: `Próximo`,
      btnPrev: `Anterior`,
      enableReportVault: `Ativar Cofre de Relatórios`,
      reportVaultSuccessfullyEnabled: `Cofre de relatórios habilitado com sucesso!`,
      reportMovedToVault: `enviou o relatório para o cofre`,
      reportMovedOutOfVault: `retirou o relatório do cofre`,
      userBlockedUntil: `Usuário bloqueado até`,
      toThe: `às`,
      warningLockerActive: `Após a ativação do 'Cofre de relatórios', não é possível desabilitar essa funcionalidade.`,
      reportMovedToTheLocker: `O relatório foi movido para o cofre de relatórios.`,
      reportMovedToTheLockerQuestion: `Você deseja ser redirecionado para o cofre?`,
      warningAccessCredentials: `Por favor, revise os dados fornecidos e tente novamente.`,
      receiveCode: `Receber código`,
      accessLocker: `Acessar o cofre!`,
      requestNewCodeEmail: `Você poderá solicitar um novo código em`,
      resetPasswordLocker: `Redefinir senha do cofre`,
      confirmPasswordLocker: `Confirmar senha`,
      errorCaptcha: `O CAPTCHA não foi autorizado. Por favor, tente novamente.`,
      rewardsReceivedInReais: `Recompensas recebidas em reais`,
      rewardsReceivedInDollars: `Recompensas recebidas em dólar`,
      onboardingMenuAccount: `Clique no menu "Minha conta".`,
      makeYourAccessReportEvenMoreSecure: `Torne seu acesso aos relatórios ainda mais seguro`,
      toAccessTheVaultEnableTheFollowingSteps: `Para acessar o cofre, habilite as etapas seguintes.`,
      registerPhoneOnboarding: `Realize o cadastrado do telefone.`,
      activeTwoFactorAuthentication: `Habilite o Two-factor authentication.`,
      registerPasswordLocker: `Cadastre uma senha para o cofre.`,
      methodAppToken: `Proteja o acesso ao cofre recebendo o código via app.`,
      methodAppEmail: `Proteja o acesso ao cofre recebendo o código por e-mail.`,
      methodAppSms: `Proteja o acesso ao cofre recebendo o código por SMS.`,
      sendToken: `Token enviado!`,
      waitToRequestNewToken: `Por favor, aguarde 5 minutos antes de solicitar um novo token.`,
      phoneNotRegistered: `Atenção! Telefone não cadastrado.`,
      useCodeSms: `Use o código recebido por SMS`,
      titleEmailTwoAuthentication: ` Two-factor authentication (2FA) via Email`,
      updateConfigLocker: `As configurações do cofre foram atualizadas!`,
      swalRegisterPassword: `Senha cadastrada com sucesso!`,
      lockerConfig: `Configuração`,
      lockerAccess: `Logs`,
      receiveCodeBySms: `Receber código por SMS`,
      lockerPassword: `Senha do cofre`,
      selectUser: `Selecionar usuário`,
      selectEvent: `Selecionar evento`,
      USER_LOGIN: `Login realizado`,
      REPORT_MOVED_TO_LOCKER: `Relatório movido para o cofre`,
      REPORT_MOVED_OUT_OF_LOCKER: `Relatório removido do cofre`,
      REPORT_ACCESS: `Relatório acessado`,
      USER_LOGIN_FAILED: `Falha ao tentar acessar o cofre`,
      manyRequestTitle: `Muitas requisições`,
      manyRequestText: `Você está enviando muitas requisições em um curto período de tempo. Por favor, tente novamente mais tarde.`,
      undestand: `Entendido`,
      noRegisterAvailable: `Nenhum registro disponível`,
      event: `Evento`,
      swalActiveLocker: `O Cofre de Relatórios foi ativado com sucesso!`,
      swalInactiveLocker: `O cofre de relatórios foi desativado!`,
      enterTheCode2fa: `Insira seu código 2FA`,
      labelCodeBackup2faLocker: `Após realizar o download do código de backup, não será possível gerar novos códigos. Certifique-se de armazená-lo em um local seguro, pois ele poderá ser utilizado para desativar a autenticação em dois fatores (2FA) caso seja necessário.`,
      swalWarningDateText: `Data inválida!`,
      swalWarningDateTitle: `A data inicial deve ser anterior à data final. Por favor, verifique e tente novamente.`,
      archiveProgram: `Arquivar programa`,
      archive: `Arquivado`,
      titleProgram: `Título do programa`,
      statusProgramArchived: `O programa foi arquivado`,
      waitRequestTitle: `Por favor, aguarde...`,
      waitRequestText: `Estamos removendo todos os seus relatórios do cofre de relatórios.`,
      tooltipLocker: `O Cofre de Relatórios permite armazenar relatórios críticos ou antigos com segurança, acessíveis apenas via autenticação extra.`,
      alertInactiveLocker: `Atenção: Ao desativar o cofre de relatórios, todos os relatórios armazenados serão permanentemente removidos, retornando à lista de relatórios sem autenticação, como era antes da ativação do cofre.`,
      moveReportToLocker: `Para mover o relatório para o cofre, certifique-se de que ele está ativo.`,
      strongPassword: `Insira uma senha forte`,
      disableSms: `Desativar código via SMS`,
      disableEmail: `Desativar código via Email`,
      disable2fa: `Desativar autenticação de dois fatores`,
      disableLocker: `Desativar cofre de relatórios`,
      activeLocker: `Ativar cofre de relatórios`,
      archivedProgramTooltip: `Ao arquivar, este programa ficará inativo e indisponível para os participantes`,
      pauseProgramTooltip: `Ao pausar, o programa será desativado temporariamente para todos os participantes.`,
      LOCKER_ACTIVATED: `Ativou cofre de relatórios`,
      LOCKER_DEACTIVATED: `Desativou cofre de relatórios`,
      expiredLockerSwal: `Sua sessão foi expirada. Por favor, faça login novamente para continuar.`,
      countrySelectorLabel: `Código do país`,
      phoneNumberLabel: `Número de telefone`,
      examplePhone: `Exemplo:`,
      lockSafe: `Bloquear cofre`,
      remainingTimeTooltip: `Tempo restante para bloquear o cofre`,
      statusProgramUnarchived: `O programa foi desarquivado`,
      budgetActive: `Ativar custos de recompensas mensais`,
      alertArchivedProgram: `Ao arquivar o programa, ele será pausado, movido para submenu "Inativos" e os participantes perderão o acesso, não podendo mais enviar relatórios.`,
      alertReactivateProgram: `Ao desarquivar o programa, ele será movido para a lista de programas ativos, mas permanecerá pausado. Os participantes ainda não poderão enviar relatórios até que o programa seja retomado.`,
      privateComment: `Este comentário será usado para se comunicar com o especialista.`,
      internalComment: `Este comentário será visível apenas para funcionários.`,
      authenticationRedirect: `Redirecionamento de Autenticação`,
      redirectPleaseWait: `Redirecionando, por favor, aguarde.`,
      maximumFilesAuthSSO: `Envie apenas um arquivo.`,
      replaceFileAuthSSO: `Se precisar substituir o arquivo, clique no ícone "X" e faça o upload do novo.`,
      allowedFilesAuthSSO: `Arquivo permitido: .xml`,
      swalTotalDays: `Atenção! O número de dias deve ser superior a zero para prosseguir.`,
      editDomain: `Editar domínio`,
      removeDomain: `Deletar`,
      activeSSO: `Ativar SSO`,
      inactiveSSO: `Desativar SSO`,
      tooltipSSO: `Acesse várias plataformas com um único login, de forma prática.`,
      updateConfigSSO: `As configurações do SSO foram atualizadas!`,
      registerDomainSSO: `Domínio cadastrado com suceso!`,
      domainSuccessfullyRemoved: `Domínio removido com sucesso!`,
      swalYouSure: `Tem certeza?`,
      swalWarningInfo: `Você não poderá reverter esta ação!`,
      swalActionCuccessfully: `Sua ação foi realizada com sucesso.`,
      swalActionPerformed: `Ação realizada!`,
      swalTitleCopy: `Conteúdo copiado!`,
      swalTextCopy: `O texto foi copiado para a área de transferência.`,
      domainInvalid: `Por favor, insira um domínio válido, ex: empresa.com`,
      domainIsSame: `Este domínio é inválido ou já foi registrado. Por favor, escolha outro.`,
      tooltipDescriptionSSSO: `Com o SSO (Login Único), você pode acessar a plataforma de maneira prática, utilizando apenas uma conta.`,
      tooltipActiveSSO: `Antes de prosseguir, certifique-se de que a configuração necessária foi concluída no seu IdP e que pelo menos um domínio esteja cadastrado e validado.`,
      registerSucess: `Cadastrado com sucesso!`,
      userPoolId: `Utilize o User Pool ID ao configurar o seu provedor de identidade (IdP).`,
      userPoolDomain: `Utilize o User Pool Domain ao configurar o seu provedor de identidade (IdP).`,
      placeholderUrlDomain: `Insira o domínio (ex.: empresa.com)`,
      labelURLXml: `Insira a URL do XML ou faça o upload do seu arquivo XML.`,
      manageDomains: `Gerenciar Domínios`,
      configSSO: `Configuração SSO`,
      placeholderUrlXml: `https://seuservico.com/configuracoes/idp-metadata.xml`,
      attachXMLFile: `Anexar Arquivo XML`,
      xmlError: `O arquivo XML fornecido não pôde ser processado. Verifique se está bem formatado e atende aos padrões esperados.`,
      swalActionNotPermitted: `Ação não permitida`,
      swalOneRegisteredDomain: `Você precisa ter pelo menos um domínio registrado e validado.`,
      accountNotFound: `E-mail não encontrado. Por favor, entre em contato com o administrador do seu IDP`,
      enabledPasswordExpiration: `Habilitar expiração de senha`,
      edit: `Editar`,
      titleRegisterAccountSSO: `É simples, não leva nem 1 minuto. Confirme alguns dados e estará concluído em instantes.`,
      yourName: `Nome`,
      updateXML: `Alterar o arquivo XML de integração`,
      getDownloadXML: `Obter arquivo de configuração em XML`,
      downloadOrUpdatedXML: `Baixar ou modificar o arquivo XML de integração do IDP`,
      titleAttachXML: `Informe a URL ou anexe o arquivo XML de configuração do IdP`,
      alterXML: `Alterar`,
      paramsConfigIDP: `Parâmetros de Configuração do IDP`,
      enterWithSSO: `Entrar com SSO`,
      enterWithoutSSO: `Entrar sem SSO`,
      titleUrlXML: `Forneça a URL do arquivo XML do IdP (Provedor de Identidade).`,
      copyContent: `Copiar`,
      validateDomain: `Validar domínio`,
      validated: `Validado`,
      validatedDomain: `Valide seu domínio dentro de 72 horas para o mesmo não ser removido.`,
      titleValidateDomain: `Valide seu domínio!`,
      swalInfoValidateDomain: `Para concluir o processo de validação, registre a seguinte variável como um registro TXT no DNS do domínio `,
      swalAfterValidateDomain: ` após realizar o registro, clique em Validar para prosseguir.`,
      swalValidateSuccess: `Domínio validado com sucesso!`,
      swalErrorValidateDomain: `Erro ao validar o domínio`,
      swalTryAgain: `verifique e tente novamente.`,
      swalTitleError: `Erro inesperado!`,
      swalTextError: `Ocorreu um erro ao abrir a validação do domínio. Tente novamente mais tarde.`,
      btnValidated: `Validar`,
      loading: `Carregando...`,
      sizeXml: `O tamanho máximo permitido para o arquivo é 100KB.`,
      pendingPayments: `Pagamentos pendentes`,
      completedPayments: `Pagamentos efetuados`,
      attributeEmailSSO: `Solicitamos que entre em contato com o administrador do IdP para verificar e assegurar que o atributo "email" esteja configurado corretamente.`,
      emailContentSSO: `Certifique-se de mapear o campo "email" com o valor "email" em seu IDP.`,
      emailExSSO: `Exemplo: email: email`,
      textErrorDomain: `Todos os domínios dos usuários owners devem ser registrados e validados antes de prosseguir`,
      swalAlertOwner: `Não é possível excluir um domínio vinculado ao owner.`,
      textWarningDisableSSO: `Ao desativar o SSO, todos os usuários com exceção dos usuários "Owner", serão desativados da plataforma. A reativação desses usuários deverá ser feita por meio do menu "Usuários". Além disso, o usuário "Owner" receberá um email para a redefinição de senha.`,
      requiredRegisterDomain: `É necessário registrar e validar o domínio do usuário.`,
      authenticationControls: `Controles de autenticação`,
      codeByEmail: `Código por email`,
      enterTheCodeBackup: `Insira seu código de backup`,
      titleModalBackup2fa: `Token de backup`,
      awaitNewToken: `Aguarde! Em breve, você poderá solicitar um novo token.`,
      monthYear: `Mes/Ano`,
      provision: `Aporte`,
      monthly: `Mensalidade`,
      management: `Gerenciado`,
      headerBounty: `Recompensas`,
      noDomainRegistered: `Nenhum domínio cadastrado.`,
      titleSendEmail: `Central de envios de e-mail`,
      cardPrivateProgram: `Programas privados`,
      sendEmailSuccess: `Email enviado para análise!`,
      placeholderMessageEmail: `Digite sua mensagem aqui..`,
      placeholderMessageTopic: `Assunto do email`,
      subTitlePageSendEmail: `Envie e-mails personalizados de forma rápida e eficiente para especialistas dos programas privados.`,
      titleCardSelectedProgram: `Programas selecionados`,
      titleCardHacker: `Especialistas`,
      hackerListEmpety: `Nenhum especialista disponível`,
      programListSelectedEmpety: `Nenhum programa selecionado`,
      placeholderFilterHacker: `Filtrar especialista`,
      placeholderFilterProgram: `Filtrar programa`,
      navCustomEmail: `Envio de E-mail`,
      controlEmail: `Gerenciador de e-mails`,
      noEmailsAvailable: `Nenhum e-mail disponível`,
      rejected: `Rejeitado`,
      scheduleDate: `Agende a data de envio do e-mail`,
      sendForAnalysis: `Enviar para Análise`,
      removeEmailSuccess: `Email deletado com sucesso!`,
      areYouSureYouWantToDeleteThisEmail: `Tem certeza de que deseja excluir este e-mail?`,
      searchEmail: `Pesquisar e-mail`,
      createEmail: `Criar e-mail`,
      editEmail: `E-mail`,
      emailTopic: `Assunto`,
      dateSendEmail: `Data Programada`,
      tooltipEditEmail: `Editar e-mail`,
      tooltipDeleteEmail: `Deletar e-mail`,
      tooltipViewRejectedMessage: `Visualizar mensagem`,
      tooltipHiddenRejectedMessage: `Esconder mensagem`,
      sentEmail: `Enviado`,
      continueEmail: `Continuar Email`,
      temporaryEmailStorage: `Armazenamos temporariamente os dados do seu email`,
      yourEmailWillBeAnalyzed: `Seu e-mail será analisado e, após a aprovação, será enviado no prazo agendado.`,
      hackersSelected: `Especialistas selecionados`,
      checkAllFields: `Verifique se todos os campos estão preenchidos!`,
      recipients: `Destinatários`,
      emailContent: `Conteúdo do e-mail`,
      viewEmail: `Visualizar email`,
      pentest: `Pentest`,
      pentestCreateSubTitle: `Momento emocionante, hora de começar a criar o seu pentest!`,
      pentestType: `Tipo de Pentest`,
      whitebox: `White Box`,
      blackbox: `Black Box`,
      inclusionInWebApplication: `Inclusão em Aplicação Web`,
      inclusionInMobileApplication: `Inclusão em Aplicação Mobile`,
      loggedArea: `Área Logada`,
      executionPeriod: `Data de execução`,
      scheduleDatePentest: `Agende a data para execução do teste`,
      limitScopePentest: `Defina os escopos a serem testados`,
      selectedScopePentest: `Selecione os escopos para teste`,
      addObsOthersPentest: `Adicione uma observação geral..`,
      lblErrorRequiredObs: `Por favor, descreva o tipo do escopo.`,
      inPerson: `Presencial`,
      applicationLocation: `Local de Aplicação`,
      credential_access: `Credenciais de Acessos`,
      sourceCode: `Código Fonte`,
      requireFields: `Verifique os campos destacados em vermelho e preencha-os corretamente.`,
      selectedLocalApplication: `Selecione o local de aplicação`,
      selectedOneOption: `Selecione uma opção`,
      securityRetest: `Reteste de Segurança`,
      settingsPentest: `Configuração do ambiente, ferramentas e escopo para a execução segura do Pentest.`,
      aboutPentest: `Defina a finalidade do Pentest, destacando os riscos e vulnerabilidades que devem ser avaliados.`,
      swalSendPentest: `Enviado para análise`,
      viewPentest: `Visualizar`,
      pentestSubTitle: `Acompanhe e gerencie seus pentests na BugHunt.`,
      editPentest: `Detalhes do pentest`,
      swalDeletedPentest: `Excluído com sucesso!`,
      areYouSureYouWantToDeleteThisPentest: `Tem certeza de que deseja excluir este pentest?`,
      wantSaveChangesPentest: `Você deseja mesmo salvar as alterações feitas neste pentest?`,
      swalUpdatePentest: `Alterações feitas com sucesso.`,
      scopeListOfThePentest: `Lista de escopo do pentest!`,
      summaryAboutPentest: `Resumo da finalidade do Pentest, destacando os riscos e vulnerabilidades que devem ser avaliados.`,
      canceled: `Cancelado`,
      noPentestAvailable: `Nenhum pentest disponível`,
      requireAtLeastOneProfile: `É necessário cadastrar pelo menos um perfil!`,
      profileAlreadyAdded: `Este perfil já foi adicionado à lista.`,
      insertUserProfile: `Inserir perfil de usuário`,
      noProfileAvailable: `Nenhum perfil disponível.`,
      enterDate: `Informe uma data`,
      testDataProvided: `Dados fornecidos para a realização dos testes`,
      selectAnOption: `Selecione uma opção`,
      describeScopeType: `Descreva o tipo do escopo`,
      addScopeToContinue: `Por favor, adicione um escopo para continuar.`,
      about: `Sobre`,
      appPurposeDescription: `Faça uma breve descrição do propósito da aplicação`,
      moreDetailsAboutYourApp: `Conte mais detalhes sobre sua aplicação...`,
      fillAppDetails: `Preencha os detalhes da aplicação *`,
      aboutApplication: `Sobre aplicação`,
      criticalApplicationDescription: `Trata-se de uma aplicação crítica, onde falhas podem colocar vidas em risco.`,
      criticalSystemsExamples: `Sistemas de usinas nucleares, aviônicos, controle industrial e automação hospitalar.`,
      criticalApplicationWarning: `Trata-se de uma aplicação crítica, onde falhas podem colocar vidas em risco.`,
      handlesLargePersonalDataVolumes: `Manipula grandes volumes de dados pessoais.`,
      performsFinancialTransactions: `Executa transações financeiras.`,
      paymentsCryptoAssetsSwiftTransactions: `Pagamentos, criptoativos e transações Swift.`,
      viewersCannotCreatePentest: `Usuários do tipo visualizador não tem permissão para criar pentest!`,
      startDate: `Data inicial`,
      endDate: `Data final`,
      startDateMustBeEqualOrGreaterThanCurrent: `A data inicial deve ser igual ou maior que a data atual!`,
      briefApplicationPurpose: `Uma breve descrição do propósito da aplicação`,
      totalPentests: `Total Pentests`,
      descriptionWhiteBox: `Simula um ataque real, onde o testador tem pouquíssimas ou nenhuma informação prévia sobre o sistema, avaliando a eficácia das medidas de proteção e a resposta a ataques.`,
      descriptionBlackBox: `Simula um ataque real sem acesso prévio a informações do sistema, testando a segurança externa, a eficácia das defesas e a resposta a possíveis invasões.`,
      createPentest: `Vamos criar um pentest ?`,
      ssoLoginMethodForOrganizations: `Este método de login exclusivo para empresas que utilizam SSO na BugHunt. Se você não faz parte de uma organização com SSO, use a opção "Entrar sem SSO".`,
      budgetSwal: `Budget atualizado com sucesso.`,
      managerSwal: `Gestores atualizado com sucesso`,
      urlDomain: `Utilize Redirect URL ao configurar o seu provedor de identidade (IdP).`,
      defineAtLeastOneGoalBeforeReactivating: `Antes de reativar o programa, defina pelo menos um objetivo!`,
      view: `Visualizar`,
      additions: `Adições`,
      removals: `Remoções`,
      minLengthUpdateProgram: `A descrição deve conter no mínimo 10 caracteres!`,
      submitAgreementNotice: `Ao clicar em "Enviar para Análise", você concorda com a`,
      ourLabel: "os nossos",
      confirmReadOur: "e confirma que leu nosso",
      tokenORSmsInvalid: `Token ou código SMS inválido.`,
      youAgree: `Você concorda com os`,
      help: `Ajuda`,
      errorUserNameIdp: `Value at 'userName' failed to satisfy constraint: Member must satisfy regular expression pattern: [\p{L}\p{M}\p{S}\p{N}\p{P}]+`,
      causeFormatUserName: `O problema reside na formatação do atributo userName que o IdP está enviando na asserção SAML. O Cognito está esperando um determinado padrão, e o IdP está enviando algo diferente.`,
      solutionFormatUserName: `No IdP, configurar o mapeamento de atributos para garantir que o atributo necessário seja enviado na asserção SAML e que seu valor seja válido.`,
      causeAttributeEmail: `O Cognito está configurado para exigir um atributo específico email, mas o IdP não o está enviando na resposta SAML, ou o valor enviado não é válido para o Cognito.`,
      solutionAttributeEmail: `Ajustar o mapeamento do atributo userName no IdP para que seu valor corresponda à expressão regular exigida pelo Cognito.`,
      causeCertificate: `O certificado usado pelo IdP para assinar a resposta SAML expirou, está revogado, ou não corresponde ao certificado configurado no Cognito. Pode haver também um problema com a cadeia de confiança do certificado.`,
      solutionCertificate: `Atualizar o certificado no IdP e no Cognito. Garantir que o certificado do IdP seja válido e que o Cognito confie nele.`,
      causeClocks: `Há uma diferença significativa de tempo (descompasso de relógio) entre o servidor do IdP e os servidores do Cognito. O SAML define um período de validade para as asserções.`,
      solutionClocks: `Sincronizar os relógios dos servidores do IdP e do Cognito (utilizando NTP, por exemplo) para minimizar o descompasso.`,
      causeAudienceRestriction: `O atributo AudienceRestriction presente na asserção SAML do IdP não corresponde ao Entity ID exato configurado e esperado pelo Cognito. Isso serve para garantir que a asserção é destinada ao Service Provider (Cognito) correto.`,
      solutionAudienceRestriction: `No IdP, verificar a configuração do "Audience Restriction" para o cliente SAML e garantir que ele corresponda ao Entity ID do seu User Pool do Cognito.`,
      causeAssertionSAML: `O Cognito detectou que uma asserção SAML com o mesmo ID já foi processada anteriormente. Esta é uma medida de segurança para prevenir ataques de replay.`,
      solutionAssertionSAML: `Geralmente, não é um erro de configuração. Pode ser um problema de cache do navegador, múltiplos envios da mesma solicitação ou uma tentativa maliciosa. Limpar o cache e os cookies do navegador do usuário pode ajudar.`,
      causeMalformed: `A resposta SAML enviada pelo IdP não é um XML SAML válido, está corrompida, ou há um problema na sua codificação/compressão.`,
      solutionMalformed: `Inspecionar o XML bruto da resposta SAML usando um SAML Tracer para identificar problemas de sintaxe ou estrutura. Verificar os logs do IdP para erros internos na geração da resposta SAML.`,
      causeSAMLAssertion: `O Cognito está configurado para exigir que as asserções SAML sejam assinadas digitalmente, mas o IdP as está enviando sem assinatura.`,
      solutionSAMLAssertion: `Configurar o IdP para assinar digitalmente as asserções SAML que ele envia para o Cognito.`,
      causeRelayState: `O parâmetro RelayState, usado em fluxos de login iniciados pelo Service Provider (SP-Initiated) para redirecionar o usuário após a autenticação, está faltando ou foi alterado durante a comunicação.`,
      solutionRelayState: `Verificar se há algum proxy ou firewall que esteja alterando a URL de redirecionamento. Em alguns casos, pode ser um problema de configuração no IdP ou na aplicação que inicia o fluxo.`,
      suspendedAccount: `Sua conta estará temporariamente suspensa de`,
      termsAcceptWithSuccess: `Termos aceito com sucesso!`,
      scopeRequired: `Campo obrigatório. Um escopo deve ser definido previamente.`,
      unsolicited: `Não solicitado`,
      author: `Autor`,
      authorName: `Autor nome`,
      sent_at: `Data de envio`,
      updatedAt: `Data de atualização`,
      closed_at: `Data de encerramento`,
      bounty_value: `Valor do pagamento`,
      company_bounty_status: `Status do pagamento para a bughunt`,
      company_bounty_payment_date: `Data do pagamento para a bughunt`,
      hacker_bounty_status: `Status do repasse do pagamento para o especialista`,
      hacker_bounty_payment_date: `Data do repasse`,
      weakness: `Weakness`,
      tags: `Tags`,
      createdAt: `Data de criação`,
      current: `Atual`,
      campaign: `Campanha`,
      suggestedValue: `O valor deve ser maior ou igual ao valor sugerido.`,
      needsValueInformed: `O valor precisa ser informado!`,
      reportYithActiveCampaign: `Relatório enviado enquanto a campanha estava ativa`,
      doubleScore: `Pontuação em dobro`,
      doubleScoreAndBounty: `Recompensas e pontuação dobradas`,
      warningFinalDate: `A data final deve ser maior que a data inicial.`
      //translation_script_end_pt
    }),

    new MLanguage("english").create({
      ln: "en",
      //translation_script_start_en
      agreementText: `Do you agree to the terms of the confidentiality agreement?`,
      agree: `Agree`,
      doNotAgree: `Do Not Agree`,
      programWithNda: `This program has an NDA attached!`,
      ndaAccepted: `NDA accepted!`,
      programWithoutNda: `This program does not yet have an NDA attached!`,
      menuProgram: `Programs`,
      menuReport: `Reports`,
      menuAccount: `My Account`,
      navInvitations: `Invitations`,
      navPayments: `Payments`,
      navCreateNda: `Create an NDA Template`,
      navEditNda: `Edit NDA`,
      navPrograms: `All`,
      navPublished: `Published`,
      navClosed: `Inactive`,
      navNda: `NDAs`,
      navAll: `All`,
      navPending: `Pending`,
      navRetest: `Retest`,
      dashTitle: `Welcome {0}!`,
      dashSubTitle: `An overview and quick access to your account just for you`,
      dashReportResolv: `Approved reports`,
      navAverage: `Average Rewards`,
      dashMsgYouHave: `You have`,
      dashMsgYouDHave: `You don't have`,
      msgProgramPu: `public programs!`,
      msgProgramPr: `private programs!`,
      dashMsgGP: `Manage your programs.`,
      dashMsgCP: `Register a program now?`,
      dashInvTitle: `Invite Experts!`,
      dashInvSubTitle: `Invite experts to participate in your programs.`,
      dashPayTitle: `Payments!`,
      dashPaySubTitle: `Financial summary and payment requests.`,
      dashNdaTitle: `Non-Disclosure Agreements!`,
      dashNdaSubTitle: `Manage the confidentiality agreements for your programs.`,
      dashCreatNdaTitle: `Standard NDA template!`,
      dashCreatNdaSubTitle: `Create a standard template for managing confidentiality agreements for your programs.`,
      dashCreatNdaAbriefsummary: `A brief summary for the specialist to understand what it is about...`,
      dashCreatNdaDesc: `NDA is an acronym in English for Non-Disclosure-Agreements, or simply information confidentiality agreement. It is intended to protect industrial or commercial secrets, or any information that cannot be disclosed and must be kept confidential among those who have access to it.`,
      dashCreatNdaWriteTerms: `Draft the terms of your confidentiality agreement and its peculiarities.`,
      dashCreatNdawritePaste: `Let's get started, write or paste your terms!`,
      dashCreatNdaWantAttach: `Do you want to attach a document to be signed?`,
      progTitle: `Overview!`,
      progSubTitle: `Track and manage your programs on BugHunt.`,
      progPubTitle: `Published programs!`,
      progPubSubTitle: `Manage your published programs! Keep track of all the details.`,
      progCampTitle: `Campaigns`,
      progClosTitle: `Inactive programs!`,
      progClosSubTitle: `Did you miss me? See the data for inactive programs.`,
      progCreateTitle: `Create a Program`,
      progCreateSubTitle: `Exciting moment, time to start creating your program!`,
      progRankTitle: `Contributions ranking!`,
      progRankSubTitle: `See who contributes the most to your programs.`,
      progRankSendThank: `Send a Thank You!`,
      progRankBtnSendThank: `Send Acknowledgement`,
      progTimelineTitle: `Program's Timeline!`,
      progTimelineSubTitle: `Follow the timeline of your programs`,
      repTitle: `Reports!`,
      repSubTitle: `Manage the reports submitted by experts to your programs.`,
      repSubTitleHacker: `Manage the reports sent to the programs.`,
      repDetMsgAlter: `Changes made to the report cannot be undone!`,
      ccpTitle: `Are we going to create a program?`,
      ccpProgPubli: `Public program`,
      ccpProgPubliDesc: `Create a program where all registered specialists can view and submit reports!`,
      ccpProgVDPDesc: `Create a program where all specialists can view and submit reports!`,
      ccpProgPriv: `Private program`,
      ccpProgPrivDesc: `Create a program where only selected specialists can view and submit reports!`,
      managedProgram: `Managed program`,
      protectedByNDA: `Protected by an NDA`,
      helpTitle: `Needing help?`,
      helpProgram: `How does a program work?`,
      helpDifference: `What is the difference between private and public?`,
      helpaverage: `What is the average applied to a bounty?`,
      rankTitle: `Contributions ranking`,
      retest_confirmed: `Redressed`,
      retest_denied: `Failure persists`,
      accountSubTitle: `An overview and quick access of your account just for you.`,
      accountAcSubTitle: `Who, when, and how accessed your account`,
      accountTerSubTitle: `Access our terms and privacy policy`,
      accountUserSubTitle: `Manage who has access to the organization.`,
      accountSettSubTitle: `How you want to receive your emails, privacy policy, and others.`,
      aboutUs: `About us`,
      aboutYou: `About you`,
      aboutYourAccount: `About your account`,
      aboutTheProgramPolicy: `About the program's policy!`,
      add: `Add`,
      addUser: `Add User`,
      addAcomment: `Add a comment`,
      addExpertToBlacklist: `Add expert to the Blacklist`,
      addTheScopesHere: `Add the scopes here!`,
      addOutOfScopesHere: `Add here the applications that should be avoided during safety tests!`,
      addYourPayPalAccount: `Add your PayPal account`,
      adjustedTheImpactTo: `Adjusted the impact to`,
      adjustedTheImpactFrom: `Adjusted the impact of`,
      adjustMetrics: `Adjust Metrics`,
      allowedFiles: `Allowed files: videos, images and text files .jpg .jpeg .png .txt .rar .zip .7z`,
      alreadyHaveAccount: `Do you already have an account?`,
      accepted: `Accepted`,
      acceptThisInvitation: `Accept this Invitation!`,
      access: `Access history`,
      accessControl: `Access control`,
      accessMyAccount: `Access my account!`,
      accessProfile: `Access profile`,
      accessInformation: `Access information`,
      accountCreatedSuccessfully: `Account created successfully!`,
      accountDeleted: `Deleted account`,
      accountRecovery: `Account recovery`,
      accurate: `Ascertained`,
      activate: `Activate`,
      activated: ` activated`,
      additionalServices: `Additional services`,
      addOtherRewardsHere: `Add other rewards here!`,
      addToBlacklist: `Add to Blacklist`,
      agreementSpecialists: `Experts in agreement`,
      ago: `{0} ago`,
      aGoodPolicAvoids: `A good policy avoids problems, if you have any problems contact us.`,
      all: `All`,
      gatTagOptDescription: `Only reports that contain the GAT tag`,
      gatTagDescription: `What reports will be sent to the GAT platform?`,
      allowMobileAccess: `Allow cell phone accesses`,
      allowedToPayReward: `You are allowed to pay rewards.`,
      allThePrograms: `All programs`,
      allStatus: `All Statuses`,
      aLowercaseLetter: `a lowercase letter`,
      anEmailContainingPasswordReset: `An email containing instructions for resetting the password has been sent.`,
      aNewValidationEmailHasBeenSenToYou: `A new validation email has been sent to you, please check your mailbox`,
      aNewSuperStrongPassword: `A new super strong password!`,
      annotation: `Note`,
      aNumber: `a number`,
      anUppercaseLetter: `a capital letter`,
      thePasswordMustHave: `The password must have`,
      anyQuestionsAboutIntegration: `Questions about this integration?`,
      application: `Application`,
      applicableReport: `Applicable report`,
      approveWithoutRetest: `Do you really want to close the report as approved before requesting a retest?`,
      approveRetest: `Approve retest`,
      approvedRetest: `Approved the retest`,
      areYouSureYouWantToDeleteThisUser: `Are you sure you want to delete this user?`,
      as: `like`,
      aSuperStrongPasswordNow: `A super strong password now!`,
      atBugHuntYouWillFindPrograms: `At BugHunt you will find programs to test different types of technologies, put your knowledge into practice, testing real applications in an ethical and legalized way.`,
      attention: `Attention!`,
      atLeastCharacters: `at least 6 characters`,
      authentication: `Authentication`,
      averageTicket: `Medium ticket`,
      average_time_to_bounty: `Average time to pay a reward`,
      average_time_to_first_response: `Average time for the first response`,
      average_time_to_resolution: `Average time to close the report`,
      averageTimeToBounty: `Average payment time`,
      avgTimeToBounty: `The average time elapsed from the company's first interaction with a report to the request for payment of a reward.`,
      avgTimeToFirstResponse: `The average time elapsed from the submission of the report to the company's first interaction with a report.`,
      avgTimeToResolution: `The average time elapsed from the opening of a report to its closing.`,
      avgTimeToBunty: `Average time between the request and the actual payment.`,
      awaitingAcceptance: `Waiting for acceptance`,
      awaitingPayment: `Awaiting payment`,
      paymentReceived: `Received payment`,
      awaitingResponse: `Waiting for Reply`,
      award: `Awarding`,
      backupCodesLeft: `Remaining backup codes`,
      balance: `Balance`,
      basedLast90Day: `Based on the last 90 days`,
      beforeActivatingTwoFactorAuthentication: `Before activating Two-factor authentication, you must validate your phone.`,
      beforeContinuingYouNeed: `Before continuing you need to validate your email!`,
      billingCreditCard: `Billing Credit card`,
      billingForms: `Billing forms`,
      billingInformation: `Billing information`,
      byActivatingTheProgramSpecialistsWill: `By activating the program, specialists will be able to submit new reports!`,
      byPausingTheProgramExpertsWill: `When you pause the program, specialists will no longer be able to submit new reports!`,
      bounty: `Financial`,
      bountyAwarded: `Reward granted`,
      bugBountyAndTheSecurityParadox: `Bug Bounty and the Security Paradox`,
      bugHuntIsTheFirstBrazilianBugBounty: `<b>BugHunt</b> is the first Brazilian Bug Bounty platform, and is now partnering with <b>AME Digital</b> with the purpose of democratizing access to information security and thereby making the Internet a safer place.`,
      bugHuntIsTheFirstBrazilianBugBountyAvenue: `<b>BugHunt</b> is the first Brazilian Bug Bounty platform, and is now partnering with <b>Avenue</b> with the purpose of democratizing access to information security and thereby making the Internet a safer place.`,
      ongoingProfileVerification: `Your profile is being verified!`,
      cancel: `Cancel`,
      cannotEnterEqualScopes: `It is not possible to enter equal scopes`,
      cannotEnterSpecialCharacters: `It is not possible to enter special characters`,
      cautionNDA1: `When drafting your company's NDA, make sure that it includes the following items:`,
      cautionNDA2: `contain at least one penalty clause in case of non-compliance;`,
      cautionNDA3: `inform the parties that make that commitment;`,
      cautionNDA4: `contain an expiration date;`,
      cautionNDA5: `detail specifically what that NDA refers to, since generic and ambiguous information mischaracterizes the legal document;`,
      cautionNDA6: `Use the tag `,
      cautionNDA7: `to refer to the name of the specialist;`,
      cautionNDA8: `The NDA template below is illustrative. Make sure you enter your company details correctly when drafting the confidentiality agreement `,
      changeAccessPassword: `Change access password`,
      changePassword: `Change Password`,
      changePermission: `Change permission`,
      changedReportSeverity: `Severity of the report changed`,
      changedReportStatus: `Report status changed`,
      changedTheStatusFrom: `changed the status from {f} to {l}`,
      changedTheSituationTo: `changed the situation to {0}`,
      changedTheTitleOf: `changed the title of the report from {f} to {l}`,
      changedTheTitleTo: `changed the title of the report to {0}`,
      changedTheVisibilityOf: `changed the visibility of {f} to {l}`,
      changedTheVisibilityTo: `changed the visibility to {0}`,
      checkOutAllFieldsHighlightedInRed: `Check out all fields highlighted in red!`,
      chooseANicknameYoursAlone: `Choose a nickname that's all yours!`,
      city: `City`,
      clickHereToLearn: `Learn more.`,
      clearData: `Clear data`,
      clearlyDefine: `Clearly define your program policy.`,
      close: `Close`,
      closed: `Closed`,
      closedAgo: `Closed {0} days ago`,
      closedIn: `Closed in`,
      closedReport: `Closed report`,
      closedReports: `Closed reports`,
      closedTheReportAs: `closed the report as`,
      reopenedTheReport: `reopened the report`,
      code: `Code`,
      conclude: `Conclude`,
      connectionDenied: `Connection denied`,
      connectionTime: `Approximate connection time`,
      connectionRefusedUserDisabled: `Connection refused, user disabled!`,
      connectionsPerUser: `Connections per user`,
      contacts: `Contacts`,
      company: `Company`,
      completed: `Completed`,
      confirm: `Confirm!`,
      confirmAccountRemoval: `Confirm Account Removal`,
      confirmYourPassword: `Confirm your password!`,
      token2fa: `Enter the 2-factor authentication token`,
      confirmProgramChanges: `Describe the changes made to the program`,
      congratulationsYourUsernameIsNowVerified: `Congratulations, your username is now verified.`,
      invalidEmail: `Invalid email, please check and try again.`,
      continueReport: `Continue Report`,
      copiedId: `Id copied`,
      copyLink: `Copy link`,
      continue: `Continue`,
      creatAccountInvit: `Created the account through the invite`,
      createA: `Create a`,
      created: `Created!`,
      createMyAccount: `Create my account!`,
      critical: `Critical`,
      request_response: `Response`,
      request_closure: `Closure`,
      responseRequestReport: `requested a response for this report.`,
      reportClosureRequest: `requested closure of this report.`,
      day: `day`,
      days: `days`,
      dateTime: `Date/Time`,
      declined: `Declined`,
      dataChanged: `Data changed!`,
      dataWillBeRemovedWithPhoneValidation: `By disabling the phone, 2FA data will be automatically removed.`,
      date: `Date`,
      declineThisInvitation: `Decline this Invitation!`,
      delimitDomains: `Delimit domains, subdomains, applications and more`,
      delimitItems: `Delimit items`,
      deleteUser: `Delete user`,
      depositedAmount: `Total Deposits`,
      delimitationOfDomainsSubdomains: `Delimitation of domains, subdomains, applications and others`,
      describeALittleMoreAboutTheImpact: `Describe a little more about the impact!`,
      describeChangesMadeInProgram: `This summary will be available to all experts participating in this program!`,
      describeClearlyHowTheVulnerabilityWorks: `Clearly describe how the vulnerability works.`,
      describeInDetailTheImpactOfThisRepor: `Describe in detail the impact of this report.`,
      describeThePerformedTests: `Describe the performed tests`,
      describeTheTitleOfTheReport: `Describe the title of the report`,
      describeTheScope: `What is the URL of the vulnerable application?`,
      description: `Description`,
      descriptionSubmitReport: `##### 1. Summary \n(add a summary of the vulnerability)\n\n##### 2. Description\n(add more details about this vulnerability)\n 1. [add step]\n\n##### 3. Steps to reproduce\n(Add details on how we can reproduce the problem)\n 1. [add step]\n 2. [add step]\n 3. [add step]\n\n##### 4. Supporting material / references\n(e.g. screenshots, logs, etc.)\n 1. List any additional material\n `,
      descriptionCannotContainSpecialCharacters: `The description cannot contain special characters`,
      descriptionMustBeFromToCharacters: `The description must be from {f} to {l} characters.`,
      describeEditsMade: `Describe the edits made.`,
      details: `Details`,
      directoryName: `Directory Name`,
      disable: `Disable`,
      domain: `Domain`,
      done: `Done`,
      doNotUseSpecialCharactersAndMalicious: `Do not use special characters and malicious payloads in the title, impact and summary, these items should be attached as .zip, .rar or .7z at the end of the report.`,
      doNotUseSpecialCharacters: `Do not submit payloads with possible malicious code, these items must be attached as .zip, .rar or .7z!`,
      dontForgetToSaveYourChanges: `Don't forget to save your changes!`,
      downloadTheReportPDF: `Download the Report in PDF`,
      doYouHaveOrganizationAndDidYou: `Would you like to protect your company?`,
      doYouWantToRemoveThePhone: `Remove phone`,
      doyoureallyWanttoDeleteVacancy: `Do you really want to delete this vacancy?`,
      doYouReallyWantToRemoveTwoFactor: `Remove Two-factor authentication`,
      doYouReallyWantToRemoveThisAccount: `Do you really want to remove this account?`,
      doYouReallyWantToRemoveThis: `Do you really want to remove this {0}?`,
      doYouWantToActivateTheProgram: `Do you want to activate the program?`,
      doYouWantToContinue: `Do you want to continue with the fields already filled in?`,
      doYouWantDisableProgram: `Do you want to disable the program?`,
      doYouWantToPauseTheProgram: `Do you want to pause the program?`,
      doYouWantToAddVPNToYourNewProgram: `Do you want to add VPN to your new program?`,
      editProgram: `Edit Program`,
      editNda: `Edit NDA`,
      eligible: `Eligible`,
      efficiencyMetrics: `Efficiency Metrics`,
      emailAlreadyRegistered: `Email is already registered`,
      emailAlreadyValidatedNonExistent: `Email already validated or expired!`,
      emailConfirmation: `Email confirmation`,
      emailDoesNotAppearToBeValid: `The email does not appear to be valid`,
      emailSuccessfullyValidated: `Email successfully validated!`,
      enableTwoFactorAuthentication: `Enable two-factor authentication`,
      end: `End`,
      enterNewTags: `Enter new tags separating them by commas`,
      enterPasswordConfirmation: `Enter password confirmation`,
      enterTheCode: `Enter the code`,
      enterTheCodeReceivedBySms: `Enter the code received by SMS`,
      enterTheCompletePhone: `Enter the complete phone number`,
      enterTheDescriptionOfTheOrganization: `Enter the description of the organization`,
      enterTheEmail: `Enter the email`,
      enterTheNameOfTheOrganization: `Enter the name of the organization`,
      enterThePassword: `Enter the password`,
      enterTheUsername: `Enter the username`,
      enterTheScope: `Enter the scope of the program!`,
      enterUserName: `Enter the user name`,
      enterYourEmail: `Enter your email`,
      enterYourFullName: `Enter your full name`,
      enterYourPayPalAccountEmail: `Enter your PayPal account email`,
      enterYourPrimaryEmailAddress: `Enter your primary email address!`,
      enterYourUserPassword: `Enter your user password`,
      enterYourRewardDetails: `Enter your reward details!`,
      evaluate_retest: `Evaluate retest`,
      evaluatedRetest: `Retest evaluated`,
      executiveSummary: `Executive summary of the organization`,
      exit: `Exit`,
      expertSuccessfullCreated: `Expert {0} successfully created`,
      export: `Export`,
      exportLogs: `Export logs`,
      exportInCsv: `Export in .csv`,
      exportReports: `Export reports`,
      externalLinkNotice: `External link notice`,
      extract: `Extract`,
      extractedBy: `Extracted by`,
      fillInTheDetailsBelowTo: `Fill in the details below to change your password.`,
      fillInAllFieldHighlightedInRed: `Fill in all fields highlighted in red!`,
      filterByTags: `Tags`,
      findSecurityJobsOnOurDashboard: `BugHunt connecting the community with the best companies.`,
      forgotYourPassword: `Forgot your password?`,
      forSecurityWeRequestYourPassword: `For security, we request your password for this operation.`,
      forYourSecurityToPDF: `For your security it is necessary to add a password to the PDF.`,
      fullName: `Full name`,
      generateNewCodes: `Generate new codes`,
      getAccessToExclusiveRewards: `Get access to exclusive rewards from this program!`,
      gift: `Gift`,
      giftsAndAcknowledgments: `Gifts and Acknowledgments`,
      guests: `Guests`,
      hackerControl: `Hacker Control`,
      haveYouRevised: `Have you revised your model? Then you're ready!`,
      haveYouReviewedYourReportNow: `Have you reviewed your report? Then you're ready, let's send it for analysis!`,
      here: `here`,
      hereYouCanSetUpYourAccount: `Here you can set up your account to receive your rewards.`,
      high: `High`,
      historic: `Historic`,
      features: `Features`,
      iAlreadyHaveAnSccount: `I already have an account!`,
      iAlreadyRemembered: `I already remembered!`,
      iAgreeWithThe: `I agree with the `,
      ifYouDontReceiveIt: `If you don't receive it, you can try again in`,
      ifYouNeedToSubmitMoreComment: `If you need to submit more, just write another comment`,
      impact: `Impact`,
      impactDescriptionCannotContainSpecialCharacters: `The impact description cannot contain special characters!`,
      inactivated: ` deactivated`,
      inactiveUsers: `Inactive Users`,
      initProgramMessage: `Program started on `,
      informBugHuntPassword: `Enter the BugHunt platform password to confirm this operation.`,
      informThePhoneWithAreaCode: `Enter the phone number with area code`,
      informTheRecommendations: `Inform the rewards that the expert will get if successful!`,
      informTheScope: `Inform the scope`,
      informTheScopeWhereTheThreatsAre: `Inform the scope where the threats are`,
      selectTheScopeType: `Select the type of inspected scope`,
      informTheImpact: `Inform the impact`,
      informTheUser: `Inform the user`,
      informTheWebsite: `Inform the website`,
      interationIdealTime: `The ideal average time for {interationType} is `,
      interviewWithExpertIgorRincon: `Interview with expert Igor Rincon`,
      invalidBackupCodeOrToken: `Invalid backup code or token`,
      invalidCode: `Invalid code`,
      invalidCodeOrToken: `Invalid code or token`,
      invalidDate: `Invalid date`,
      invalidData: `Invalid data`,
      invalidRegistrationData: `Invalid registration data {0}!`,
      invalidEmailOrPassword: `Invalid email or password!`,
      invalidPassword: `Invalid password`,
      invite: `Invite`,
      invitationAccepted: `Invitation accepted`,
      invitationDeclined: `Invitation declined`,
      invitationLimitManagersReached: `The invitation limit for managers has been reached.`,
      invitationProgramLimitReached: `The invitation limit for the {program} program has been reached.`,
      invitationNotFoundOrExpired: `Invitation not found or expired!`,
      invitationsAccepted: `Invitation accepted`,
      invitationsReceived: `Invitations Received!`,
      invitationRevoked: `Invitation revoked`,
      invitationSent: `Invitation sent`,
      invoiceValue: `Invoice total`,
      NdaCreated: `NDA created`,
      inProgress: `In progress`,
      inRelationToTheReport: `Regarding the report`,
      inSomeCasesTheEmailMayFallAsSpam: `In some cases, the email may fall as spam.`,
      integration: `Integration`,
      integrations: `Integrations`,
      integrationsNotAvailable: `Integrations not available!`,
      inTheProgram: `in the program`,
      internal: `Internal`,
      invoices: `Billing`,
      iPAdress: `IP Address`,
      issued: `Issued`,
      itHappensInTheBestFamilies: `It happens in the best families! Don't worry, just enter your email and we'll send you a new password.`,
      itHappensInTheBestFamiliesDonotworry: `It happens in the best families! Don't worry.`,
      itIsNotPossibleToEnterEqualRewards: `It is not possible to enter equal rewards!`,
      itIsNotPossibleToEnterMore: `It is not possible to enter more than 30 tags!`,
      itIsNotPossibleToSubmitAnotherRetest: `It was not possible to submit the retest evaluation!<br /> Wait for the expert's retest.`,
      iWantToCreateAnAccount: `I want to create an account!`,
      jobBoard: `Job Board`,
      jobDescription: `##### About the Company \n Describe here the details about your **company**\n \n ##### About the Job\n We are looking for a Professional whose main responsibilities will be:\n - Responsibility 1.\n - Responsibility 2.\n - Responsibility 3.\n \n ##### Requirements\n - **Requirement 1:** Above x years of experience.\n - **Requirement 2:** Above x years of experience.\n - **Requirement 3:** Above x years of experience.`,
      jobTitle: `Job Title`,
      joinedThePlatform: `Joined the platform`,
      lastReviewSubmittedAgo: `Last review submitted {0} ago`,
      lastInvitations: `Last Sent Invitations`,
      last7daysOfAccess: `Last 7 days of access`,
      latestReports: `Latest reports`,
      letStartYourRegistrationAnd: `Let's start your registration and we will soon contact you to clarify any doubts and finalize your registration!`,
      letsCompleteYourRegistration: `Let's complete your registration!`,
      letsCreateYourAccount: `Let's create your account!`,
      letsCreateYourPreRegistration: `Let's create your pre-registration!`,
      lessThanMonthAgo: `less than a month ago`,
      like: `like`,
      limitScope: `Limit the scope and only the accesses that will be rewarded!`,
      limitOutOfScope: `Which applications should not be tested?`,
      limitOfScopesPerProgramReached: `Limit of {0} scopes per program reached!`,
      linkToJob: `Link to job`,
      location: `Location`,
      longPeriodsImpactSpecialists: `Long waiting periods can impact the engagement of specialists in this program.`,
      low: `Low`,
      makePayment: `Make a Payment`,
      makeAPayment: `Make a Payment`,
      makeSureYouHaveACompatibleAppLike: `Make sure you have a compatible app like `,
      makeYourAccessEvenMoreSecure: `Make your access even more secure`,
      manageAccess: `Manage who has access to the program.`,
      managementInvitations: `Management of received invitations.`,
      manageVPNforUsers: `Manage the VPN of users of each program`,
      manageYourPlanInformation: `Manage your plan information.`,
      manageYourProgressPlatform: `Manage your progress on the BugHunt platform`,
      maximumLengthIsCharacters: `Maximum length is {0} characters`,
      maximumFilesPerComment: `The maximum is 10 files per comment`,
      medianTimeToResolution: `Median time to resolution`,
      medianTimeToFirstResponse: `Median time to first response`,
      medium: `Medium`,
      metricDoesNotHaveEnoughDataYet: `There is not enough data to calculate this metric yet`,
      metricsDoesNotHaveEnoughDataYet: `There is not enough data to calculate the metrics yet`,
      message: `Message`,
      messagePostedAgo: `message posted {time} ago`,
      messagePublishedDay: `message published on {day}`,
      missedResponseTargetsReportsSent: `Responses sent above the expected time`,
      missedResponseTargetsResolved: `Report resolution above the expected time`,
      missedResponseTargetsBounty: `Payments made above the expected time`,
      monthlyFee: `Monthly fee`,
      monthlyPayment: `Monthly payment`,
      moreOptions: `More options`,
      money: `Money`,
      myPlan: `My Plan`,
      myBusiness: `My business`,
      nameChanged: `Name changed!`,
      nameOfAccountHolder: `Name of account holder!`,
      nameIsNotValid: `The name is not valid`,
      navigation: `Navigation`,
      needChangeDescription: `Use the template to make a detailed description.`,
      ndaVerificationRequired: `Your profile is eligible to participate in the verification process!`,
      ndaChange: `NDA change`,
      next: `Next`,
      new: `New`,
      newComment: `New comment`,
      newUsers: `New Users`,
      newPassword: `New Password`,
      newPasswordAndConfirmation: `New password and confirmation do not match!`,
      newReport: `New report`,
      none: `None`,
      noActivePrograms: `No active programs`,
      noInvitationAvailable: `No invitation available`,
      noNotificationsAvailable: `No notifications available`,
      noPaymentsFound: `No payments found`,
      noProgramAvailable: `No program available`,
      noReportsFound: `No reports found`,
      noScopeAvailable: `No scope available!`,
      noSuggestionsAvailable: `No suggestions available`,
      noteValue: `Note Value`,
      notAvailableForThisPlan: `Not available for this Plan!`,
      notAuthorized: `Not authorized!`,
      shutdownRequested: `The shutdown of this report has already been requested!`,
      replyNotificationTitle: `Response request`,
      closingRequestTitle: `Closing request`,
      replyRequestMessage: `A response has already been requested for this report!`,
      notificationResponseReport: `Attention! A response has been requested for this report.`,
      shutdownNotificationMessage: `Attention! A shutdown has been requested for this report.`,
      notificationSeeRequest: `See request`,
      requestSent: `Request sent successfully!`,
      reportResponseNotification: `Attention! A response has been requested for this report.`,
      notEligible: `Not eligible`,
      noExpertsFound: `No experts found`,
      notificationUpdatedNDA: `The non-disclosure agreement for the program {programName} has been updated! To continue participating in this program, you need to review and accept the NDA.`,
      noUserAvailable: `No user available`,
      noVpnAccessLogFound: `No vpn access log found!`,
      nowTellUsLittle: `Now tell us a little about the program policy!`,
      nowTellUsALittleBitAboutTheThreat: `Now tell us a little about the threat!`,
      ofReward: `of reward`,
      oneDayAgo: `one day ago`,
      oldPassword: `Current Password`,
      outstandingPayments: `Outstanding payments`,
      open: `Open`,
      opssMatiDidntApproveYourData: `Oops, Mati didn't approve your data.`,
      others: `Others`,
      other: `Others`,
      otherTypes: `Other types`,
      outOfScope: `out of scope`,
      outOfScopeTitle: `Out of Scope`,
      participating: `Participating`,
      password: `Password`,
      passwordChanged: `Password changed!`,
      passwordConfirmation: `New Password Confirmation`,
      passwordsMustMatch: `Passwords must match`,
      expirePasswordConfig: `User passwords will be valid for`,
      passwordUpdateRequired: `Attention! Change your password to avoid blocking this account!`,
      remainingDaysToUpdateYourPassword: `days remaining to update your password.`,
      passwordExpiredNotificationTitle: `Attention! Your password has expired!`,
      passwordExpiredInstructions: `Your account will be temporarily blocked. Keep your password updated and follow the instructions sent to the email associated with this account.`,
      enablePasswordExpiration: `Enable password expiration`,
      configSuccess: `Configuration updated successfully!`,
      pasteTheLinkIntoTheBodyOfTheDescription: `Paste the link into the body of the description.`,
      pause: `Pause`,
      paused: `Paused`,
      pauseProgram: `Pause program`,
      paymentFor: `Payment for`,
      paymentHistory: `Payment History`,
      paymentSummary: `Payment summary`,
      paymentRequested: `Payment requested`,
      pending: `Pending`,
      pendingSubscription: `Pending Subscription`,
      permission: `Permission`,
      permissions: `Permissions`,
      pleaseMakeSureThatThisEmail: `Please make sure that this email is correct and belongs to you.`,
      phoneNumber: `Phone number`,
      phoneSuccessfullyRemoved: `Phone removed successfully!`,
      phoneValidation: `Phone validation`,
      platform: `Platform`,
      points: `Points`,
      pointsIn: `points in`,
      possibleDup: `Possibly duplicate report - The scope {scope} has already received reports regarding {CWE}`,
      possibleSpam: `Possible SPAM - We have verified that the expert {expert} has submitted several reports regarding {CWE} in the scope {scope}.`,
      postedComment: `posted a comment`,
      postedImage: `Posted an image`,
      previous: `Previous`,
      primaryEmail: `primary email`,
      primaryEmailReceiving: `Primary Email for receiving information`,
      privacy: `Privacy`,
      privacyPolicy: `Privacy Policy`,
      private: `Private`,
      privateProgram: `private program`,
      profileInformation: `Profile Information`,
      profileVerifiedReleased: `Profile verification requested`,
      program: `Program`,
      programs: `Programs`,
      programDetails: `Program details`,
      program_management: `Program management`,
      programLifeCycle: `Program life cycle`,
      programsLimitReached: `Program limit of {0} reached!`,
      programsIhaveAlreadyContributed: `Programs I have already contributed to`,
      programPolicy: `Program Policy`,
      programPolicyMustBeInformed: `The program policy must be informed`,
      programPolicyMustBeBetweenAndCharacters: `The program policy must be between {f} and {l} characters`,
      programRanking: `Program ranking`,
      programNdaMustBeBetweenAndCharacters: `The NDA content must be between {f} and {l} characters`,
      programsPublishedOnTheWeb: `Programs published on the web can be accessed by experts not registered on the platform.`,
      programSuccessfullyChanged: `Program changed successfully`,
      programType: `Program Type`,
      programWith: `Program with {0}`,
      proofOfConceptLinks: `Links to proof of concept are usually benign, but can often be accompanied by unintended consequences.`,
      setProgramNda: `Do you want to add the non-disclosure agreement to your new program?`,
      public: `Public`,
      publicInformation: `Public Information`,
      publicOrPrivateProgram: `Public or private program`,
      publicProgram: `public program`,
      publish: `Publish`,
      published: `Published`,
      publishedDaysAgo: `Published {0} days ago`,
      publishProgramOnTheWeb: `Publish program on the Web?`,
      publishToTheWeb: `Publish to the Web`,
      questionsAboutUrl: `Questions about {0}`,
      rankingDoesNotHaveEnoughDataYet: `The Ranking does not have enough data yet`,
      rankingPosition: `{0}° in Ranking`,
      received: `Received at`,
      receiveAdvertising: `Receive advertising emails`,
      receiveEmails: `Receiving Emails`,
      receiveAdvertisingEmails: `Receive advertising emails`,
      receiveNotificationsAboutNewReports: `Receive notifications about new reports directly on your management platforms`,
      referenceDate: `Reference date`,
      refuseRetest: `Refuse retest`,
      refusedRetest: `refused the retest`,
      registerBelowTheTags: `Tag management`,
      registeredUsers: `Registered Users`,
      registeredVacancies: `Vacancies`,
      registration: `Registration`,
      removeAccount: `Remove Account`,
      remove: `Remove`,
      removeFromWhitelist: `Remove from Whitelist`,
      removeFromBlacklist: `Remove from Blacklist`,
      removed: `Removed`,
      reportAllPossibleThreatData: `Report all possible threat data`,
      report: `Report`,
      reportID: `Report ID`,
      reportCreatedSuccessfully: `Report created successfully`,
      reportEvaluation: `Report evaluation`,
      reportPayments: `Report payments`,
      reports: `Reports`,
      reportSent: `Report sent`,
      reportsSent: `Reports sent`,
      reportTitle: `Report title`,
      reportedThatTheVulnerabilityIsFixed: `reported that the vulnerability is fixed`,
      reportedThatTheVulnerabilityIsNotPatched: `reported that the vulnerability is not patched`,
      reportedVulnerabilities: `Reported vulnerabilities`,
      approvedVulnerabilities: `Approved vulnerabilities`,
      vulnerabilities: `Vulnerabilities`,
      overviewSubTitle: `A management view of your account just for you`,
      summaryCard: `Reports summary`,
      requestedPayment: `requested a payment`,
      requestedPaymentOf: `requested the payment of`,
      requestedANewTestOfTheReport: `requested a new test of the report`,
      reset: `Reset`,
      rewardValue: `Reward value`,
      whatIsAnNda: `What is an NDA?`,
      whatIsAnNda2: `NDA is an acronym for Non-Disclosure-Agreements.`,
      whatIsAnNda3: `It is intended to protect trade secrets, commercial secrets, or any information that cannot be disclosed and must remain confidential between those who have access to it.`,
      whatIsaVPNAndHow: `What is a VPN and how can it help in your programs?`,
      reportTags: `Add tag(s) to the report`,
      requestNewPassword: `Request new password!`,
      requestRetest: `Request Retest`,
      requestSubscription: `Request Subscription`,
      requiredField: `Required field`,
      retestRequested: `Retest Requested`,
      requestedRetestPayment: `requested the retest payment`,
      retestId: `Retest id`,
      retestSent: `Retest sent`,
      return: `Return`,
      resolved: `Resolved`,
      revoke: `Revoke`,
      revokeWebAccessToTheProgram: `Revoke web access to the program?`,
      revoked: `Revoked`,
      revokeAccess: `Revoke Access`,
      rewardAmount: `Reward Amount`,
      reward: `Reward`,
      rewardDetails: `Reward details`,
      rewards: `Rewards`,
      rewardsReceived: `Rewards Received`,
      rewardsWithFinancialValues: `Rewards with financial values`,
      save: `Save`,
      saveEditions: `Save changes`,
      saveNda: `Save non-disclosure agreement`,
      saveInformation: `Save`,
      scopePerProgram: `Scope per program`,
      scopesPerProgram: `Scopes per program`,
      search: `Search`,
      seconds: `seconds`,
      select: `Select`,
      selectAddAccount: `Select "Add account" or "+" and scan the QR code below`,
      selectAScoreForTheReport: `Select a score for the report`,
      selectFile: `Select the file!`,
      selectLanguage: `Select a language`,
      selectScopeType: `Select the scope type`,
      selectTheThreat: `Select the threat!`,
      selectTheProgramScope: `Select the program scope!`,
      selectTheProgramImpact: `Select the program impact!`,
      selectTheReport: `Select the report`,
      selectTheScope: `Select the scope`,
      selectTheCWE: `Select the CWE`,
      selectTheVulnerability: `Select the vulnerability`,
      securityAnalyst: `Ex. Security analyst`,
      send: `Send`,
      sentTheRetest: `Sent the retest`,
      sendMessage: `Send Message`,
      sent: `Sent`,
      sentTo: `Sent to`,
      sentTheReport: `sent the report`,
      settings: `Settings`,
      severityReports: `Severity reports`,
      severity: `Severity`,
      currentValue: `Current value`,
      finalValue: `Final value`,
      showingResultsOfTotal: `Showing {results} of {totalResults} results.`,
      since: `Since {0}`,
      sinceLastMonth: `since last month`,
      situation: `Situation`,
      scope: `Scope`,
      scopeLimitExceeded: `The program's scope limit has been exceeded.`,
      scopeListOfTheProgram: `Program scope list!`,
      score: `Score`,
      scoreHistory: `Score history`,
      scopeType: `Scope Type`,
      share: `Share`,
      smsCode: `SMS Code`,
      smsCodeSent: `SMS Code sent`,
      specialist: `Specialist`,
      specialistNotFound: `Specialist not found!`,
      standard: `Standard`,
      standoutCreate: `Stand out! Create a motivating title.`,
      start: `Start`,
      pauseMessage: `Unable to perform the action, as the campaign has not yet started.`,
      startAnAccountForOrganization: `Create an account for organization`,
      startWithRewards: `Start with rewards that have financial value`,
      statistics: `Statistics`,
      stateCity: `State`,
      status: `Status`,
      statusChanged: `Status changed!`,
      storeYourBackupCodes: `Store your backup codes`,
      subdomain: `Subdomain`,
      submittedDays: `Submitted {0} days ago`,
      submitComment: `Submit Comment`,
      submitForReview: `Submit for Review`,
      rewardNotice: `Reminder: This program offers double reward`,
      submitReport: `Submit Report`,
      submit_retest: `Submit retest`,
      successfullyGeneratedKeys: `Keys generated successfully!`,
      suggestions: `Suggestions`,
      suggestedReward: `Suggested reward`,
      summary: `Summary`,
      superSimpleItDoesntEvenTake: `It's simple, it doesn't even take 1 minute. Just enter the data below and you're done! Your account is created.`,
      superSimpleItDoesntEvenTakeCompany: `It's simple, it doesn't even take 1 minute. Just enter the common organization data and you're done! Your account will be submitted for analysis.`,
      support: `Support`,
      sureAddExpertBlacklist: `Are you sure you want to add this expert to the blacklist?`,
      sureAddExpertWhiteList: `Are you sure you want to add this expert to the Whitelist?`,
      sureRemoveExpertBlacklist: `Are you sure you want to remove this expert from the Blacklist?`,
      sureRemoveExpertWhitelist: `Are you sure you want to remove this expert from the Whitelist?`,
      successfullyCreatedProgram: `Program created successfully`,
      successfullyCreated: `successfully created`,
      acceptedNda: `NDA accepted successfully!`,
      openReports: `Open reports`,
      openYourApp: `Open your app.`,
      or: `or`,
      organizationName: `Organization name`,
      overallRanking: `Overall ranking`,
      paidRetest: `If the <b>retest is approved</b>, you will receive an additional <b>{0}</b> of the bounty value.`,
      tagsAreUsedToHelpIdentifyReports: `Tags are used to help identify reports.`,
      tagsForReports: `Tags for reports`,
      takeAction: `Take Action`,
      takeTheOpportunityToAcquireMoreComplete: `Take the opportunity to acquire more complete plans for your company`,
      talkDirectlyToOurOperators: `Talk directly to our operators.`,
      target: `Expected time: {0}`,
      telephone: `Telephone`,
      testDescriptionsMustBetweenCharacters: `Test descriptions must be between {f} and {l} characters`,
      tests: `Tests`,
      terms: `Terms`,
      termsAPolicy: `Terms & Policy`,
      termsOfUse: `Terms of Use`,
      thanksForRegistering: `Thanks for registering!`,
      thankByEmail: `Thank you by email`,
      theActionsTakenOnTheReportCannotBe: `The actions taken on the report cannot be removed`,
      theCommentNeedsToBeInformed: `The comment needs to be informed!`,
      theDescriptionTestsMustBeInformed: `The test description needs to be informed`,
      theDescriptionOfTheProgramMustBeInformed: `The program description must be informed`,
      theImpactDescriptionMustBeInformed: `The impact description needs to be informed`,
      theImpactDescriptionMustBetweenCharacters: `The impact description must be between {f} and {l} characters`,
      theIsNotValid: `The {0} is not valid`,
      theFileIsNotValid: `The file is not valid!`,
      theNameMustBeFromToCharacters: `The name must be from {f} to {l} characters`,
      theNameOfThePersonResponsibleIsMandatory: `The name of the responsible person is mandatory.`,
      theNameOfTheProgramMustBInformed: `The program name must be informed`,
      theNameWillBeAssignedToYourProgramsURL: `The name will be assigned to your program's URL.`,
      thenUseYourEmail: `Then use your email, your password and access our platform. If you have forgotten your password or username, use the recovery option below!`,
      thePhoneIsNotValid: `The phone is not valid.`,
      theProgramDescriptionMustBeBetweenAndCharacters: `The program description must be between {f} and {l} characters!`,
      theProgramNameMustBeBetweenAndCharacters: `The program name must be between {f} and {l} characters`,
      thereIsAlreadyAprogram: `There is already a program registered with this name!`,
      thereIsAlreadyProgramSlug: `There is already a program registered with this slug!`,
      theReportNeedsToBeInformed: `The report needs to be informed`,
      theRetestMustBeSentWithinDays: `The retest must be sent within {0} days`,
      theRetestWasNotSubmitted: `The retest was not submitted!`,
      theRetestHaAlreadyAccepted: `The retest has already been accepted!`,
      theseSettingsDirectlyImpactTheAccessOfExperts: `These settings directly impact the access of experts.`,
      theScopeAddressMustBeInformed: `The scope address must be informed`,
      theThreatDescriptionMustBeInformed: `The threat description must be informed!`,
      theThreatDescriptionMustBetweenCharacters: `The threat description must be between {f} and {l} characters`,
      theTitleMustBeInformed: `The title needs to be informed`,
      theTitleMustBeBetweenCharacters: `The title must be between {f} and {l} characters`,
      theWebhookIsNotValid: `The webhook is not valid!`,
      theWebsiteMustBeFromToCharacters: `The website must be from {f} to {l} characters`,
      thisChangeIsIrreversible: `This change is irreversible.`,
      thisInformationCanAppear: `This information may appear on the company's public profile, next to your comments and in any of your reports.`,
      thisIsAnInternalSurvey: `This is an internal survey, experts will not have access to the data in this questionnaire.`,
      thisServiceCreatesAVPNResponsible: `This service creates a VPN, responsible for connecting and monitoring the data traffic of the expert's tests to your scopes, and with that greater traceability and security.`,
      thisWeek: `this week`,
      threats: `Threats`,
      time: `Time`,
      timeToFirstResponse: `to the first response`,
      timeToBounty: `to pay the bounty`,
      timeToResolution: `to close the report`,
      title: `Title`,
      to: `to`,
      toAcceptThisInvitation: `To accept this invitation, you need to verify yourself in Meta<b>Map</b> , after verification, wait a few minutes and refresh the page.`,
      tokenIsInvalid: `The token is invalid or has already been used.`,
      toAddMorePrograms: `To add more programs check our plans by clicking`,
      toAddMoreScopesToThe: `To add more scopes to the program check our plans by clicking`,
      toAddMoreUsersCheck: `To add more users, check our plans by clicking`,
      toAddTheseIntegrations: `To add these integrations check our plans by clicking`,
      toAddThisFeatureCheck: `To add this feature, check our plans by clicking`,
      toChangeYourPlanContactSupport: `To change your plan, contact support.`,
      toCheck: `Check`,
      toConfirmWeNeedYourPassword: `To confirm we need your password`,
      toConfirmYourRegistrationOn: `To confirm your registration on our platform, you need to click on the button below.`,
      today: `Today`,
      toDoThisYouNeedToEnterYourAppCode: `To do this, you need to enter your authentication app code or a backup token (each token is valid only once).`,
      topReportedCWE: `Top reported CWE`,
      totalConnectedHours: `Total connected hours`,
      totalEvents: `Total events`,
      totalMonthlyFees: `Total monthly fees`,
      totalReports: `Total reports`,
      totalReceived: `Total Received`,
      totalRewards: `Total rewards`,
      toTheProgram: `to the program`,
      totalSpent: `Total Spent`,
      totalSum: `Total Sum`,
      trackYourOpenReports: `Track your open reports`,
      twoFactorAuthentication: `Two-factor authentication`,
      type: `Type`,
      typeOfContract: `Type of contract`,
      typeOrPasteOneOfYourBackupTokens: `Type or paste one of your backup tokens, remembering that each token can only be used once!`,
      typeProgramLimitExceeded: `The program limit of type {programType} has been exceeded`,
      unableToCompleteThisRequest: `Unable to complete this request.`,
      unableToSubmittedTheReport: `Unable to submit this report. Make sure all fields are filled in correctly.`,
      undefinedRanking: `Undefined ranking`,
      uninformed: `Uninformed`,
      unshowPassword: `Hide password`,
      update: `Update`,
      updates: `Updates ({numberOfUpdates})`,
      updated: `Updated`,
      uploadFiles: `Upload files`,
      upTo: `Up to`,
      urlIsNotValid: `The url is not valid`,
      useBackupCode: `Use backup code?`,
      user: `User`,
      userBlockedForOverTrying: `User blocked for too many attempts, try again later.`,
      userByCompany: `User by company`,
      userDisconnected: `User disconnected!`,
      userLimitReached: `User limit reached!`,
      userLoggedIn: `User logged in!`,
      usersByCompany: `Users by company`,
      userDoesNotHavPermissionToPerform: `User does not have permission to perform this action`,
      usernameHasInvalidCharacters: `The username has invalid characters`,
      usernameIsNotAvailable: `The username is not available!`,
      usernameMustBeFromCharacters: `The username must be from {f} to {l} characters.`,
      users: `Users`,
      userEmail: `User or email`,
      usersOnTheBlacklist: `Users on the Blacklist will not have access to this program!`,
      userRemoved: `User removed`,
      useYourAuthenticationAppToEnterTheCode: `Use your authentication app to enter the code`,
      validatePhone: `Validate phone`,
      validatedPhone: `Validated phone`,
      value: `Value`,
      verified: `Verified`,
      verifieds: `Verified`,
      vpnIP: `VPN IP`,
      waitingConfirmation: `Waiting for confirmation`,
      wantSaveChangesProgram: `Do you really want to save the changes made to this program?`,
      waysExplore: `Ways to Explore`,
      weLeaveThisPanel: `We leave this panel for you to publish your vacancies for our experts`,
      whatIsBugBounty: `What is Bug Bounty`,
      whatIsYourAction: `What is your action?`,
      whatIsNdaHeader: `Pay attention!`,
      whatPrograms: `Which programs?`,
      whatTypeOfVulnerability: `What type of vulnerability reported`,
      whoDoYouWantInvite: `Who do you want to invite?`,
      whiteMessage: `Write a message...`,
      weakPasswordContain: `Weak password! It must contain`,
      websiteInvitation: `Website invitation`,
      weSendAToast: `We send a toast`,
      weAreUnderMaintenance: `We are under maintenance! Come back soon!`,
      weTemporarilyStoreYourReport: `We temporarily store your report data for the program`,
      weWillContactYouShortly: `We will contact you shortly to confirm your details.`,
      wikiSubTitle: `We help how we can and how we can't.`,
      withoutWebAccessTheProgram: `Without Web access, the program will only be available to platform users.`,
      workModel: `Work model`,
      workSchedule: `Work Schedule`,
      yesIWantToRegister: `Yes, I want to register`,
      yes: `Yes`,
      no: `No`,
      youAcceptedThisInvitation: `You accepted this invitation`,
      youAreAboutToVisitLink: `You are about to visit an external link.`,
      youAreAllowedToViewTheReports: `You are allowed to view the reports.`,
      youCanUseOneOfTheseBackupCodes: `You can use one of these backup codes to log in if you lose access to your smartphone. Remember that each code can only be used once.`,
      yourCurrentPlanIsThe: `Your current plan is`,
      youDoNotHaveAnyTagRegistered: `You do not have any Tag registered, to add access the menu <a href="/account?tags">My Account/Tags</a>`,
      youDontHaveAnyAcceptedInvitations: `You don't have any accepted invitations yet!`,
      youDontHaveAnyInvitationsWaiting: `You don't have any invitations waiting for responses yet!`,
      youDontHaveAnyNDAs: `You don't have any Non-Disclosure Agreements yet!`,
      youDontHaveAnyNDAsHacker: `You haven't agreed to any Non-Disclosure Agreements yet!`,
      youDontHaveAnyProgramsInThisCategoryYet: `You don't have any programs in this category yet`,
      youDontHaveSubmittedReports: `You don't have any approved reports yet!`,
      youHaveBeenInvitedToSend: `You have been invited to submit reports to this program`,
      youHavePermissionToViewAndEditReports: `You have permission to view and edit the reports.`,
      youMustAgreeToThe: `You must agree to the`,
      youMustAgreeToTheTermsOfUse: `You must agree to the terms of use.`,
      youMustAgreeToTheTermsOfUseAndCodeOfConduct: `You must agree to the terms of use and code of conduct.`,
      yourAccessPassword: `Your access password!`,
      yourAccesEmail: `Your access email to {0}`,
      youReachedLimit: `You have reached the daily limit for sending reports!`,
      yourEmail: `Your email`,
      yourFullName: `Your full name!`,
      yourNameMustBeBetweenAndCharacters: `Your name must be between {f} and {l} characters!`,
      yourOrganizationNameIsRequired: `Your organization name is required`,
      YourOrganizationTradeName: `Your organization trade name!`,
      yourPassword: `Your password`,
      yourPhoneToGetInTouch: `Phone number to get in touch!`,
      yourProfileIsNowAbleTo: `Your profile is now able to participate in the verification process!`,
      ndaVerificationRequired1: `You have been invited to participate in the program `,
      ndaVerificationRequired2: `Verification of your profile is required to accept this invitation!`,
      ndaVerificationRequired3: `Check your notification list and proceed with the verification process.`,
      noJobsFound: `No jobs found`,
      registrationDone: `Registration done!`,
      reportPaymentVerificationRequired1: `A reward payment for the report `,
      reportPaymentVerificationRequired2: `has been requested!`,
      reportSummaryNotValid: `The report summary is not valid!`,
      reportContentIsNotValid: `The report content is not valid!`,
      reportVulnerabilitIsNotValid: `The vulnerability impact is not valid!`,
      reportCriticalityIsNotValid: `The vulnerability criticality is not valid!`,
      reportCantAcceptEspecialCaracter: `(Special characters are not allowed.)`,
      reportScopeIsNotValid: `The report scope identifier is not valid!`,
      reportIdentifierIsNotValid: `The program identifier is not valid!`,
      reportVulnerabilityIdentifierIsNotValid: `The vulnerability identifier is not valid!`,
      ndaVerificationRequired6: `Complete your profile verification so we can proceed with the reward payment!`,
      reportTitleIsNotValid: `The report title is not valid!`,
      showPassword: `Show password`,
      companyNdaVerificationRequired: `You need to create an NDA for your program before inviting experts!`,
      taxesNotIncluded: `Taxes not included`,
      youAcceptedParticipateInThisProgram: `You have agreed to participate in this program.`,
      youCanCalculate: `You can calculate the severity using the calculator below`,
      youShouldConsiderUsingSeparate: `You should consider using a separate browser or virtual machine before continuing.`,
      yourSecurityPlatformAndBugReward: `Your Bug Bounty platform`,
      youWereInvitedPartOf: `You have been invited to be part of the {0} team. Just enter your account details.`,
      youWillBeRedirectedIn: `You will be redirected in`,
      youWillReceiveReportsFromCommunity: `You will receive reports from security experts in our community at no additional cost, minimizing the risk of your data being exposed or vulnerabilities exploited.`,
      invitationsSummary: `Invitations summary`,
      doubleReward: `Double reward`,
      boostedProgram: `Boosted program!`,
      doubleCampaignNotificationStarted: `Double bonus campaign started`,
      doubleCampaignNotificationClosed: `Double bonus campaign closed`,
      doubleCampaignNotificationPaused: `Double bonus campaign paused`,
      doubleCampaignNotificationResumed: `Double bonus campaign resumed`,
      campSubTitle: `Manage your campaigns! Track all the details.`,
      historicCampaign: `Historic`,
      historicDoubleBounty: `Double bounty`,
      historicDoubleScore: `Double score`,
      inText: `Of`,
      until: `Until`,
      finished: `Finished`,
      in_progress: `In progress`,
      situationCancel: `Canceled`,
      createdTh: `Created in`,
      periodTh: `Period`,
      rewardsTh: `Rewards`,
      situationsTh: `Situations`,
      historicApproved: `Approved`,
      historicCancel: `Canceled`,
      historicPaused: `Paused`,
      historicFinished: `Finished`,
      notificationAttention: `Attention!`,
      notificationYourCampaignHasStarted: `Your campaign has started!`,
      notificationThisCampaign: `This campaign`,
      notificationHasClosed: `has closed`,
      notificationHasBeenPaused: `has been paused`,
      keepAnEyeOutNotification: `keep an eye out`,
      notificationWillLetYouKnowWhenToStartAgain: `we will let you know when to start again.`,
      notificationThisCampaignIsLiveAgain: `This campaign is live again!`,
      finalDate: `End`,
      remain: `Remain`,
      campaignStarted: `The double rewards campaign has started!`,
      campaignClosed: `The double rewards campaign has ended!`,
      campaignPause: `The double rewards campaign has been paused!`,
      campaignReactivated: `The double rewards campaign has been reactivated!`,
      campaignFinalDays: `until the end of the campaign`,
      campaignInitialDays: `until the start of the campaign`,
      dayCampaign: `day`,
      daysCampaign: `days`,
      daysGeneric: `day(s)`,
      btnRegister: `Register`,
      btnLabel: `Select a date`,
      doubleBounties: `Double bounties`,
      doubleScore: `Double score`,
      activeDoubleCampaign: `Boost program`,
      selectAPeriod: `Select a period:`,
      monthlyRanking: `Monthly Ranking`,
      generalRanking: `General Ranking`,
      expertRating: `Check out the BugHunt expert rating`,
      bountyOffer: `You are offering: Double bounties`,
      bountyScore: `You are offering: Double score`,
      bountyAndScoreOffer: `you are offering: Double bounties and Score`,
      closeCampaign: `Close Bonus Campaign`,
      pauseCampaign: `Pause Bonus Campaign`,
      reactivateCampaign: `Reactivate Bonus Campaign`,
      boostCampaign: `Boost program`,
      doubleCheckCampaign: `I am aware of the changes made to this program.`,
      successfullyCreatedCampaign: `Request successfully completed, please wait for campaign approval analysis!`,
      vpnMessage: `There is no vpn enabled in this program.`,
      campaignPaused: `Campaign paused successfully!`,
      doubleCampaignClosed: `Campaign closed successfully!`,
      doubleCampaignResumed: `Campaign resumed successfully!`,
      registeredProgramWarning: `This program already has an approved or closed campaign less than 15 days old.`,
      warningBoutiesOrScore: `The campaign must offer double bounties or score!`,
      invalidDateMessage: `Invalid date, please check if the field has been filled in correctly!`,
      administrator: `Administrator`,
      viewer: `Viewer`,
      analyst: `Analyst`,
      needsInformation: `needs information`,
      retest_done: `Retest done`,
      pending_retest: `Pending retest`,
      notImpact: `Severity not informed`,
      lowImpact: `Low severity`,
      mediumImpact: `Medium severity`,
      highImpact: `High severity`,
      criticalImpact: `Critical severity`,
      approved: `Approved`,
      informative: `Informative`,
      duplicated: `Duplicated`,
      not_applicable: `Not applicable`,
      spam: `Spam`,
      comment: `Post a comment`,
      change_situation: `Change situation`,
      update_severity: `Update severity`,
      request_update: `Request update`,
      retest: `Request retest`,
      pay_bounty: `Pay a reward`,
      close_report: `Close the report`,
      reopen_report: `Reopen the report`,
      needs_information: `Waiting for information`,
      move_to_locker: `Move to the report locker`,
      move_out_of_locker: `Remove from the report locker`,
      under_review: `Under review`,
      triaged: `Triaged`,
      plan_trial: `Trial Plan`,
      plan_bronze: `Bronze Plan`,
      plan_silver: `Silver Plan`,
      plan_gold: `Gold Plan`,
      trial: `Trial`,
      bronze: `Bronze`,
      silver: `Silver`,
      gold: `Gold`,
      fulltime: `Full-time`,
      parttime: `Part-time`,
      clt: `CLT`,
      pj: `PJ`,
      autonomous: `Autonomous`,
      cltflex: `CLT-Flex`,
      cooperative: `Cooperative`,
      internship: `Internship`,
      hybrid: `Hybrid`,
      office: `Office`,
      remote: `Remote`,
      web: `Web Application`,
      api: `API`,
      mobileapplication: `Mobile Application`,
      mobileapplicationandroid: `Mobile Application Android`,
      mobileapplicationios: `Mobile Application IOS`,
      ip: `IP Address`,
      january: `January`,
      february: `February`,
      march: `March`,
      april: `April`,
      may: `May`,
      june: `June`,
      july: `July`,
      august: `August`,
      september: `September`,
      october: `October`,
      november: `November`,
      december: `December`,
      seeOriginalText: `Original text.`,
      waiting_for_information: `Waiting for information`,
      severity_updated: `Severity updated`,
      retest_requested: `Retest requested`,
      bounty_paid: `Bounty paid`,
      close_as_approved: `Close as approved`,
      close_as_informative: `Close as informative`,
      close_as_spam: `Close as spam`,
      close_as_duplicated: `Close as duplicated`,
      close_as_not_applicable: `Close as not applicable`,
      select_option: `Select an option`,
      deleteMessageAlert: `Are you sure you want to delete this message?`,
      automaticMessage: `By selecting the option, the automatic response will be registered as a first interaction in the report.`,
      defaultMessageCenterMenu: `Default Message Center`,
      registerNotFound: `No records were found.`,
      registeredMessageTitle: `Registered Messages`,
      customSettingsTitle: `Custom Settings`,
      customSettingsSubtitle: `Message configuration for standardized responses`,
      addMessageButton: `Add message`,
      existingMessageAlert: `You can only register one message per message type. Currently, all messages are already registered!`,
      editMessage: `Edit Message`,
      registerMessage: `Register Message`,
      placeholderTitleMessage: `Message title`,
      placeholderTextAreaMessage: `Add a description...`,
      labelAutomatic: `Automatic`,
      alertMessageSuccess: `Message registered successfully!`,
      alertMessageUpdate: `Message updated successfully!`,
      swalTokenRemoved: `The token has been successfully deleted.`,
      deleteTokenCompany: `Delete token`,
      placeholderTokenCompany: `Enter a token`,
      errorToken: `The token must contain a minimum of 20 characters and a maximum of 500 characters!`,
      emailNotification: `Email notification has been successfully activated!`,
      enableEmailNotification: `Enable receiving program updates via email.`,
      emailNotificationDisabled: `Email notification has been disabled!`,
      china: `China`,
      india: `India`,
      estadosUnidos: `United States`,
      indonesia: `Indonesia`,
      paquistao: `Pakistan`,
      brasil: `Brazil`,
      nigeria: `Nigeria`,
      bangladesh: `Bangladesh`,
      russia: `Russia`,
      mexico: `Mexico`,
      japao: `Japan`,
      etiopia: `Ethiopia`,
      filipinas: `Philippines`,
      egito: `Egypt`,
      vietna: `Vietnam`,
      repuplicaDemocraticaDoCongo: `Democratic Republic of the Congo`,
      turquia: `Turkey`,
      ira: `Iran`,
      alemanha: `Germany`,
      tailandia: `Thailand`,
      reinoUnido: `United Kingdom`,
      franca: `France`,
      italia: `Italy`,
      tanzania: `Tanzania`,
      africaDoSul: `South Africa`,
      mianmar: `Myanmar (Burma)`,
      coreiaDoSul: `South Korea`,
      colombia: `Colombia`,
      quenia: `Kenya`,
      espanha: `Spain`,
      ucrania: `Ukraine`,
      uganda: `Uganda`,
      sudao: `Sudan`,
      angertina: `Argentina`,
      angelia: `Algeria`,
      iraque: `Iraq`,
      polonia: `Poland`,
      canada: `Canada`,
      uzbequistao: `Uzbekistan`,
      arabiaSaudita: `Saudi Arabia`,
      br: `Portuguese`,
      en: `English`,
      es: `Spanish`,
      fr: `French`,
      it: `Italian`,
      ru: `Russian`,
      de: `German`,
      jp: `Japanese`,
      cn: `Chinese`,
      pl: `Polish`,
      ua: `Ukrainian`,
      sd: `Arabic`,
      kr: `Korean`,
      in: `Hindi`,
      id: `Indonesian`,
      pk: `Urdu`,
      bd: `Bengali`,
      et: `Amharic`,
      ph: `Filipino (Tagalog)`,
      vn: `Vietnamese`,
      tr: `Turkish`,
      ir: `Persian`,
      th: `Thai`,
      za: `Afrikaans`,
      mm: `Burmese`,
      ug: `Swahili`,
      uz: `Uzbek`,
      sa: `Arabic`,
      additionalMoreLanguages: `Add more languages`,
      country: `Country`,
      language: `Language`,
      clearText: `Use default message`,
      selectCountry: `Select a country`,
      basic: `Basic`,
      proficiency: `Proficiency`,
      conversational: `Conversational`,
      fluent: `Fluent`,
      native: `Native or bilingual`,
      AreYouSureYouWantToCompleteTheRequest: `Are you sure you want to complete this request?`,
      managers: `Managers`,
      manageProgram: `Define who will manage your new program.`,
      config: `Settings`,
      programSettings: `Program settings`,
      programEditAlert: `Warning! You cannot edit inactive programs or programs awaiting approval.`,
      changeSettings: `Change settings`,
      managersWithAccesToTheProgram: `Managers with access to the program`,
      freeAccess: `Free access`,
      pendingInviteAlert: `Warning! There is already a pending invitation associated with this email address.`,
      USDT: `Dollar`,
      BRL: `Real`,
      selectCurrencyType: `Select the currency type`,
      passwordSuccess: `Password successfully registered!`,
      isNan: `The value entered must be numeric.`,
      filterScope: `Filter by scope`,
      selectScope: `Select a scope option`,
      filterScopeTitle: `Filter by scope`,
      scopeSelected: `Scope selected`,
      summaryFinancialCard: `Financial summary`,
      summaryTotalCard: `Contributions`,
      summaryTotalPgCard: `Total paid`,
      projectedValueLabel: `Number of months to be projected`,
      totalMonthlyPayments: `Monthly payments`,
      totalManagedServices: `Managed services`,
      totalRewardsPaid: `Rewards paid`,
      monthAndyear: `Month/Year`,
      contribution: `Capital injection`,
      managed: `Management`,
      costProjection: `Cost projection`,
      contributionBalance: `Contribution balance`,
      detailsNF: `Invoice Details`,
      total: `Total`,
      expenseNotification: `Stay in control! Configure notifications for when you reach "70%" of your spending budget.`,
      errorValueBudget: `Enter the budget limit`,
      errorBudgetNotification: `Enter the desired percentage`,
      labelInvalidValue: `Invalid value. Please enter a value between 0 and 100`,
      labelCurrencyValue: `Invalid value: Negative values cannot be entered.`,
      titleBudgetActive: `Limit monthly reward costs`,
      budgetLimitProgram: `The budget limit for this program is`,
      errorBudgetLimit: `Enter the budget limit`,
      invalidValueBudget: `Invalid value: Negative values cannot be entered.`,
      notificationBudget: `Notify when reaching the value of`,
      percentageBudget: `Enter the desired percentage`,
      percentageErrorBudget: `Invalid value. Please enter a value between 0 and 100`,
      pauseProgramBudget: `Pause the program before reaching the total budget?`,
      percentagePauseBudget: `Pause percentage (0-99%)`,
      createCredentialTooltip: `Define credential`,
      confirmBtn: `Confirm`,
      swalCredential: `Credential saved successfully.`,
      labelCredentialForTest: `The credentials for testing the system and the scope of the program`,
      labelCredentialForTestContinued: `are listed below`,
      labelCredentialIndividual: `Individual use. Do not share to ensure your safety.`,
      labelCredentialShared: `Shared use. All experts have the same access.`,
      credentials: `Credentials`,
      confirmPassword: `Confirm Password`,
      confirmPasswordToViewCredential: `Confirm your platform access password to view the `,
      confirmPasswordToViewCredentialContinued: `available credentials`,
      hello: `Hello`,
      doYouHaveCredentials: `you have credentials to use in the systems and scopes that will be tested`,
      manageYourCredentials: `Manage your registered generic credentials to facilitate access for the experts who will be testing your systems`,
      manageYourCredentialsTooltip: `Manage your credentials`,
      credentialPublica: `Generic Credential`,
      credentialPrivate: `Exclusive Credential`,
      credentialPublicaDescription: `The registered generic credentials will be sent to all experts who are participating in the program, in order to be used to perform security tests.`,
      credentialSentToSpecialist: `The registered exclusive credentials will only be sent to the destination specialist`,
      credentialSentToSpecialistContinued: `in order to be used to perform security tests.`,
      request_review: `Request triage review`,
      request_review_report: `requested triage review`,
      reviewRequestedNotification: `Review request`,
      availableCredential: `Available Credential`,
      allActionsAllowed: `Has permission to manage all programs and users.`,
      owner: `Owner`,
      AreYouSureYouWantToUpdateTheUserRole: `Are you sure you want to apply the changes to this user's permissions?`,
      manageCredentials: `Manage registered credentials.`,
      setPublicCredential: `Manage your public credentials`,
      programSpellers: `Program experts`,
      viewCredentials: `View Credentials`,
      informPassword: `Enter your password`,
      credentialDeleted: `Credential deleted successfully!`,
      genericError: `Something went wrong. We are resolving this now. Please try again later.`,
      delete: `Delete`,
      toClose: `Close`,
      labelDeleteCredential: `Are you sure you want to delete this credential?`,
      credentialsTooltip: `Available Credentials`,
      setPasswordExpiration: `Set password expiration`,
      authenticationViaEmail: `Two-factor authentication (2FA) via Email`,
      accessValidation: `Access Validation`,
      invalidCodeError: `The code entered is invalid!`,
      confirmPasswordLabel: `Confirm your platform access password to complete the desired action.`,
      emailAuthenticationInformation: `Increase the security of all accounts by enabling email authentication, protecting user information against unauthorized access.`,
      alertTwoFactory: `<div class="container-two-factory"><p class="two-factory-descrition">To submit a report in this program, you must enable two-factor authentication. Your security is our priority, and this extra layer of protection is essential to ensure the integrity of your account. <span>Follow the setup steps to enable 2-factor authentication now.</span></p></div>`,
      twoFactoryNewUsersContinuation: `will be able to interact with the reports.`,
      restriction: `Restriction`,
      warningTwoFactorAuthentication: `Warning! 2-factor authentication setup required.`,
      labelFeatureTwoFactorAuthentication: `Only managers with Two-factor Authentication can interact with program reports.`,
      labelFeatureTwoFactorAuthenticationHacker: `Only specialists with Two-Factor Authentication can submit new reports for the program.`,
      configureNow: `Configure now`,
      enable2fa: `enabled the requirement to configure two-factor authentication`,
      disable2faSwal: `disabled the requirement to configure two-factor authentication`,
      itWas: `Was`,
      toProgram: `to the program,`,
      translateText: `Translate text`,
      openingDate: `Opening date:`,
      classification: `Classification`,
      confidential: `Confidential`,
      selectProgram: `Select program`,
      swalSuccess: `Change successfully made.`,
      dateDownloadReport: `download`,
      setHallOfFame: `Do you want to activate the hall of fame in your new program?`,
      addHackerToHof: `Do you want to add the expert to the Hall of Fame?`,
      hallOfFame: `Hall of Fame`,
      hallOfFameDoesNotHaveEnoughDataYet: `The Hall of Fame does not have enough specialists yet!`,
      hallOfFameThanksDescription: `would like to thank the following researchers for reporting significant security flaws.`,
      addedAt: `Added at`,
      programByObjective: `Program by objective`,
      programObjective: `Program Objective`,
      nowTellUsLittleObjective: `Now tell us a little about the program's objective!`,
      aGoodObjectiveAvoids: `A well-defined objective avoids problems, if you have any problems consult us.`,
      targetProgram: `Objective`,
      include: `Include`,
      infoTarget: `Warning! It is necessary to inform at least one objective.`,
      aboutTarget: `About the program objective!`,
      setProgramReward: `Set the program reward.`,
      maxProgram: `Attention! A maximum of 10 objectives per program is allowed.`,
      requiredProgram: `Please register an objective for the program.`,
      targetRequired: `Please fill in the program objective.`,
      requiredBounty: `Please enter a value.`,
      idConfirmation: `Almost there! Confirm your identity to proceed with the password change process.`,
      titleTarget: `Objective title`,
      targetPlaceholder: `Program objective title!`,
      titleTargetError: `Please fill in the program objective title.`,
      updateTarget: `Objective updated successfully!`,
      swalTarget: `Please check if the fields are filled in correctly.`,
      areYouSureYouWantToDeleteThisTarget: `Are you sure you want to remove this objective?`,
      removeTargetProgram: `Objective removed successfully!`,
      selectAnObjectiveForTheReport: `What type of objective was reported`,
      informTheTarget: `Inform the objective`,
      selectTheProgramTarget: `Select a program objective!`,
      achievedTheObjective: `Was the program objective achieved?`,
      reachedIn: `Objective achieved in`,
      noObjectivesAvailable: `No objectives available!`,
      removeIn: `removed`,
      achievedIn: `achieved by`,
      pauseProgramSwal: `Program paused due to lack of active objective(s).`,
      cBoostedProgram: `Boosted program`,
      signedAgreements: `Signed agreements`,
      ccpProgObj: `Program by Objective`,
      ccpProgObjDesc: `Create a program with pre-defined objectives, where you choose who can participate and submit reports!`,
      objectiveProgram: `program by objective`,
      publicPrograms: `public programs`,
      privatePrograms: `private programs`,
      objectivePrograms: `objective programs`,
      alertMessageRemoved: `Message removed successfully!`,
      scopeNotFound: `Scope not found.`,
      usernameOrEmail: `Username or E-Mail`,
      aboutTheProgramPolicyHacker: `The rules contained in the program policy must be respected!`,
      jiraIssueType: `What will be the type of activity that will be registered in Jira?`,
      conceded: `conceded`,
      toTheSpecialist: `to the specialist`,
      getToKnow: `Get to know`,
      solutions: `Solutions`,
      contact: `Contact`,
      ourBlog: `Our Blog`,
      doubts: `Doubts?`,
      inTheMedia: `In the media`,
      talkToUs: `Talk to us`,
      understandHowItWorks: `Understand how it works!`,
      managedPrograms: `Managed Programs`,
      vdpPrograms: `VDP Programs`,
      howItWorks: `How it works!`,
      ranking: `Ranking`,
      url: `URL`,
      multipliedScore: `Bonus! Multiplied score`,
      codeOfConduct: `Code of Conduct`,
      and: `and`,
      reportConfidential: `Document classification: Confidential`,
      securitySystem: `Security System`,
      emailAlreadyRegisteredInOurDatabase: `Email already registered in our database`,
      theTokenMustBeEntered: `The token must be entered`,
      actionAlreadyReported: `Action already reported!`,
      statusPauseProgram: `The program has been paused`,
      statusStartProgram: `The program has been reactivated`,
      by: `by`,
      inShort: `in`,
      invalidName: `The name entered is not valid!`,
      includeMoreDetails: `Add more details...`,
      maxTech: `The maximum allowed is 10 technologies per scope.`,
      maxLine: `Please limit the message to a maximum of 10 line breaks.`,
      includeInfoScope: `Enter observations about the scope... `,
      includeTech: `Enter the technologies`,
      editScope: `Edit scope`,
      scopeDetails: `Scope details`,
      minMaxScopeCaracter: `The scope must be between 3 and 40 characters`,
      characters: `Characters`,
      menuLocker: `Report Vault`,
      useCodeEmail: `Use the code received by email`,
      authenticationByEmail: `Authentication via email`,
      accessCredentials: `Access Credentials`,
      safePassword: `Set report vault password`,
      beforeActivating2faAuthentication: `Before setting the vault password, you need to activate your Two-factor authentication.`,
      beforeActivating2faEmailAuthentication: `Before setting the vault password, you need to activate Two-factor authentication (2FA) via Email.`,
      beforeActivatingSafePassword: `Before activating the vault, you need to set the vault password.`,
      cardHeaderSafe: `Report Vault`,
      tryAgain: `Please review the information provided and try again.`,
      btnNext: `Next`,
      btnPrev: `Previous`,
      enableReportVault: `Enable Report Vault`,
      reportVaultSuccessfullyEnabled: `Report vault successfully enabled!`,
      reportMovedToVault: `sent the report to the vault`,
      reportMovedOutOfVault: `removed the report from the vault`,
      userBlockedUntil: `User blocked until`,
      toThe: `at`,
      warningLockerActive: `After activating the 'Report vault', it is not possible to disable this functionality.`,
      reportMovedToTheLocker: `The report has been moved to the report vault.`,
      reportMovedToTheLockerQuestion: `Do you want to be redirected to the vault?`,
      warningAccessCredentials: `Please review the information provided and try again.`,
      receiveCode: `Receive code`,
      accessLocker: `Access the vault!`,
      requestNewCodeEmail: `You can request a new code in`,
      resetPasswordLocker: `Reset vault password`,
      confirmPasswordLocker: `Confirm password`,
      errorCaptcha: `The CAPTCHA was not authorized. Please try again.`,
      rewardsReceivedInReais: `Rewards received in reais`,
      rewardsReceivedInDollars: `Rewards received in dollars`,
      onboardingMenuAccount: `Click on the "My account" menu.`,
      makeYourAccessReportEvenMoreSecure: `Make your access to reports even more secure`,
      toAccessTheVaultEnableTheFollowingSteps: `To access the vault, enable the following steps.`,
      registerPhoneOnboarding: `Register the phone.`,
      activeTwoFactorAuthentication: `Enable Two-factor authentication.`,
      registerPasswordLocker: `Register a password for the vault.`,
      methodAppToken: `Protect access to the vault by receiving the code via app.`,
      methodAppEmail: `Protect access to the vault by receiving the code via email.`,
      methodAppSms: `Protect access to the vault by receiving the code via SMS.`,
      sendToken: `Token sent!`,
      waitToRequestNewToken: `Please wait 5 minutes before requesting a new token.`,
      phoneNotRegistered: `Attention! Phone not registered.`,
      useCodeSms: `Use the code received by SMS`,
      titleEmailTwoAuthentication: `Two-factor authentication (2FA) via Email`,
      updateConfigLocker: `The vault settings have been updated!`,
      swalRegisterPassword: `Password registered successfully!`,
      lockerConfig: `Settings`,
      lockerAccess: `Logs`,
      receiveCodeBySms: `Receive code by SMS`,
      lockerPassword: `Locker password`,
      selectUser: `Select user`,
      selectEvent: `Select event`,
      USER_LOGIN: `Login successful`,
      REPORT_MOVED_TO_LOCKER: `Report moved to locker`,
      REPORT_MOVED_OUT_OF_LOCKER: `Report removed from locker`,
      REPORT_ACCESS: `Report accessed`,
      USER_LOGIN_FAILED: `Failed to access locker`,
      manyRequestTitle: `Too many requests`,
      manyRequestText: `You are sending too many requests in a short period of time. Please try again later.`,
      undestand: `Understood`,
      noRegisterAvailable: `No records available`,
      event: `Event`,
      swalActiveLocker: `The Report Locker has been successfully activated!`,
      swalInactiveLocker: `The report locker has been deactivated!`,
      enterTheCode2fa: `Enter your 2FA code`,
      labelCodeBackup2faLocker: `After downloading the backup code, you will not be able to generate new codes. Be sure to store it in a safe place, as it can be used to disable two-factor authentication (2FA) if necessary.`,
      swalWarningDateText: `Invalid date!`,
      swalWarningDateTitle: `The start date must be before the end date. Please check and try again.`,
      archiveProgram: `Archive program`,
      archive: `Archived`,
      titleProgram: `Program title`,
      statusProgramArchived: `The program has been archived`,
      waitRequestTitle: `Please wait...`,
      waitRequestText: `We are removing all your reports from the report locker.`,
      tooltipLocker: `The Report Locker allows you to securely store critical or old reports, accessible only via extra authentication.`,
      alertInactiveLocker: `Warning: When deactivating the report locker, all stored reports will be permanently removed, returning to the report list without authentication, as it was before the locker was activated.`,
      moveReportToLocker: `To move the report to the locker, make sure it is active.`,
      strongPassword: `Enter a strong password`,
      disableSms: `Disable code via SMS`,
      disableEmail: `Disable code via Email`,
      disable2fa: `Disable two-factor authentication`,
      disableLocker: `Disable report locker`,
      activeLocker: `Activate report locker`,
      archivedProgramTooltip: `When archived, this program will be inactive and unavailable to participants`,
      pauseProgramTooltip: `When paused, the program will be temporarily disabled for all participants.`,
      LOCKER_ACTIVATED: `Activated report locker`,
      LOCKER_DEACTIVATED: `Deactivated report locker`,
      expiredLockerSwal: `Your session has expired. Please log in again to continue.`,
      countrySelectorLabel: `Country code`,
      phoneNumberLabel: `Phone number`,
      examplePhone: `Example:`,
      lockSafe: `Lock locker`,
      remainingTimeTooltip: `Remaining time to lock the locker`,
      statusProgramUnarchived: `The program has been unarchived`,
      budgetActive: `Activate monthly reward costs`,
      alertArchivedProgram: `When archiving the program, it will be paused, moved to the "Inactive" submenu, and participants will lose access, no longer being able to submit reports.`,
      alertReactivateProgram: `When unarchiving the program, it will be moved to the list of active programs, but will remain paused. Participants will still not be able to submit reports until the program is resumed.`,
      privateComment: `This comment will be used to communicate with the specialist.`,
      internalComment: `This comment will only be visible to employees.`,
      authenticationRedirect: `Authentication Redirect`,
      redirectPleaseWait: `Redirecting, please wait.`,
      maximumFilesAuthSSO: `Upload only one file.`,
      replaceFileAuthSSO: `If you need to replace the file, click the "X" icon and upload the new one.`,
      allowedFilesAuthSSO: `Allowed file: .xml`,
      swalTotalDays: `Warning! The number of days must be greater than zero to proceed.`,
      editDomain: `Edit domain`,
      removeDomain: `Delete`,
      activeSSO: `Activate SSO`,
      inactiveSSO: `Deactivate SSO`,
      tooltipSSO: `Access multiple platforms with a single login, in a practical way.`,
      updateConfigSSO: `SSO settings have been updated!`,
      registerDomainSSO: `Domain registered successfully!`,
      domainSuccessfullyRemoved: `Domain removed successfully!`,
      swalYouSure: `Are you sure?`,
      swalWarningInfo: `You will not be able to revert this action!`,
      swalActionCuccessfully: `Your action was performed successfully.`,
      swalActionPerformed: `Action performed!`,
      swalTitleCopy: `Content copied!`,
      swalTextCopy: `The text has been copied to the clipboard.`,
      domainInvalid: `Please enter a valid domain, e.g. company.com`,
      domainIsSame: `This domain is invalid or has already been registered. Please choose another.`,
      tooltipDescriptionSSSO: `With SSO (Single Sign-On), you can access the platform in a practical way, using only one account.`,
      tooltipActiveSSO: `Before proceeding, make sure that the necessary configuration has been completed in your IdP and that at least one domain is registered and validated.`,
      registerSucess: `Registered successfully!`,
      userPoolId: `Use the User Pool ID when configuring your identity provider (IdP).`,
      userPoolDomain: `Use the User Pool Domain when configuring your identity provider (IdP).`,
      placeholderUrlDomain: `Enter the domain (e.g. company.com)`,
      labelURLXml: `Enter the URL of the XML or upload your XML file.`,
      manageDomains: `Manage Domains`,
      configSSO: `SSO Configuration`,
      placeholderUrlXml: `https://yourserver.com/configurations/idp-metadata.xml`,
      attachXMLFile: `Attach XML File`,
      xmlError: `The XML file provided could not be processed. Please check that it is well-formed and meets the expected standards.`,
      swalActionNotPermitted: `Action not permitted`,
      swalOneRegisteredDomain: `You need to have at least one domain registered and validated.`,
      accountNotFound: `Email not found. Please contact your IDP administrator`,
      enabledPasswordExpiration: `Enable password expiration`,
      edit: `Edit`,
      titleRegisterAccountSSO: `It's simple, it doesn't even take 1 minute. Confirm some data and it will be completed in moments.`,
      yourName: `Name`,
      updateXML: `Change the integration XML file`,
      getDownloadXML: `Get XML configuration file`,
      downloadOrUpdatedXML: `Download or modify the IDP integration XML file`,
      titleAttachXML: `Enter the URL or attach the XML configuration file of the IdP`,
      alterXML: `Change`,
      paramsConfigIDP: `IDP Configuration Parameters`,
      enterWithSSO: `Enter with SSO`,
      enterWithoutSSO: `Enter without SSO`,
      titleUrlXML: `Provide the URL of the IdP (Identity Provider) XML file.`,
      copyContent: `Copy`,
      validateDomain: `Validate domain`,
      validated: `Validated`,
      validatedDomain: `Validate your domain within 72 hours so that it is not removed.`,
      titleValidateDomain: `Validate your domain!`,
      swalInfoValidateDomain: `To complete the validation process, register the following variable as a TXT record in the DNS of the domain `,
      swalAfterValidateDomain: ` after registering, click Validate to proceed.`,
      swalValidateSuccess: `Domain validated successfully!`,
      swalErrorValidateDomain: `Error validating domain`,
      swalTryAgain: `check and try again.`,
      swalTitleError: `Unexpected error!`,
      swalTextError: `An error occurred while opening the domain validation. Please try again later.`,
      btnValidated: `Validate`,
      loading: `Loading...`,
      sizeXml: `The maximum allowed file size is 100KB.`,
      pendingPayments: `Pending payments`,
      completedPayments: `Completed payments`,
      attributeEmailSSO: `We ask that you contact your IdP administrator to verify and ensure that the "email" attribute is configured correctly.`,
      emailContentSSO: `Make sure to map the "email" field with the "email" value in your IDP.`,
      emailExSSO: `Example: email: email`,
      textErrorDomain: `All domains of owner users must be registered and validated before proceeding`,
      swalAlertOwner: `It is not possible to delete a domain linked to the owner.`,
      textWarningDisableSSO: `When disabling SSO, all users except "Owner" users will be deactivated from the platform. Reactivation of these users must be done through the "Users" menu. In addition, the "Owner" user will receive an email to reset the password.`,
      requiredRegisterDomain: `It is necessary to register and validate the user's domain.`,
      authenticationControls: `Authentication controls`,
      codeByEmail: `Code by email`,
      enterTheCodeBackup: `Enter your backup code`,
      titleModalBackup2fa: `Backup token`,
      awaitNewToken: `Wait! Soon, you can request a new token.`,
      monthYear: `Month/Year`,
      provision: `Provision`,
      monthly: `Monthly fee`,
      management: `Managed`,
      headerBounty: `Rewards`,
      noDomainRegistered: `No domain registered.`,
      titleSendEmail: `Email sending center`,
      cardPrivateProgram: `Private programs`,
      sendEmailSuccess: `Email sent for analysis!`,
      placeholderMessageEmail: `Type your message here..`,
      placeholderMessageTopic: `Email subject`,
      subTitlePageSendEmail: `Send personalized emails quickly and efficiently to specialists in private programs.`,
      titleCardSelectedProgram: `Selected programs`,
      titleCardHacker: `Specialists`,
      hackerListEmpety: `No specialist available`,
      programListSelectedEmpety: `No program selected`,
      placeholderFilterHacker: `Filter specialist`,
      placeholderFilterProgram: `Filter program`,
      navCustomEmail: `Email sending`,
      controlEmail: `Email manager`,
      noEmailsAvailable: `No email available`,
      rejected: `Rejected`,
      scheduleDate: `Schedule the email sending date`,
      sendForAnalysis: `Send for analysis`,
      removeEmailSuccess: `Email deleted successfully!`,
      areYouSureYouWantToDeleteThisEmail: `Are you sure you want to delete this email?`,
      searchEmail: `Search Email`,
      createEmail: `Create email`,
      editEmail: `Email`,
      emailTopic: `Subject`,
      dateSendEmail: `Scheduled Date`,
      tooltipEditEmail: `Edit Email`,
      tooltipDeleteEmail: `Delete Email`,
      tooltipViewRejectedMessage: `View message`,
      tooltipHiddenRejectedMessage: `Hide message`,
      sentEmail: `Sent`,
      continueEmail: `Continue Email`,
      temporaryEmailStorage: `We temporarily store your email data`,
      yourEmailWillBeAnalyzed: `Your email will be analyzed and, after approval, will be sent on schedule.`,
      hackersSelected: `Selected specialists`,
      checkAllFields: `Check that all fields are filled in!`,
      recipients: `Recipients`,
      emailContent: `Email content`,
      viewEmail: `View email`,
      pentest: `Pentest`,
      pentestCreateSubTitle: `Exciting moment, time to start creating your pentest!`,
      pentestType: `Pentest Type`,
      whitebox: `White Box`,
      blackbox: `Black Box`,
      inclusionInWebApplication: `Inclusion in Web Application`,
      inclusionInMobileApplication: `Inclusion in Mobile Application`,
      loggedArea: `Logged Area`,
      executionPeriod: `Execution date`,
      scheduleDatePentest: `Schedule the date for test execution`,
      limitScopePentest: `Define the scopes to be tested`,
      selectedScopePentest: `Select the scopes for testing`,
      addObsOthersPentest: `Add a general observation..`,
      lblErrorRequiredObs: `Please describe the type of scope.`,
      inPerson: `In Person`,
      applicationLocation: `Application Location`,
      credential_access: `Access credentials`,
      sourceCode: `Source Code`,
      requireFields: `Check the fields highlighted in red and fill them in correctly.`,
      selectedLocalApplication: `Select the application location`,
      selectedOneOption: `Select an option`,
      securityRetest: `Security Retest`,
      settingsPentest: `Environment, tools and scope configuration for secure Pentest execution.`,
      aboutPentest: `Define the purpose of the Pentest, highlighting the risks and vulnerabilities that should be assessed.`,
      swalSendPentest: `Sent for analysis`,
      viewPentest: `View`,
      pentestSubTitle: `Track and manage your pentests on BugHunt.`,
      editPentest: `Pentest Details`,
      swalDeletedPentest: `Deleted successfully!`,
      areYouSureYouWantToDeleteThisPentest: `Are you sure you want to delete this pentest?`,
      wantSaveChangesPentest: `Do you really want to save the changes made to this pentest?`,
      swalUpdatePentest: `Changes made successfully.`,
      scopeListOfThePentest: `Pentest scope list!`,
      summaryAboutPentest: `Summary of the purpose of the Pentest, highlighting the risks and vulnerabilities that should be assessed.`,
      canceled: `Canceled`,
      noPentestAvailable: `No pentest available`,
      requireAtLeastOneProfile: `You must register at least one profile!`,
      profileAlreadyAdded: `This profile has already been added to the list.`,
      insertUserProfile: `Insert User Profile`,
      noProfileAvailable: `No profile available.`,
      enterDate: `Enter a date`,
      testDataProvided: `Data provided for testing`,
      selectAnOption: `Select an option`,
      describeScopeType: `Describe the scope type`,
      addScopeToContinue: `Please add a scope to continue.`,
      about: `About`,
      appPurposeDescription: `Give a brief description of the application's purpose`,
      moreDetailsAboutYourApp: `Tell us more details about your application...`,
      fillAppDetails: `Fill in the application details *`,
      aboutApplication: `About application`,
      criticalApplicationDescription: `This is a critical application, where failures can put lives at risk.`,
      criticalSystemsExamples: `Nuclear power plant, avionics, industrial control and hospital automation systems.`,
      criticalApplicationWarning: `This is a critical application, where failures can put lives at risk.`,
      handlesLargePersonalDataVolumes: `Handles large volumes of personal data.`,
      performsFinancialTransactions: `Performs financial transactions.`,
      paymentsCryptoAssetsSwiftTransactions: `Payments, crypto assets and Swift transactions.`,
      viewersCannotCreatePentest: `Viewer users are not allowed to create pentests!`,
      startDate: `Start date`,
      endDate: `End date`,
      startDateMustBeEqualOrGreaterThanCurrent: `The start date must be equal to or greater than the current date!`,
      briefApplicationPurpose: `A brief description of the application's purpose`,
      totalPentests: `Total Pentests`,
      descriptionWhiteBox: `Simulates a real attack, where the tester has very little or no prior information about the system, assessing the effectiveness of protection measures and response to attacks.`,
      descriptionBlackBox: `Simulates a real attack without prior access to system information, testing external security, the effectiveness of defenses and the response to possible intrusions.`,
      createPentest: `Let's create a pentest?`,
      ssoLoginMethodForOrganizations: `This unique login method for companies that use SSO on BugHunt. If you are not part of an organization with SSO, use the "Enter without SSO" option.`,
      budgetSwal: `Budget updated successfully.`,
      managerSwal: `Managers updated successfully`,
      urlDomain: `Use Redirect URL when configuring your identity provider (IdP).`,
      defineAtLeastOneGoalBeforeReactivating: `Before reactivating the program, define at least one goal!`,
      view: `View`,
      additions: `Additions`,
      removals: `Removals`,
      minLengthUpdateProgram: `The description must contain at least 10 characters!`,
      submitAgreementNotice: `By clicking on "Send for Analysis", you agree to the`,
      ourLabel: `our`,
      confirmReadOur: `and confirm that you have read our`,
      youAgree: `You agree to the`,
      help: `Help`,
      errorUserNameIdp: `Value at 'userName' failed to satisfy constraint: Member must satisfy regular expression pattern: [\p{L}\p{M}\p{S}\p{N}\p{P}]+`,
      causeFormatUserName: `The problem lies in the formatting of the userName attribute that the IdP is sending in the SAML assertion. Cognito is expecting a certain pattern, and the IdP is sending something different.`,
      solutionFormatUserName: `In the IdP, configure attribute mapping to ensure that the required attribute is sent in the SAML assertion and that its value is valid.`,
      causeAttributeEmail: `Cognito is configured to require a specific email attribute, but the IdP is not sending it in the SAML response, or the value sent is not valid for Cognito.`,
      solutionAttributeEmail: `Adjust the mapping of the userName attribute in the IdP so that its value matches the regular expression required by Cognito.`,
      causeCertificate: `The certificate used by the IdP to sign the SAML response has expired, is revoked, or does not match the certificate configured in Cognito. There may also be a problem with the certificate's chain of trust.`,
      solutionCertificate: `Update the certificate in the IdP and Cognito. Ensure that the IdP's certificate is valid and that Cognito trusts it.`,
      causeClocks: `There is a significant time difference (clock skew) between the IdP server and the Cognito servers. SAML defines a validity period for assertions.`,
      solutionClocks: `Synchronize the clocks of the IdP and Cognito servers (using NTP, for example) to minimize the skew.`,
      causeAudienceRestriction: `The AudienceRestriction attribute present in the IdP's SAML assertion does not match the exact Entity ID configured and expected by Cognito. This is to ensure that the assertion is intended for the correct Service Provider (Cognito).`,
      solutionAudienceRestriction: `In the IdP, verify the configuration of the "Audience Restriction" for the SAML client and ensure that it matches the Entity ID of your Cognito User Pool.`,
      causeAssertionSAML: `Cognito has detected that a SAML assertion with the same ID has already been processed. This is a security measure to prevent replay attacks.`,
      solutionAssertionSAML: `Generally, it is not a configuration error. It may be a browser cache problem, multiple submissions of the same request, or a malicious attempt. Clearing the user's browser cache and cookies may help.`,
      causeMalformed: `The SAML response sent by the IdP is not a valid SAML XML, is corrupt, or there is a problem with its encoding/compression.`,
      solutionMalformed: `Inspect the raw XML of the SAML response using a SAML Tracer to identify syntax or structure problems. Check the IdP logs for internal errors in generating the SAML response.`,
      causeSAMLAssertion: `Cognito is configured to require that SAML assertions be digitally signed, but the IdP is sending them unsigned.`,
      solutionSAMLAssertion: `Configure the IdP to digitally sign the SAML assertions it sends to Cognito.`,
      causeRelayState: `The RelayState parameter, used in login flows initiated by the Service Provider (SP-Initiated) to redirect the user after authentication, is missing or has been changed during communication.`,
      solutionRelayState: `Check if there is any proxy or firewall that is changing the redirect URL. In some cases, it may be a configuration problem in the IdP or in the application that initiates the flow.`,
      suspendedAccount: `Your account will be temporarily suspended from`,
      termsAcceptWithSuccess: `Terms accepted successfully!`,
      scopeRequired: `Required field. A scope must be defined beforehand.`,
      unsolicited: `Not requested`,
      author: `Author`,
      authorName: `Author name`,
      sent_at: `Sent at`,
      updatedAt: `Last updated`,
      closed_at: `Closed at`,
      bounty_value: `Bounty value`,
      company_bounty_status: `Company bounty status`,
      company_bounty_payment_date: `Company bounty payment date`,
      hacker_bounty_status: `Status of the payment transfer to the expert`,
      hacker_bounty_payment_date: `Payout date`,
      weakness: `Weakness`,
      tags: `Tags`,
      createdAt: `Creation date`,
      current: `Current`,
      campaign: `Campaign`,
      suggestedValue: `The value must be greater than or equal to the suggested value.`,
      needsValueInformed: `The value must be informed!`,
      reportYithActiveCampaign: `Report sent while the campaign was active`,
      doubleScore: `Double score`,
      doubleScoreAndBounty: `Rewards and double score`,
      warningFinalDate: `The end date must be later than the start date.`

      //translation_script_end_en
    }),

    new MLanguage("spanish").create({
      ln: "es",
      //translation_script_start_es
      agreementText: `¿Está de acuerdo con los términos del acuerdo de confidencialidad?`,
      agree: `De Acuerdo`,
      doNotAgree: `No Estoy de Acuerdo`,
      programWithNda: `¡Este programa tiene un NDA adjunto!`,
      ndaAccepted: `¡NDA aceptado!`,
      programWithoutNda: `¡Este programa aún no tiene un NDA adjunto!`,
      menuProgram: `Programas`,
      menuReport: `Informes`,
      menuAccount: `Mi Cuenta`,
      navInvitations: `Invitaciones`,
      navPayments: `Pagos`,
      navCreateNda: `Crear una Plantilla de NDA`,
      navEditNda: `Editar NDA`,
      navPrograms: `Todo`,
      navPublished: `Publicados`,
      navClosed: `Inactivos`,
      navNda: `NDAs`,
      navAll: `Todos`,
      navPending: `Pendiente`,
      navRetest: `Reanálisis`,
      dashTitle: `¡Bienvenido {0}!`,
      dashSubTitle: `Una visión general y acceso rápido a su cuenta solo para usted`,
      dashReportResolv: `Informes aprobados`,
      navAverage: `Promedio de Recompensas`,
      dashMsgYouHave: `Usted tiene`,
      dashMsgYouDHave: `Usted no tiene`,
      msgProgramPu: `¡programas públicos!`,
      msgProgramPr: `¡programas privados!`,
      dashMsgGP: `Administra tus programas.`,
      dashMsgCP: `¿Registrar un programa ahora?`,
      dashInvTitle: `¡Invita a Expertos!`,
      dashInvSubTitle: `Invita a expertos a participar en tus programas.`,
      dashPayTitle: `¡Pagos!`,
      dashPaySubTitle: `Resumen financiero y solicitudes de pago.`,
      dashNdaTitle: `¡Acuerdos de Confidencialidad!`,
      dashNdaSubTitle: `Gestiona los acuerdos de confidencialidad de tus programas.`,
      addAcomment: `Agregar un comentario`,
      addExpertToBlacklist: `Agregar experto a la lista negra`,
      addTheScopesHere: `¡Agrega los scopes aquí!`,
      addOutOfScopesHere: `¡Agrega aquí las aplicaciones que deben evitarse durante las pruebas de seguridad!`,
      addYourPayPalAccount: `Agrega tu cuenta de PayPal`,
      adjustedTheImpactTo: `Ajustado el impacto a`,
      adjustedTheImpactFrom: `Ajustado el impacto de`,
      adjustMetrics: `Ajustar métricas`,
      allowedFiles: `Archivos permitidos: videos, imágenes y archivos de texto .jpg .jpeg .png .txt .rar .zip .7z`,
      alreadyHaveAccount: `¿Ya tienes una cuenta?`,
      accepted: `Aceptado`,
      acceptThisInvitation: `¡Acepta esta invitación!`,
      access: `Historial de acceso`,
      accessControl: `Control de acceso`,
      accessMyAccount: `¡Accede a mi cuenta!`,
      accessProfile: `Acceder al perfil`,
      accessInformation: `Información de acceso`,
      accountCreatedSuccessfully: `¡Cuenta creada con éxito!`,
      accountDeleted: `Cuenta eliminada`,
      accountRecovery: `Recuperación de cuenta`,
      accurate: `Verificado`,
      activate: `Activar`,
      activated: ` activado`,
      additionalServices: `Servicios adicionales`,
      addOtherRewardsHere: `¡Agrega otras recompensas aquí!`,
      addToBlacklist: `Añadir a la lista negra`,
      agreementSpecialists: `Especialistas en acuerdo`,
      ago: `Hace {0}`,
      aGoodPolicAvoids: `Una buena política evita problemas, si tienes algún problema contáctanos.`,
      all: `Todos`,
      gatTagOptDescription: `Solo los informes que contienen la etiqueta GAT`,
      gatTagDescription: `¿Qué informes se enviarán a la plataforma GAT?`,
      allowMobileAccess: `Permitir accesos por teléfono celular`,
      allowedToPayReward: `Tienes permiso para pagar recompensas.`,
      allThePrograms: `Todos los programas`,
      allStatus: `Todos los estados`,
      aLowercaseLetter: `una letra minúscula`,
      anEmailContainingPasswordReset: `Se ha enviado un correo electrónico con instrucciones para restablecer la contraseña.`,
      aNewValidationEmailHasBeenSenToYou: `Se le ha enviado un nuevo correo electrónico de validación, por favor revise su buzón de correo`,
      aNewSuperStrongPassword: `¡Una nueva contraseña súper fuerte!`,
      annotation: `Nota`,
      aNumber: `un número`,
      anUppercaseLetter: `una letra mayúscula`,
      thePasswordMustHave: `La contraseña debe tener`,
      anyQuestionsAboutIntegration: `¿Preguntas sobre esta integración?`,
      application: `Aplicación`,
      applicableReport: `Informe aplicable`,
      approveWithoutRetest: `¿Realmente quieres cerrar el informe como aprobado antes de solicitar una nueva prueba?`,
      approveRetest: `Aprobar nueva prueba`,
      approvedRetest: `Aprobada la nueva prueba`,
      areYouSureYouWantToDeleteThisUser: `¿Estás seguro de que quieres eliminar a este usuario?`,
      as: `como`,
      aSuperStrongPasswordNow: `¡Una contraseña súper fuerte ahora!`,
      atBugHuntYouWillFindPrograms: `En BugHunt encontrarás programas para probar diferentes tipos de tecnologías, pon en práctica tus conocimientos, probando aplicaciones reales de forma ética y legalizada.`,
      attention: `¡Atención!`,
      atLeastCharacters: `al menos 6 caracteres`,
      authentication: `Autenticación`,
      averageTicket: `Ticket medio`,
      average_time_to_bounty: `Tiempo promedio para pagar una recompensa`,
      average_time_to_first_response: `Tiempo promedio para la primera respuesta`,
      average_time_to_resolution: `Tiempo promedio para cerrar el informe`,
      averageTimeToBounty: `Tiempo promedio de pago`,
      avgTimeToBounty: `El tiempo promedio transcurrido desde la primera interacción de la empresa con un informe hasta la solicitud de pago de una recompensa.`,
      avgTimeToFirstResponse: `El tiempo promedio transcurrido desde el envío del informe hasta la primera interacción de la empresa con un informe.`,
      avgTimeToResolution: `El tiempo promedio transcurrido desde la apertura de un informe hasta su cierre.`,
      avgTimeToBunty: `Tiempo promedio entre la solicitud y la efectivización del pago.`,
      awaitingAcceptance: `Esperando aceptación`,
      awaitingPayment: `Esperando el pago`,
      paymentReceived: `Pago recibido`,
      awaitingResponse: `Esperando respuesta`,
      award: `Premiación`,
      backupCodesLeft: `Códigos de respaldo restantes`,
      balance: `Balance`,
      basedLast90Day: `Basado en los últimos 90 días`,
      beforeActivatingTwoFactorAuthentication: `Antes de activar la autenticación de dos factores, debes validar tu teléfono.`,
      beforeContinuingYouNeed: `¡Antes de continuar, debes validar tu correo electrónico!`,
      billingCreditCard: `Tarjeta de crédito de facturación`,
      billingForms: `Formularios de facturación`,
      billingInformation: `Información de facturación`,
      byActivatingTheProgramSpecialistsWill: `Al activar el programa, ¡los especialistas podrán enviar nuevos informes!`,
      byPausingTheProgramExpertsWill: `Cuando pauses el programa, ¡los especialistas ya no podrán enviar nuevos informes!`,
      bounty: `Financiero`,
      bountyAwarded: `Recompensa otorgada`,
      bugBountyAndTheSecurityParadox: `Bug Bounty y la paradoja de la seguridad`,
      bugHuntIsTheFirstBrazilianBugBounty: `<b>BugHunt</b> es la primera plataforma brasileña de Bug Bounty, y ahora se está asociando con <b>AME Digital</b> con el propósito de democratizar el acceso a la seguridad de la información y, por lo tanto, hacer de Internet un lugar más seguro.`,
      bugHuntIsTheFirstBrazilianBugBountyAvenue: `<b>BugHunt</b> es la primera plataforma brasileña de Bug Bounty, y ahora se está asociando con <b>Avenue</b> con el propósito de democratizar el acceso a la seguridad de la información y, por lo tanto, hacer de Internet un lugar más seguro.`,
      ongoingProfileVerification: `¡Tu perfil está siendo verificado!`,
      cancel: `Cancelar`,
      cannotEnterEqualScopes: `No es posible introducir scopes iguales`,
      cannotEnterSpecialCharacters: `No es posible introducir caracteres especiales`,
      cautionNDA1: `Al redactar el NDA de tu empresa, asegúrate de que incluya los siguientes elementos:`,
      cautionNDA2: `contener al menos una cláusula penal en caso de incumplimiento;`,
      cautionNDA3: `informar a las partes que asumen ese compromiso;`,
      cautionNDA4: `contener una fecha de vencimiento;`,
      cautionNDA5: `detallar específicamente a qué se refiere ese NDA, ya que la información genérica y ambigua descaracteriza el documento legal;`,
      cautionNDA6: `Utilice la etiqueta `,
      cautionNDA7: `para referirse al nombre del especialista;`,
      cautionNDA8: `La plantilla de NDA a continuación es ilustrativa. Asegúrese de ingresar correctamente los datos de su empresa al redactar el acuerdo de confidencialidad`,
      changeAccessPassword: `Cambiar contraseña de acceso`,
      changePassword: `Cambiar la contraseña`,
      changePermission: `Cambiar permiso`,
      changedReportSeverity: `Gravedad del informe cambiada`,
      changedReportStatus: `Estado del informe cambiado`,
      changedTheStatusFrom: `cambió el estado de {f} a {l}`,
      changedTheSituationTo: `cambió la situación a {0}`,
      changedTheTitleOf: `cambió el título del informe de {f} a {l}`,
      changedTheTitleTo: `cambió el título del informe a {0}`,
      changedTheVisibilityOf: `cambió la visibilidad de {f} a {l}`,
      changedTheVisibilityTo: `cambió la visibilidad a {0}`,
      checkOutAllFieldsHighlightedInRed: `¡Revisa todos los campos resaltados en rojo!`,
      chooseANicknameYoursAlone: `¡Elige un apodo que sea solo tuyo!`,
      city: `Ciudad`,
      clickHereToLearn: `Aprende más.`,
      clearData: `Limpiar datos`,
      clearlyDefine: `Define claramente tu política del programa.`,
      close: `Cerrar`,
      closed: `Cerrado`,
      closedAgo: `Cerrado hace {0} días`,
      closedIn: `Cerrado en`,
      closedReport: `Informe cerrado`,
      closedReports: `Informes cerrados`,
      closedTheReportAs: `cerró el informe como`,
      reopenedTheReport: `reabrió el informe`,
      code: `Código`,
      conclude: `Concluir`,
      connectionDenied: `Conexión denegada`,
      connectionTime: `Tiempo aproximado de conexión`,
      connectionRefusedUserDisabled: `¡Conexión rechazada, usuario desactivado!`,
      connectionsPerUser: `Conexiones por usuario`,
      contacts: `Contactos`,
      company: `Empresa`,
      completed: `Completados`,
      confirm: `¡Confirmar!`,
      confirmAccountRemoval: `Confirmar Eliminación de Cuenta`,
      confirmYourPassword: `¡Confirma tu contraseña!`,
      token2fa: `Ingrese el token de autenticación de 2 factores`,
      confirmProgramChanges: `Describe los cambios realizados en el programa`,
      congratulationsYourUsernameIsNowVerified: `Felicitaciones, ahora su usuario está verificado.`,
      invalidEmail: `Correo electrónico no válido, verifique e intente nuevamente.`,
      continueReport: `Continuar Informe`,
      copiedId: `Id copiado`,
      copyLink: `Copiar enlace`,
      continue: `Continuar`,
      creatAccountInvit: `Creó la cuenta a través de la invitación`,
      createA: `Crear un`,
      created: `¡Creado!`,
      createMyAccount: `¡Crear mi cuenta!`,
      critical: `Crítico`,
      request_response: `Respuesta`,
      request_closure: `Cierre`,
      responseRequestReport: `solicitó una respuesta para este informe.`,
      reportClosureRequest: `solicitó el cierre de este informe.`,
      day: `día`,
      days: `días`,
      dateTime: `Fecha/Hora`,
      declined: `Rechazado`,
      dataChanged: `¡Datos modificados!`,
      dataWillBeRemovedWithPhoneValidation: `Al desactivar el teléfono, los datos de 2FA se eliminarán automáticamente.`,
      date: `Fecha`,
      declineThisInvitation: `¡Rechazar esta invitación!`,
      delimitDomains: `Delimitar dominios, subdominios, aplicaciones y más`,
      delimitItems: `Delimitar elementos`,
      deleteUser: `Eliminar usuario`,
      depositedAmount: `Total de Aportes`,
      delimitationOfDomainsSubdomains: `Delimitación de dominios, subdominios, aplicaciones y otros`,
      describeALittleMoreAboutTheImpact: `¡Describe un poco más sobre el impacto!`,
      describeChangesMadeInProgram: `¡Este resumen estará disponible para todos los expertos que participan en este programa!`,
      describeClearlyHowTheVulnerabilityWorks: `Describe claramente cómo funciona la vulnerabilidad.`,
      describeInDetailTheImpactOfThisRepor: `Describe en detalle el impacto de este informe.`,
      describeThePerformedTests: `Describe las pruebas realizadas`,
      describeTheTitleOfTheReport: `Describe el título del informe`,
      describeTheScope: `¿Cuál es la URL de la aplicación vulnerable?`,
      description: `Descripción`,
      descriptionSubmitReport: `##### 1. Resumen \n(añadir resumen de la vulnerabilidad)\n\n##### 2. Descripción\n(añadir más detalles sobre esta vulnerabilidad)\n 1. [añadir paso]\n\n##### 3. Pasos para reproducir\n(Añadir detalles sobre cómo podemos reproducir el problema)\n 1. [añadir paso]\n 2. [añadir paso]\n 3. [añadir paso]\n\n##### 4. Material de apoyo / referencias\n(por ejemplo, capturas de pantalla, registros, etc.)\n 1. Liste cualquier material adicional\n `,
      descriptionCannotContainSpecialCharacters: `La descripción no puede contener caracteres especiales`,
      descriptionMustBeFromToCharacters: `La descripción debe tener de {f} a {l} caracteres.`,
      describeEditsMade: `Describe las ediciones realizadas.`,
      details: `Detalles`,
      directoryName: `Nombre del directorio`,
      disable: `Desactivar`,
      domain: `Dominio`,
      done: `Hecho`,
      doNotUseSpecialCharactersAndMalicious: `No utilice caracteres especiales y payloads maliciosos en el título, el impacto y el resumen, estos elementos deben adjuntarse como .zip, .rar o .7z al final del informe.`,
      doNotUseSpecialCharacters: `No envíe payloads con posibles códigos maliciosos, ¡estos elementos deben adjuntarse como .zip, .rar o .7z!`,
      dontForgetToSaveYourChanges: `¡No olvide guardar los cambios!`,
      downloadTheReportPDF: `Descargar el informe en PDF`,
      doYouHaveOrganizationAndDidYou: `¿Le gustaría proteger su empresa?`,
      doYouWantToRemoveThePhone: `Eliminar teléfono`,
      doyoureallyWanttoDeleteVacancy: `¿De verdad quiere eliminar esta vacante?`,
      doYouReallyWantToRemoveTwoFactor: `Eliminar la autenticación de dos factores`,
      doYouReallyWantToRemoveThisAccount: `¿De verdad quiere eliminar esta cuenta?`,
      doYouReallyWantToRemoveThis: `¿De verdad quiere eliminar este {0}?`,
      doYouWantToActivateTheProgram: `¿Desea activar el programa?`,
      doYouWantToContinue: `¿Desea continuar con los campos ya cumplimentados?`,
      doYouWantDisableProgram: `¿Desea desactivar el programa?`,
      doYouWantToPauseTheProgram: `¿Desea pausar el programa?`,
      doYouWantToAddVPNToYourNewProgram: `¿Desea añadir VPN a su nuevo programa?`,
      editProgram: `Editar programa`,
      editNda: `Editar NDA`,
      eligible: `Elegible`,
      efficiencyMetrics: `Métricas de eficiencia`,
      emailAlreadyRegistered: `El correo electrónico ya está registrado`,
      emailAlreadyValidatedNonExistent: `¡Correo electrónico ya validado o expirado!`,
      emailConfirmation: `Confirmación de correo electrónico`,
      emailDoesNotAppearToBeValid: `El correo electrónico no parece ser válido`,
      emailSuccessfullyValidated: `¡Correo electrónico validado con éxito!`,
      enableTwoFactorAuthentication: `Habilitar la autenticación de dos factores`,
      end: `Final`,
      enterNewTags: `Introduzca nuevas etiquetas separándolas por comas`,
      enterPasswordConfirmation: `Introduzca la confirmación de la contraseña`,
      enterTheCode: `Introduce el código`,
      enterTheCodeReceivedBySms: `Introduce el código recibido por SMS`,
      enterTheCompletePhone: `Introduce el número de teléfono completo`,
      enterTheDescriptionOfTheOrganization: `Introduce la descripción de la organización`,
      enterTheEmail: `Introduce el correo electrónico`,
      enterTheNameOfTheOrganization: `Introduce el nombre de la organización`,
      enterThePassword: `Introduce la contraseña`,
      enterTheUsername: `Introduce el nombre de usuario`,
      enterTheScope: `¡Introduce el alcance del programa!`,
      enterUserName: `Introduce el nombre de usuario`,
      enterYourEmail: `Introduce tu correo electrónico`,
      enterYourFullName: `Introduce tu nombre completo`,
      enterYourPayPalAccountEmail: `Introduce el correo electrónico de la cuenta PayPal`,
      enterYourPrimaryEmailAddress: `¡Introduce tu dirección de correo electrónico principal!`,
      enterYourUserPassword: `Introduce tu contraseña de usuario`,
      enterYourRewardDetails: `¡Introduce los detalles de la recompensa!`,
      evaluate_retest: `Evaluar reanálisis`,
      evaluatedRetest: `Reanálisis evaluado`,
      executiveSummary: `Resumen ejecutivo de la organización`,
      exit: `Salir`,
      expertSuccessfullCreated: `Experto {0} creado con éxito`,
      export: `Exportar`,
      exportLogs: `Exportar registros`,
      exportInCsv: `Exportar en .csv`,
      exportReports: `Exportar informes`,
      externalLinkNotice: `Aviso de enlace externo`,
      extract: `Extracto`,
      extractedBy: `Extraído por`,
      fillInTheDetailsBelowTo: `Rellene los detalles a continuación para cambiar su contraseña.`,
      fillInAllFieldHighlightedInRed: `¡Rellene todos los campos resaltados en rojo!`,
      filterByTags: `Etiquetas`,
      findSecurityJobsOnOurDashboard: `BugHunt conectando a la comunidad con las mejores empresas.`,
      forgotYourPassword: `¿Olvidaste tu contraseña?`,
      forSecurityWeRequestYourPassword: `Por seguridad, solicitamos su contraseña para esta operación.`,
      forYourSecurityToPDF: `Para su seguridad, es necesario añadir una contraseña al PDF.`,
      fullName: `Nombre completo`,
      generateNewCodes: `Generar nuevos códigos`,
      getAccessToExclusiveRewards: `¡Ten acceso a recompensas exclusivas de este programa!`,
      gift: `Regalo`,
      giftsAndAcknowledgments: `Regalos y Agradecimientos`,
      guests: `Invitados`,
      hackerControl: `Control de Hackers`,
      haveYouRevised: `¿Has revisado tu modelo? ¡Entonces está listo!`,
      haveYouReviewedYourReportNow: `¿Has revisado tu informe? ¡Entonces está listo, vamos a enviarlo para análisis!`,
      here: `aquí`,
      hereYouCanSetUpYourAccount: `Aquí puedes configurar tu cuenta para recibir tus recompensas.`,
      high: `Alto`,
      historic: `Histórico`,
      features: `Funcionalidades`,
      iAlreadyHaveAnSccount: `¡Ya tengo una cuenta!`,
      iAlreadyRemembered: `¡Ya lo recordé!`,
      iAgreeWithThe: `Estoy de acuerdo con los `,
      ifYouDontReceiveIt: `Si no lo recibes, puedes intentarlo de nuevo en`,
      ifYouNeedToSubmitMoreComment: `Si necesitas enviar más, solo escribe otro comentario`,
      impact: `Impacto`,
      impactDescriptionCannotContainSpecialCharacters: `¡La descripción del impacto no puede contener caracteres especiales!`,
      inactivated: ` desactivado`,
      inactiveUsers: `Usuarios inactivos`,
      initProgramMessage: `Programa iniciado el `,
      informBugHuntPassword: `Informe la contraseña de la plataforma BugHunt para confirmar esta operación.`,
      informThePhoneWithAreaCode: `Informe el teléfono con código de área`,
      informTheRecommendations: `Informe las recompensas que el experto obtendrá si tiene éxito.`,
      informTheScope: `Informe el alcance`,
      informTheScopeWhereTheThreatsAre: `Informe el alcance donde están las amenazas`,
      selectTheScopeType: `Seleccione el tipo de alcance inspeccionado`,
      informTheImpact: `Informe el impacto`,
      informTheUser: `Informe al usuario`,
      informTheWebsite: `Informe el sitio web`,
      interationIdealTime: `El tiempo promedio ideal para {interationType} es de `,
      interviewWithExpertIgorRincon: `Entrevista con el experto Igor Rincon`,
      invalidBackupCodeOrToken: `Código o token de respaldo inválido`,
      invalidCode: `Código inválido`,
      invalidCodeOrToken: `Código o token inválido`,
      invalidDate: `Fecha inválida`,
      invalidData: `Datos inválidos`,
      invalidRegistrationData: `¡Datos para registro {0} inválidos!`,
      invalidEmailOrPassword: `¡Correo electrónico o contraseña inválidos!`,
      invalidPassword: `Contraseña inválida`,
      invite: `Invitar`,
      invitationAccepted: `Invitación aceptada`,
      invitationDeclined: `Invitación rechazada`,
      invitationLimitManagersReached: `Se ha alcanzado el límite de invitaciones para gestores.`,
      invitationProgramLimitReached: `Se ha alcanzado el límite de invitaciones del programa {program}.`,
      invitationNotFoundOrExpired: `¡Invitación no encontrada o expirada!`,
      invitationsAccepted: `Invitación aceptada`,
      invitationsReceived: `¡Invitaciones Recibidas!`,
      invitationRevoked: `Invitación revocada`,
      invitationSent: `Invitación enviada`,
      invoiceValue: `Total de la factura`,
      NdaCreated: `NDA creado`,
      inProgress: `En curso`,
      inRelationToTheReport: `Referente al informe`,
      inSomeCasesTheEmailMayFallAsSpam: `En algunos casos, el correo electrónico puede considerarse spam.`,
      integration: `Integración`,
      integrations: `Integraciones`,
      integrationsNotAvailable: `¡Integraciones no disponibles!`,
      inTheProgram: `en el programa`,
      internal: `Interno`,
      invoices: `Facturas`,
      iPAdress: `Dirección IP`,
      issued: `Emitido`,
      itHappensInTheBestFamilies: `¡Sucede en las mejores familias! No te preocupes, solo introduce tu correo electrónico y te enviaremos una nueva contraseña.`,
      itHappensInTheBestFamiliesDonotworry: `¡Sucede en las mejores familias! No te preocupes.`,
      itIsNotPossibleToEnterEqualRewards: `¡No es posible insertar recompensas iguales!`,
      itIsNotPossibleToEnterMore: `¡No es posible insertar más de 30 etiquetas!`,
      itIsNotPossibleToSubmitAnotherRetest: `No fue posible enviar la evaluación de la nueva prueba.<br /> Espere a la nueva prueba del experto.`,
      iWantToCreateAnAccount: `¡Quiero crear una cuenta!`,
      jobBoard: `Bolsa de Trabajo`,
      jobDescription: `##### Sobre la Empresa \n Describa aquí los detalles sobre su **empresa**\n \n ##### Sobre la Vacante\n Estamos buscando un Profesional cuyas principales responsabilidades serán:\n - Responsabilidad 1.\n - Responsabilidad 2.\n - Responsabilidad 3.\n \n ##### Requisitos\n - **Requisito 1:** Más de x años de experiencia.\n - **Requisito 2:** Más de x años de experiencia.\n - **Requisito 3:** Más de x años de experiencia.`,
      jobTitle: `Título del puesto`,
      joinedThePlatform: `Se unió a la plataforma`,
      lastReviewSubmittedAgo: `Última revisión enviada hace {0}`,
      lastInvitations: `Últimas invitaciones enviadas`,
      last7daysOfAccess: `Últimos 7 días de acceso`,
      latestReports: `Últimos informes`,
      letStartYourRegistrationAnd: `¡Comencemos su registro y pronto nos pondremos en contacto con usted para aclarar cualquier duda y finalizar su registro!`,
      letsCompleteYourRegistration: `¡Completemos su registro!`,
      letsCreateYourAccount: `¡Creemos su cuenta!`,
      letsCreateYourPreRegistration: `¡Creemos su pre-registro!`,
      lessThanMonthAgo: `hace menos de un mes`,
      like: `como`,
      limitScope: `¡Delimite el alcance y solo los accesos que serán recompensados!`,
      limitOutOfScope: `¿Qué aplicaciones no deben probarse?`,
      limitOfScopesPerProgramReached: `¡Límite de {0} alcances por programa alcanzado!`,
      linkToJob: `Enlace a la vacante`,
      location: `Localidad`,
      longPeriodsImpactSpecialists: `Los largos períodos de espera pueden afectar el compromiso de los especialistas en este programa.`,
      low: `Bajo`,
      makePayment: `Realizar un pago`,
      makeAPayment: `Realizar un Pago`,
      makeSureYouHaveACompatibleAppLike: `Asegúrese de tener una aplicación compatible como `,
      makeYourAccessEvenMoreSecure: `Haga que su acceso sea aún más seguro`,
      manageAccess: `Administre quién tiene acceso al programa.`,
      managementInvitations: `Gestión de invitaciones recibidas.`,
      manageVPNforUsers: `Administre la VPN de los usuarios de cada programa`,
      manageYourPlanInformation: `Administre la información de su plan.`,
      manageYourProgressPlatform: `Administre su progreso en la plataforma BugHunt`,
      maximumLengthIsCharacters: `La longitud máxima es de {0} caracteres`,
      maximumFilesPerComment: `El máximo es de 10 archivos por comentario`,
      medianTimeToResolution: `Tiempo medio para la resolución`,
      medianTimeToFirstResponse: `Tiempo medio hasta la primera respuesta`,
      medium: `Medio`,
      metricDoesNotHaveEnoughDataYet: `No hay suficientes datos para calcular esta métrica todavía`,
      metricsDoesNotHaveEnoughDataYet: `Aún no hay suficientes datos para calcular las métricas`,
      message: `Mensaje`,
      messagePostedAgo: `mensaje publicado hace {time}`,
      messagePublishedDay: `mensaje publicado el día {day}`,
      missedResponseTargetsReportsSent: `Respuestas enviadas por encima del tiempo esperado`,
      missedResponseTargetsResolved: `Resolución de informes por encima del tiempo esperado`,
      missedResponseTargetsBounty: `Pagos realizados por encima del tiempo esperado`,
      monthlyFee: `Cuota mensual`,
      monthlyPayment: `Mensualidad`,
      moreOptions: `Más opciones`,
      money: `Dinero`,
      myPlan: `Mi Plan`,
      myBusiness: `Mi empresa`,
      nameChanged: `¡Nombre cambiado!`,
      nameOfAccountHolder: `¡Nombre del titular de la cuenta!`,
      nameIsNotValid: `El nombre no es válido`,
      navigation: `Navegación`,
      needChangeDescription: `Utilice la plantilla para hacer una descripción detallada.`,
      ndaVerificationRequired: `¡Su perfil es elegible para participar en el proceso de verificación!`,
      ndaChange: `Cambio de NDA`,
      next: `Próximo`,
      new: `Nuevo`,
      newComment: `Nuevo comentario`,
      newUsers: `Nuevos usuarios`,
      newPassword: `Nueva contraseña`,
      newPasswordAndConfirmation: `¡La nueva contraseña y la confirmación no coinciden!`,
      newReport: `Nuevo informe`,
      none: `Ninguno`,
      noActivePrograms: `Ningún programa activo`,
      noInvitationAvailable: `Ninguna invitación disponible`,
      noNotificationsAvailable: `Ninguna notificación disponible`,
      noPaymentsFound: `Ningún pago encontrado`,
      noProgramAvailable: `Ningún programa disponible`,
      noReportsFound: `Ningún informe encontrado`,
      noScopeAvailable: `Ningún alcance disponible!`,
      noSuggestionsAvailable: `Ninguna sugerencia disponible`,
      noteValue: `Valor de la Nota`,
      notAvailableForThisPlan: `¡No disponible para este Plan!`,
      notAuthorized: `¡No autorizado!`,
      shutdownRequested: `¡Ya se ha solicitado el cierre de este informe!`,
      replyNotificationTitle: `Solicitud de respuesta`,
      closingRequestTitle: `Solicitud de cierre`,
      replyRequestMessage: `¡Ya se ha solicitado una respuesta para este informe!`,
      notificationResponseReport: `¡Atención! Se ha solicitado una respuesta para este informe.`,
      shutdownNotificationMessage: `¡Atención! Se ha solicitado el cierre de este informe.`,
      notificationSeeRequest: `Ver solicitud`,
      requestSent: `¡Solicitud enviada con éxito!`,
      reportResponseNotification: `¡Atención! Se ha solicitado una respuesta para este informe.`,
      notEligible: `No elegible`,
      noExpertsFound: `Ningún experto encontrado`,
      notificationUpdatedNDA: `¡El acuerdo de confidencialidad del programa {programName} ha sido actualizado! Para continuar participando en este programa, debe revisar y aceptar el NDA.`,
      noUserAvailable: `Ningún usuario disponible`,
      noVpnAccessLogFound: `¡No se encontró ningún registro de acceso a la VPN!`,
      nowTellUsLittle: `¡Ahora cuéntenos un poco sobre la política del programa!`,
      nowTellUsALittleBitAboutTheThreat: `¡Ahora cuéntenos un poco sobre la amenaza!`,
      ofReward: `de recompensa`,
      oneDayAgo: `hace un día`,
      oldPassword: `Contraseña actual`,
      outstandingPayments: `Pagos pendientes`,
      open: `Abierto`,
      opssMatiDidntApproveYourData: `Opss, Mati no aprobó sus datos.`,
      other: `Otros`,
      otherTypes: `Otros tipos`,
      outOfScope: `fuera de alcance`,
      outOfScopeTitle: `Fuera de Alcance`,
      participating: `Participando`,
      password: `Contraseña`,
      passwordChanged: `¡Contraseña cambiada!`,
      passwordConfirmation: `Confirmación de la Nueva Contraseña`,
      passwordsMustMatch: `Las contraseñas deben coincidir`,
      expirePasswordConfig: `Las contraseñas de los usuarios serán válidas por`,
      passwordUpdateRequired: `¡Atención! ¡Cambie su contraseña para evitar el bloqueo de esta cuenta!`,
      remainingDaysToUpdateYourPassword: `días restantes para actualizar su contraseña.`,
      passwordExpiredNotificationTitle: `¡Atención! ¡Su contraseña ha expirado!`,
      passwordExpiredInstructions: `Su cuenta será bloqueada temporalmente. Mantenga su contraseña actualizada y siga las instrucciones enviadas al correo electrónico asociado con esta cuenta.`,
      enablePasswordExpiration: `Habilitar la expiración de la contraseña`,
      configSuccess: `¡Configuración actualizada con éxito!`,
      pasteTheLinkIntoTheBodyOfTheDescription: `Pegue el enlace en el cuerpo de la descripción.`,
      pause: `Pausar`,
      paused: `Pausado`,
      pauseProgram: `Pausar programa`,
      paymentFor: `Pago para`,
      paymentHistory: `Historial de pagos`,
      paymentSummary: `Resumen de pagos`,
      paymentRequested: `Pago solicitado`,
      pending: `Pendiente`,
      pendingSubscription: `Pendiente de Suscripción`,
      permission: `Permiso`,
      permissions: `Permisos`,
      pleaseMakeSureThatThisEmail: `Asegúrese de que este correo electrónico sea correcto y le pertenezca.`,
      phoneNumber: `Número de teléfono`,
      phoneSuccessfullyRemoved: `¡Teléfono eliminado con éxito!`,
      phoneValidation: `Validación de teléfono`,
      platform: `Plataforma`,
      points: `Puntos`,
      pointsIn: `puntos en`,
      possibleDup: `Informe posiblemente duplicado: el alcance {scope} ya ha recibido informes sobre {CWE}`,
      possibleSpam: `Posible SPAM: hemos verificado que el experto {expert} ha enviado varios informes sobre {CWE} en el alcance {scope}.`,
      postedComment: `publicó un comentario`,
      postedImage: `Publicó una imagen`,
      previous: `Anterior`,
      primaryEmail: `correo electrónico principal`,
      primaryEmailReceiving: `Correo electrónico principal para recibir información`,
      privacy: `Privacidad`,
      privacyPolicy: `Política de Privacidad`,
      private: `Privado`,
      privateProgram: `programa privado`,
      profileInformation: `Información del perfil`,
      profileVerifiedReleased: `Verificación de perfil solicitada`,
      program: `Programa`,
      programs: `Programas`,
      programDetails: `Detalles del programa`,
      program_management: `Gestión del programa`,
      programLifeCycle: `Ciclo de vida del programa`,
      programsLimitReached: `¡Límite de programas {0} alcanzado!`,
      programsIhaveAlreadyContributed: `Programas en los que ya he contribuido`,
      programPolicy: `Política del programa`,
      programPolicyMustBeInformed: `Se debe informar la política del programa`,
      programPolicyMustBeBetweenAndCharacters: `La política del programa debe tener entre {f} y {l} caracteres`,
      programRanking: `Ranking del programa`,
      programNdaMustBeBetweenAndCharacters: `El contenido del NDA debe tener entre {f} y {l} caracteres`,
      programsPublishedOnTheWeb: `Los programas publicados en la web pueden ser accedidos por expertos no registrados en la plataforma.`,
      programSuccessfullyChanged: `Programa cambiado con éxito`,
      programType: `Tipo de programa`,
      programWith: `Programa con {0}`,
      proofOfConceptLinks: `Los enlaces a prueba de concepto suelen ser benignos, pero a menudo pueden ir acompañados de consecuencias no deseadas.`,
      setProgramNda: `¿Desea agregar el acuerdo de confidencialidad a su nuevo programa?`,
      public: `Público`,
      publicInformation: `Información pública`,
      publicOrPrivateProgram: `Programa público o privado`,
      publicProgram: `programa público`,
      publish: `Publicar`,
      published: `Publicado`,
      publishedDaysAgo: `Publicado hace {0} días`,
      publishProgramOnTheWeb: `¿Publicar programa en la Web?`,
      publishToTheWeb: `Publicar en la Web`,
      questionsAboutUrl: `Preguntas sobre {0}`,
      rankingDoesNotHaveEnoughDataYet: `El Ranking aún no tiene suficientes datos`,
      rankingPosition: `{0}° en el Ranking`,
      received: `Recibido`,
      receiveAdvertising: `Recibir correos electrónicos publicitarios`,
      receiveEmails: `Recepción de correos electrónicos`,
      receiveAdvertisingEmails: `Recibir correos electrónicos de publicidad`,
      receiveNotificationsAboutNewReports: `Reciba notificaciones sobre nuevos informes directamente en sus plataformas de gestión`,
      referenceDate: `Fecha de referencia`,
      refuseRetest: `Rechazar reanálisis`,
      refusedRetest: `rechazó el reanálisis`,
      registerBelowTheTags: `Gestión de etiquetas`,
      registeredUsers: `Usuarios registrados`,
      registeredVacancies: `Vacantes`,
      registration: `Registro`,
      removeAccount: `Eliminar cuenta`,
      remove: `Eliminar`,
      removeFromWhitelist: `Eliminar de la lista blanca`,
      removeFromBlacklist: `Eliminar de la lista negra`,
      removed: `Eliminado`,
      reportAllPossibleThreatData: `Informe todos los datos posibles de las amenazas`,
      report: `Informe`,
      reportID: `ID del informe`,
      reportCreatedSuccessfully: `Informe creado con éxito`,
      reportEvaluation: `Evaluación del informe`,
      reportPayments: `Pagos de informes`,
      reports: `Informes`,
      reportSent: `Informe enviado`,
      reportsSent: `Informes enviados`,
      reportTitle: `Título del informe`,
      reportedThatTheVulnerabilityIsFixed: `informó que la vulnerabilidad está corregida`,
      reportedThatTheVulnerabilityIsNotPatched: `informó que la vulnerabilidad no está parcheada`,
      reportedVulnerabilities: `Vulnerabilidades reportadas`,
      approvedVulnerabilities: `Vulnerabilidades aprobadas`,
      vulnerabilities: `Vulnerabilidades`,
      overviewSubTitle: `Una vista gerencial de su cuenta solo para usted`,
      summaryCard: `Resumen de los informes`,
      requestedPayment: `solicitó un pago`,
      requestedPaymentOf: `solicitó el pago de`,
      requestedANewTestOfTheReport: `solicitó una nueva prueba del informe`,
      reset: `Reiniciar`,
      rewardValue: `Valor de la recompensa`,
      whatIsAnNda: `¿Qué es un NDA?`,
      whatIsAnNda2: `NDA es una sigla en inglés para Non-Disclosure-Agreements, o simplemente acuerdo de sigilo de información.`,
      whatIsAnNda3: `Tiene la intención de proteger secretos industriales, comerciales o cualquier información que no pueda divulgarse y deba mantenerse en secreto entre quienes tienen acceso a ella.`,
      whatIsaVPNAndHow: `¿Qué es una VPN y cómo puede ayudar en sus programas?`,
      reportTags: `Agregar etiqueta(s) al informe`,
      requestNewPassword: `¡Solicitar nueva contraseña!`,
      requestRetest: `Solicitar Reanálisis`,
      requestSubscription: `Solicitar Suscripción`,
      requiredField: `Campo obligatorio`,
      retestRequested: `Reanálisis Solicitado`,
      requestedRetestPayment: `solicitó el pago del reanálisis`,
      retestId: `Id de reanálisis`,
      retestSent: `Reanálisis enviado`,
      return: `Volver`,
      resolved: `Resueltos`,
      revoke: `Revocar`,
      revokeWebAccessToTheProgram: `¿Revocar el acceso web al programa?`,
      revoked: `Revocado`,
      revokeAccess: `Revocar Acceso`,
      rewardAmount: `Monto de la Recompensa`,
      reward: `Recompensa`,
      rewardDetails: `Detalles de la recompensa`,
      rewards: `Recompensas`,
      rewardsReceived: `Recompensas Recibidas`,
      rewardsWithFinancialValues: `Recompensas con valores financieros`,
      save: `Guardar`,
      saveEditions: `Guardar cambios`,
      saveNda: `Guardar acuerdo de confidencialidad`,
      saveInformation: `Guardar`,
      scopePerProgram: `Alcance por programa`,
      scopesPerProgram: `Alcances por programa`,
      search: `Buscar`,
      seconds: `segundos`,
      select: `Seleccionar`,
      selectAddAccount: `Seleccione "Agregar cuenta" o "+" y escanee el código QR a continuación`,
      selectAScoreForTheReport: `Seleccione una puntuación para el informe`,
      selectFile: `¡Seleccione el archivo!`,
      selectLanguage: `Seleccione un idioma`,
      selectScopeType: `Seleccione el tipo de alcance`,
      selectTheThreat: `¡Seleccione la amenaza!`,
      selectTheProgramScope: `¡Seleccione el alcance del programa!`,
      selectTheProgramImpact: `¡Seleccione el impacto del programa!`,
      selectTheReport: `Seleccione el informe`,
      selectTheScope: `Seleccione el alcance`,
      selectTheCWE: `Seleccione el CWE`,
      selectTheVulnerability: `Seleccione la vulnerabilidad`,
      securityAnalyst: `Ej. Analista de seguridad`,
      send: `Enviar`,
      sentTheRetest: `Envió el retest`,
      sendMessage: `Enviar Mensaje`,
      sent: `Envió`,
      sentTo: `Enviado a`,
      sentTheReport: `envió el informe`,
      settings: `Configuración`,
      severityReports: `Informes por severidad`,
      severity: `Severidad`,
      currentValue: `Valor actual`,
      finalValue: `Valor final`,
      showingResultsOfTotal: `Mostrando {results} de {totalResults} resultados.`,
      since: `Desde {0}`,
      sinceLastMonth: `desde el mes pasado`,
      situation: `Situación`,
      scope: `Alcance`,
      scopeLimitExceeded: `Se ha excedido el límite de alcances del programa.`,
      scopeListOfTheProgram: `¡Lista de alcance del programa!`,
      score: `Puntuación`,
      scoreHistory: `Historial de puntuación`,
      scopeType: `Tipo de Alcance`,
      share: `Compartir`,
      smsCode: `Código SMS`,
      smsCodeSent: `Código SMS enviado`,
      specialist: `Especialista`,
      specialistNotFound: `¡Especialista no encontrado!`,
      standard: `Estándar`,
      standoutCreate: `¡Destaca! Crea un título motivador.`,
      start: `Inicio`,
      pauseMessage: `No fue posible ejecutar la acción, ya que la campaña aún no ha comenzado.`,
      startAnAccountForOrganization: `Crear una cuenta para la organización`,
      startWithRewards: `Comience con las recompensas que tienen valor financiero`,
      statistics: `Estadísticas`,
      stateCity: `Estado`,
      status: `Estado`,
      statusChanged: `¡Estado cambiado!`,
      storeYourBackupCodes: `Guarde sus códigos de respaldo`,
      subdomain: `Subdominio`,
      submittedDays: `Enviado hace {0} días`,
      submitComment: `Enviar Comentario`,
      submitForReview: `Enviar para Revisión`,
      rewardNotice: `Recordatorio: Este programa ofrece doble recompensa`,
      submitReport: `Enviar Informe`,
      submit_retest: `Enviar retest`,
      successfullyGeneratedKeys: `¡Claves generadas con éxito!`,
      suggestions: `Sugerencias`,
      suggestedReward: `Recompensa sugerida`,
      summary: `Resumen`,
      superSimpleItDoesntEvenTake: `Es simple, ni siquiera toma 1 minuto. ¡Simplemente ingrese los datos a continuación y listo! Su cuenta está creada.`,
      superSimpleItDoesntEvenTakeCompany: `Es simple, ni siquiera toma 1 minuto. ¡Simplemente ingrese los datos comunes de la organización y listo! Su cuenta será enviada para análisis.`,
      support: `Soporte`,
      sureAddExpertBlacklist: `¿Está seguro de que desea agregar este especialista a la lista negra?`,
      sureAddExpertWhiteList: `¿Está seguro de que desea agregar este especialista a la Lista Blanca?`,
      sureRemoveExpertBlacklist: `¿Está seguro de que desea eliminar este especialista de la Lista Negra?`,
      sureRemoveExpertWhitelist: `¿Está seguro de que desea eliminar este especialista de la Lista Blanca?`,
      successfullyCreatedProgram: `Programa creado con éxito`,
      successfullyCreated: `creado con éxito`,
      acceptedNda: `¡NDA aceptado con éxito!`,
      openReports: `Informes abiertos`,
      openYourApp: `Abra su aplicación.`,
      or: `o`,
      organizationName: `Nombre de la organización`,
      overallRanking: `Ranking general`,
      paidRetest: `Si el&nbsp;<b>retest es aprobado</b>, recibirá&nbsp;<b>{0}</b>&nbsp;adicional del valor de la recompensa.`,
      tagsAreUsedToHelpIdentifyReports: `Las etiquetas se utilizan para ayudar a identificar los informes.`,
      tagsForReports: `Etiquetas para informes`,
      takeAction: `Tomar acción`,
      takeTheOpportunityToAcquireMoreComplete: `Aproveche la oportunidad para adquirir planes más completos para su empresa`,
      talkDirectlyToOurOperators: `Hable directamente con nuestros operadores.`,
      target: `Tiempo esperado: {0}`,
      telephone: `Teléfono`,
      testDescriptionsMustBetweenCharacters: `Las descripciones de las pruebas deben tener entre {f} y {l} caracteres`,
      tests: `Pruebas`,
      terms: `Términos`,
      termsAPolicy: `Términos y Política`,
      termsOfUse: `Términos de uso`,
      thanksForRegistering: `¡Gracias por registrarse!`,
      thankByEmail: `Agradecimiento por correo electrónico`,
      theActionsTakenOnTheReportCannotBe: `Las acciones realizadas en el informe no se pueden eliminar`,
      theCommentNeedsToBeInformed: `¡El comentario debe ser informado!`,
      theDescriptionTestsMustBeInformed: `La descripción de las pruebas debe ser informada`,
      theDescriptionOfTheProgramMustBeInformed: `La descripción del programa debe ser informada`,
      theImpactDescriptionMustBeInformed: `La descripción del impacto debe ser informada`,
      theImpactDescriptionMustBetweenCharacters: `La descripción del impacto debe tener entre {f} y {l} caracteres`,
      theIsNotValid: `El {0} no es válido`,
      theFileIsNotValid: `¡El archivo no es válido!`,
      theNameMustBeFromToCharacters: `El nombre debe tener de {f} a {l} caracteres`,
      theNameOfThePersonResponsibleIsMandatory: `El nombre del responsable es obligatorio.`,
      theNameOfTheProgramMustBInformed: `El nombre del programa debe ser informado`,
      theNameWillBeAssignedToYourProgramsURL: `El nombre se asignará a la URL de su programa.`,
      thenUseYourEmail: `Luego use su correo electrónico, su contraseña y acceda a nuestra plataforma. Si ha olvidado su contraseña o nombre de usuario, ¡utilice la opción de recuperación a continuación!`,
      thePhoneIsNotValid: `El teléfono no es válido.`,
      theProgramDescriptionMustBeBetweenAndCharacters: `¡La descripción del programa debe tener entre {f} y {l} caracteres!`,
      theProgramNameMustBeBetweenAndCharacters: `El nombre del programa debe tener entre {f} y {l} caracteres`,
      thereIsAlreadyAprogram: `¡Ya existe un programa registrado con este nombre!`,
      thereIsAlreadyProgramSlug: `¡Ya existe un programa registrado con este slug!`,
      theReportNeedsToBeInformed: `El informe debe ser informado`,
      theRetestMustBeSentWithinDays: `El retest debe ser enviado dentro de {0} días`,
      theRetestWasNotSubmitted: `¡El retest no fue enviado!`,
      theRetestHaAlreadyAccepted: `¡El retest ya ha sido aceptado!`,
      theseSettingsDirectlyImpactTheAccessOfExperts: `Estas configuraciones impactan directamente en el acceso de los expertos.`,
      theScopeAddressMustBeInformed: `La dirección del alcance debe ser informada`,
      theThreatDescriptionMustBeInformed: `¡La descripción de la amenaza debe ser informada!`,
      theThreatDescriptionMustBetweenCharacters: `La descripción de la amenaza debe tener entre {f} y {l} caracteres`,
      theTitleMustBeInformed: `El título debe ser informado`,
      theTitleMustBeBetweenCharacters: `El título debe tener entre {f} y {l} caracteres`,
      theWebhookIsNotValid: `¡El webhook no es válido!`,
      theWebsiteMustBeFromToCharacters: `El sitio web debe tener de {f} a {l} caracteres`,
      thisChangeIsIrreversible: `Este cambio es irreversible.`,
      thisInformationCanAppear: `Esta información puede aparecer en el perfil público de la empresa, junto a sus comentarios y en cualquiera de sus informes.`,
      thisIsAnInternalSurvey: `Esta es una encuesta interna, los expertos no tendrán acceso a los datos de este cuestionario.`,
      thisServiceCreatesAVPNResponsible: `Este servicio crea una VPN, responsable de conectar y monitorear el tráfico de datos de las pruebas del especialista a sus alcances, y con eso mayor rastreabilidad y seguridad.`,
      thisWeek: `esta semana`,
      threats: `Amenazas`,
      time: `Tiempo`,
      timeToFirstResponse: `a la primera respuesta`,
      timeToBounty: `pagar la recompensa`,
      timeToResolution: `cerrar el informe`,
      title: `Título`,
      to: `para`,
      toAcceptThisInvitation: `Para aceptar esta invitación, es necesario que se verifique en Meta<b>Map</b> , después de la verificación, espere unos minutos y actualice la página.`,
      tokenIsInvalid: `El token no es válido o ya ha sido utilizado.`,
      toAddMorePrograms: `Para agregar más programas, consulte nuestros planes haciendo clic`,
      toAddMoreScopesToThe: `Para agregar más alcances al programa, consulte nuestros planes haciendo clic`,
      toAddMoreUsersCheck: `Para agregar más usuarios, consulte nuestros planes haciendo clic`,
      toAddTheseIntegrations: `Para agregar estas integraciones, consulte nuestros planes haciendo clic`,
      toAddThisFeatureCheck: `Para agregar esta función, consulte nuestros planes haciendo clic`,
      toChangeYourPlanContactSupport: `Para cambiar su plan, póngase en contacto con el soporte.`,
      toCheck: `Verificar`,
      toConfirmWeNeedYourPassword: `Para confirmar necesitamos su contraseña`,
      toConfirmYourRegistrationOn: `Para confirmar su registro en nuestra plataforma, debe hacer clic en el botón de abajo.`,
      today: `Hoy`,
      toDoThisYouNeedToEnterYourAppCode: `Para hacer esto, debe ingresar el código de su aplicación de autenticación o un token de respaldo (cada token es válido solo una vez).`,
      topReportedCWE: `CWE más reportado`,
      totalConnectedHours: `Total de horas conectadas`,
      totalEvents: `Total de eventos`,
      totalMonthlyFees: `Total de cuotas mensuales`,
      totalReports: `Total de informes`,
      totalReceived: `Total Recibido`,
      totalRewards: `Total de recompensas`,
      toTheProgram: `al programa`,
      totalSpent: `Total gastado`,
      totalSum: `Sumatorio total`,
      trackYourOpenReports: `Rastree sus informes abiertos`,
      twoFactorAuthentication: `Autenticación de dos factores`,
      type: `Tipo`,
      typeOfContract: `Tipo de contrato`,
      typeOrPasteOneOfYourBackupTokens: `Escriba o pegue uno de sus tokens de respaldo, ¡recordando que cada token solo se puede usar una vez!`,
      typeProgramLimitExceeded: `Se ha excedido el límite de programas del tipo {programType}`,
      unableToCompleteThisRequest: `No se pudo completar esta solicitud.`,
      unableToSubmittedTheReport: `No se pudo enviar este informe. Asegúrese de que todos los campos estén completos correctamente.`,
      undefinedRanking: `Ranking indefinido`,
      uninformed: `No informado`,
      unshowPassword: `Ocultar contraseña`,
      update: `Actualizar`,
      updates: `Actualizaciones ({numberOfUpdates})`,
      updated: `Actualizado`,
      uploadFiles: `Subir archivos`,
      upTo: `Hasta`,
      urlIsNotValid: `La URL no es válida`,
      useBackupCode: `¿Usar código de respaldo?`,
      user: `Usuario`,
      userBlockedForOverTrying: `Usuario bloqueado por exceso de intentos, intente nuevamente más tarde.`,
      userByCompany: `Usuario por empresa`,
      userDisconnected: `¡Usuario desconectado!`,
      userLimitReached: `¡Límite de usuarios alcanzado!`,
      userLoggedIn: `¡Usuario conectado!`,
      usersByCompany: `Usuarios por empresa`,
      userDoesNotHavPermissionToPerform: `El usuario no tiene permiso para realizar esta acción`,
      usernameHasInvalidCharacters: `El nombre de usuario tiene caracteres inválidos`,
      usernameIsNotAvailable: `¡El nombre de usuario no está disponible!`,
      usernameMustBeFromCharacters: `El nombre de usuario debe tener de {f} a {l} caracteres.`,
      users: `Usuarios`,
      userEmail: `Usuario o correo electrónico`,
      usersOnTheBlacklist: `¡Los usuarios en la Lista Negra no tendrán acceso a este programa!`,
      userRemoved: `Usuario eliminado`,
      useYourAuthenticationAppToEnterTheCode: `Utilice su aplicación de autenticación para ingresar el código`,
      validatePhone: `Validar teléfono`,
      validatedPhone: `Teléfono validado`,
      value: `Valor`,
      verified: `Verificado`,
      verifieds: `Verificados`,
      vpnIP: `IP de la VPN`,
      waitingConfirmation: `Esperando confirmación`,
      wantSaveChangesProgram: `¿Realmente desea guardar los cambios realizados en este programa?`,
      waysExplore: `Formas de Explorar`,
      weLeaveThisPanel: `Dejamos este panel para que publique sus vacantes para nuestros expertos`,
      whatIsBugBounty: `Qué es Bug Bounty`,
      whatIsYourAction: `¿Cuál es su acción?`,
      whatIsNdaHeader: `¡Estate atento!`,
      whatPrograms: `¿Qué programas?`,
      whatTypeOfVulnerability: `¿Qué tipo de vulnerabilidad se reportó?`,
      whoDoYouWantInvite: `¿A quién quieres invitar?`,
      whiteMessage: `Escribe un mensaje...`,
      weakPasswordContain: `¡Contraseña débil! Debe contener`,
      websiteInvitation: `Invitación del sitio web`,
      weSendAToast: `Enviamos un brindis`,
      weAreUnderMaintenance: `¡Estamos en mantenimiento! ¡Vuelve pronto!`,
      weTemporarilyStoreYourReport: `Almacenamos temporalmente los datos de su informe para el programa`,
      weWillContactYouShortly: `En breve nos pondremos en contacto para confirmar sus datos.`,
      wikiSubTitle: `Ayudamos como podemos y como no podemos.`,
      withoutWebAccessTheProgram: `Sin acceso web, el programa solo estará disponible para los usuarios de la plataforma.`,
      workModel: `Modelo de trabajo`,
      workSchedule: `Horario de trabajo`,
      yesIWantToRegister: `Sí, quiero registrarme`,
      yes: `Sí`,
      no: `No`,
      youAcceptedThisInvitation: `Aceptaste esta invitación`,
      youAreAboutToVisitLink: `Estás a punto de visitar un enlace externo.`,
      youAreAllowedToViewTheReports: `Tienes permiso para ver los informes.`,
      youCanUseOneOfTheseBackupCodes: `Puede usar uno de estos códigos de respaldo para iniciar sesión si pierde el acceso a su teléfono inteligente. Recuerde que cada código solo se puede usar una vez.`,
      yourCurrentPlanIsThe: `Tu plan actual es`,
      youDoNotHaveAnyTagRegistered: `No tienes ninguna etiqueta registrada, para agregar acceso al menú <a href="/account?tags">Mi cuenta/Etiquetas</a>`,
      youDontHaveAnyAcceptedInvitations: `¡Aún no tienes ninguna invitación aceptada!`,
      youDontHaveAnyInvitationsWaiting: `¡Aún no tienes ninguna invitación esperando respuestas!`,
      youDontHaveAnyNDAs: `¡Aún no tienes ningún acuerdo de confidencialidad!`,
      youDontHaveAnyNDAsHacker: `¡Aún no has aceptado ningún acuerdo de confidencialidad!`,
      youDontHaveAnyProgramsInThisCategoryYet: `Aún no tienes ningún programa en esta categoría`,
      youDontHaveSubmittedReports: `¡Aún no tienes ningún informe aprobado!`,
      youHaveBeenInvitedToSend: `Has sido invitado a enviar informes a este programa`,
      youHavePermissionToViewAndEditReports: `Tienes permiso para ver y editar los informes.`,
      youMustAgreeToThe: `Debes aceptar los`,
      youMustAgreeToTheTermsOfUse: `Debes aceptar los términos de uso.`,
      youMustAgreeToTheTermsOfUseAndCodeOfConduct: `Debes aceptar los términos de uso y el código de conducta.`,
      yourAccessPassword: `¡Su contraseña de acceso!`,
      yourAccesEmail: `Su correo electrónico de acceso a {0}`,
      youReachedLimit: `¡Has alcanzado el límite diario de envío de informes!`,
      yourEmail: `Su correo electrónico`,
      yourFullName: `¡Su nombre completo!`,
      yourNameMustBeBetweenAndCharacters: `¡Su nombre debe tener entre {f} y {l} caracteres!`,
      yourOrganizationNameIsRequired: `Se requiere el nombre de su organización`,
      YourOrganizationTradeName: `¡Nombre comercial de su organización!`,
      yourPassword: `Su contraseña`,
      yourPhoneToGetInTouch: `¡Teléfono para ponernos en contacto!`,
      yourProfileIsNowAbleTo: `¡Su perfil ahora puede participar en el proceso de verificación!`,
      ndaVerificationRequired1: `Has sido invitado a participar en el programa `,
      ndaVerificationRequired2: `¡Se requiere la verificación de su perfil para aceptar esta invitación!`,
      ndaVerificationRequired3: `Consulte su lista de notificaciones y continúe con el proceso de verificación.`,
      noJobsFound: `No se encontraron trabajos`,
      registrationDone: `¡Registro completado!`,
      reportPaymentVerificationRequired1: `¡Se ha solicitado el pago de una recompensa para el informe `,
      reportPaymentVerificationRequired2: `!`,
      reportSummaryNotValid: `¡El resumen del informe no es válido!`,
      reportContentIsNotValid: `¡El contenido del informe no es válido!`,
      reportVulnerabilitIsNotValid: `¡El impacto de la vulnerabilidad no es válido!`,
      reportCriticalityIsNotValid: `¡La criticidad de la vulnerabilidad no es válida!`,
      reportCantAcceptEspecialCaracter: `(No es posible insertar caracteres especiales.)`,
      reportScopeIsNotValid: `¡El identificador del alcance del informe no es válido!`,
      reportIdentifierIsNotValid: `¡El identificador del programa no es válido!`,
      reportVulnerabilityIdentifierIsNotValid: `¡El identificador de la vulnerabilidad no es válido!`,
      ndaVerificationRequired6: `¡Completa la validación de tu perfil para que podamos proceder con el pago de la recompensa!`,
      reportTitleIsNotValid: `¡El título del informe no es válido!`,
      showPassword: `Mostrar contraseña`,
      companyNdaVerificationRequired: `¡Necesitas crear un NDA para tu programa antes de invitar a expertos!`,
      taxesNotIncluded: `Impuestos no incluidos`,
      youAcceptedParticipateInThisProgram: `Has aceptado participar en este programa.`,
      youCanCalculate: `Puedes calcular la severidad a través de la calculadora a continuación`,
      youShouldConsiderUsingSeparate: `Deberías considerar usar un navegador o máquina virtual separada antes de continuar.`,
      yourSecurityPlatformAndBugReward: `Tu plataforma de Bug Bounty`,
      youWereInvitedPartOf: `Has sido invitado a formar parte del equipo {0}. Solo tienes que introducir los datos de tu cuenta.`,
      youWillBeRedirectedIn: `Serás redirigido en`,
      youWillReceiveReportsFromCommunity: `Recibirás informes de los expertos en seguridad de nuestra comunidad, sin ningún coste adicional, minimizando los riesgos de que tus datos sean expuestos o vulnerabilidades explotadas.`,
      invitationsSummary: `Resumen de las invitaciones`,
      doubleReward: `Recompensa doble`,
      boostedProgram: `¡Programa impulsado!`,
      doubleCampaignNotificationStarted: `Campaña de bonificación doble iniciada`,
      doubleCampaignNotificationClosed: `Campaña de bonificación doble cerrada`,
      doubleCampaignNotificationPaused: `Campaña de bonificación doble pausada`,
      doubleCampaignNotificationResumed: `Campaña de bonificación doble reanudada`,
      campSubTitle: `¡Gestiona tus campañas! Sigue todos los detalles.`,
      historicCampaign: `Histórico`,
      historicDoubleBounty: `Bounty doble`,
      historicDoubleScore: `Puntuación doble`,
      inText: `De`,
      until: `Hasta`,
      finished: `Finalizado`,
      in_progress: `En progreso`,
      situationCancel: `Cancelado`,
      createdTh: `Creado en`,
      periodTh: `Período`,
      rewardsTh: `Recompensas`,
      situationsTh: `Situaciones`,
      historicApproved: `Aprobados`,
      historicCancel: `Cancelados`,
      historicPaused: `Pausados`,
      historicFinished: `Finalizados`,
      notificationAttention: `¡Atención!`,
      notificationYourCampaignHasStarted: `¡Tu campaña ha comenzado!`,
      notificationThisCampaign: `Esta campaña`,
      notificationHasClosed: `ha terminado`,
      notificationHasBeenPaused: `ha sido pausada`,
      keepAnEyeOutNotification: `mantente atento`,
      notificationWillLetYouKnowWhenToStartAgain: `te avisaremos cuando vuelva a empezar.`,
      notificationThisCampaignIsLiveAgain: `¡Esta campaña está en marcha de nuevo!`,
      finalDate: `Fin`,
      remain: `Restan`,
      campaignStarted: `¡La campaña de recompensas dobles ha comenzado!`,
      campaignClosed: `¡La campaña de recompensas dobles ha finalizado!`,
      campaignPause: `¡La campaña de recompensas dobles ha sido pausada!`,
      campaignReactivated: `¡La campaña de recompensas dobles ha sido reactivada!`,
      campaignFinalDays: `para el fin de la campaña`,
      campaignInitialDays: `para el inicio de la campaña`,
      dayCampaign: `día`,
      daysCampaign: `días`,
      daysGeneric: `día(s)`,
      btnRegister: `Registrar`,
      btnLabel: `Seleccione la fecha`,
      doubleBounties: `Doblar bounties`,
      doubleScore: `Doblar puntuación`,
      activeDoubleCampaign: `Impulsar programa`,
      selectAPeriod: `Seleccione un período:`,
      monthlyRanking: `Ranking Mensual`,
      generalRanking: `Ranking General`,
      expertRating: `Consulta la clasificación de los expertos BugHunt`,
      bountyOffer: `Estás ofreciendo: Bounties dobles`,
      bountyScore: `Estás ofreciendo: Puntuación doble`,
      bountyAndScoreOffer: `estás ofreciendo: Bouties y Puntuación doble`,
      closeCampaign: `Cerrar Campaña de bonificación`,
      pauseCampaign: `Pausar Campaña de bonificación`,
      reactivateCampaign: `Reactivar Campaña de bonificación`,
      boostCampaign: `Impulsar programa`,
      doubleCheckCampaign: `Estoy al tanto de los cambios realizados en este programa.`,
      successfullyCreatedCampaign: `Solicitud realizada con éxito, por favor espere el análisis de aprobación de la campaña!`,
      vpnMessage: `No hay una VPN habilitada en este programa.`,
      campaignPaused: `¡Campaña pausada con éxito!`,
      doubleCampaignClosed: `¡Campaña cerrada con éxito!`,
      doubleCampaignResumed: `¡Campaña reanudada con éxito!`,
      registeredProgramWarning: `Este programa ya tiene una campaña aprobada o cerrada hace menos de 15 días.`,
      warningBoutiesOrScore: `¡La campaña debe ofrecer bounties o puntuación doble!`,
      invalidDateMessage: `Fecha inválida, por favor, compruebe si el campo se ha rellenado correctamente!`,
      administrator: `Administrador`,
      viewer: `Visor`,
      analyst: `Analista`,
      needsInformation: `necesita información`,
      retest_done: `Retest completado`,
      pending_retest: `Retest pendiente`,
      notImpact: `Severidad no informada`,
      lowImpact: `Severidad baja`,
      mediumImpact: `Severidad media`,
      highImpact: `Severidad alta`,
      criticalImpact: `Severidad crítica`,
      approved: `Aprobado`,
      informative: `Informativo`,
      duplicated: `Duplicado`,
      not_applicable: `No aplicable`,
      spam: `Spam`,
      comment: `Publicar un comentario`,
      change_situation: `Cambiar situación`,
      update_severity: `Actualizar severidad`,
      request_update: `Solicitar actualización`,
      retest: `Solicitar retest`,
      pay_bounty: `Pagar una recompensa`,
      close_report: `Cerrar el informe`,
      reopen_report: `Reabrir el informe`,
      needs_information: `Esperando información`,
      move_to_locker: `Mover al casillero de informes`,
      move_out_of_locker: `Sacar del casillero de informes`,
      under_review: `En revisión`,
      triaged: `Clasificado`,
      plan_trial: `Plan Trial`,
      plan_bronze: `Plan Bronce`,
      plan_silver: `Plan Plata`,
      plan_gold: `Plan Oro`,
      trial: `Trial`,
      bronze: `Bronce`,
      silver: `Plata`,
      gold: `Oro`,
      fulltime: `Tiempo completo`,
      parttime: `Tiempo parcial`,
      clt: `CLT`,
      pj: `PJ`,
      autonomous: `Autónomo`,
      cltflex: `CLT-Flex`,
      cooperative: `Cooperativo`,
      internship: `Prácticas`,
      hybrid: `Híbrido`,
      office: `Presencial`,
      remote: `Remoto`,
      web: `Aplicación Web`,
      api: `API`,
      mobileapplication: `Aplicación Móvil`,
      mobileapplicationandroid: `Aplicación Móvil Android`,
      mobileapplicationios: `Aplicación Móvil IOS`,
      ip: `Dirección IP`,
      january: `Enero`,
      february: `Febrero`,
      march: `Marzo`,
      april: `Abril`,
      may: `Mayo`,
      june: `Junio`,
      july: `Julio`,
      august: `Agosto`,
      september: `Septiembre`,
      october: `Octubre`,
      november: `Noviembre`,
      december: `Diciembre`,
      seeOriginalText: `Texto original.`,
      waiting_for_information: `Esperando información`,
      severity_updated: `Severidad actualizada`,
      retest_requested: `Retest solicitado`,
      bounty_paid: `Bounty pagado`,
      close_as_approved: `Cerrar como aprobado`,
      close_as_informative: `Cerrar como informativo`,
      close_as_spam: `Cerrar como spam`,
      close_as_duplicated: `Cerrar como duplicado`,
      close_as_not_applicable: `Cerrar como no aplicable`,
      select_option: `Seleccione una opción`,
      deleteMessageAlert: `¿Estás seguro de que quieres eliminar este mensaje?`,
      automaticMessage: `Al seleccionar la opción, la respuesta automática se registrará como una primera interacción en el informe.`,
      defaultMessageCenterMenu: `Centro de Mensajes Predeterminado`,
      registerNotFound: `No se encontraron registros.`,
      registeredMessageTitle: `Mensajes Registrados`,
      customSettingsTitle: `Configuraciones Personalizadas`,
      customSettingsSubtitle: `Configuración de mensajes para respuestas estandarizadas`,
      addMessageButton: `Agregar mensaje`,
      existingMessageAlert: `Solo puedes registrar un mensaje por tipo de mensaje. Actualmente, ¡todos los mensajes ya están registrados!`,
      editMessage: `Editar Mensaje`,
      registerMessage: `Registrar Mensaje`,
      placeholderTitleMessage: `Título del mensaje`,
      placeholderTextAreaMessage: `Añade una descripción...`,
      labelAutomatic: `Automático`,
      alertMessageSuccess: `¡Mensaje registrado con éxito!`,
      alertMessageUpdate: `¡Mensaje actualizado con éxito!`,
      swalTokenRemoved: `El token se ha eliminado correctamente.`,
      deleteTokenCompany: `Eliminar token`,
      placeholderTokenCompany: `Introduce un token`,
      errorToken: `¡El token debe contener un mínimo de 20 caracteres y un máximo de 500 caracteres!`,
      emailNotification: `¡La notificación por correo electrónico se ha activado con éxito!`,
      enableEmailNotification: `Activar la recepción de actualizaciones del programa por correo electrónico.`,
      emailNotificationDisabled: `¡La notificación enviada por correo electrónico ha sido desactivada!`,
      china: `China`,
      india: `India`,
      estadosUnidos: `Estados Unidos`,
      indonesia: `Indonesia`,
      paquistao: `Pakistán`,
      brasil: `Brasil`,
      nigeria: `Nigeria`,
      bangladesh: `Bangladesh`,
      russia: `Rusia`,
      mexico: `México`,
      japao: `Japón`,
      etiopia: `Etiopía`,
      filipinas: `Filipinas`,
      egito: `Egipto`,
      vietna: `Vietnam`,
      repuplicaDemocraticaDoCongo: `República Democrática del Congo`,
      turquia: `Turquía`,
      ira: `Irán`,
      alemanha: `Alemania`,
      tailandia: `Tailandia`,
      reinoUnido: `Reino Unido`,
      franca: `Francia`,
      italia: `Italia`,
      tanzania: `Tanzania`,
      africaDoSul: `Sudáfrica`,
      mianmar: `Myanmar (Birmania)`,
      coreiaDoSul: `Corea del Sur`,
      colombia: `Colombia`,
      quenia: `Kenia`,
      espanha: `España`,
      ucrania: `Ucrania`,
      uganda: `Uganda`,
      sudao: `Sudán`,
      angertina: `Argentina`,
      angelia: `Argelia`,
      iraque: `Irak`,
      polonia: `Polonia`,
      canada: `Canadá`,
      uzbequistao: `Uzbekistán`,
      arabiaSaudita: `Arabia Saudita`,
      br: `Portugués`,
      en: `Inglés`,
      es: `Español`,
      fr: `Francés`,
      it: `Italiano`,
      ru: `Ruso`,
      de: `Alemán`,
      jp: `Japonés`,
      cn: `Chino`,
      pl: `Polaco`,
      ua: `Ucraniano`,
      sd: `Árabe`,
      kr: `Coreano`,
      in: `Hindi`,
      id: `Indonesio`,
      pk: `Urdu`,
      bd: `Bengalí`,
      et: `Amárico`,
      ph: `Filipino (Tagalo)`,
      vn: `Vietnamita`,
      tr: `Turco`,
      ir: `Persa`,
      th: `Tailandés`,
      za: `Afrikáans`,
      mm: `Birmano`,
      ug: `Suajili`,
      uz: `Uzbeko`,
      sa: `Árabe`,
      additionalMoreLanguages: `Agregar más idiomas`,
      country: `País`,
      language: `Idioma`,
      clearText: `Usar el mensaje predeterminado`,
      selectCountry: `Seleccione un país`,
      basic: `Básico`,
      proficiency: `Dominio`,
      conversational: `Conversacional`,
      fluent: `Fluido`,
      native: `Nativo o bilingüe`,
      AreYouSureYouWantToCompleteTheRequest: `¿Está seguro de que desea completar esta solicitud?`,
      managers: `Gerentes`,
      manageProgram: `Defina quién administrará su nuevo programa.`,
      config: `Configuración`,
      programSettings: `Configuración del programa`,
      programEditAlert: `¡Atención! No es posible editar programas inactivos o programas en espera de aprobación.`,
      changeSettings: `Cambiar la configuración`,
      managersWithAccesToTheProgram: `Gerentes con acceso al programa`,
      freeAccess: `Acceso libre`,
      pendingInviteAlert: `¡Atención! Ya existe una invitación pendiente asociada a esta dirección de correo electrónico.`,
      USDT: `Dólar`,
      BRL: `Real`,
      selectCurrencyType: `Seleccione el tipo de moneda`,
      passwordSuccess: `¡Contraseña registrada con éxito!`,
      isNan: `El valor ingresado debe ser numérico.`,
      filterScope: `Filtrar por alcance`,
      selectScope: `Seleccione una opción de alcance`,
      filterScopeTitle: `Filtrar por alcance`,
      scopeSelected: `Alcance seleccionado`,
      summaryFinancialCard: `Resumen financiero`,
      summaryTotalCard: `Aportes`,
      summaryTotalPgCard: `Total pagado`,
      projectedValueLabel: `Número de meses a proyectar`,
      totalMonthlyPayments: `Pagos mensuales`,
      totalManagedServices: `Servicios administrados`,
      totalRewardsPaid: `Recompensas pagadas`,
      monthAndyear: `Mes/Año`,
      contribution: `Aporte`,
      managed: `Administrado`,
      costProjection: `Proyección de costos`,
      contributionBalance: `Saldo del aporte`,
      detailsNF: `Detalles de la factura`,
      total: `Total`,
      expenseNotification: `¡Manténgase en control! Configure notificaciones para cuando alcance el "70%" de su presupuesto de gastos.`,
      errorValueBudget: `Ingrese el límite del presupuesto`,
      errorBudgetNotification: `Ingrese el porcentaje deseado`,
      labelInvalidValue: `Valor inválido. Por favor, ingrese un valor entre 0 y 100`,
      labelCurrencyValue: `Valor inválido: No es posible registrar valores negativos.`,
      titleBudgetActive: `Limitar los costos mensuales de recompensas`,
      budgetLimitProgram: `El límite de presupuesto para este programa es`,
      errorBudgetLimit: `Ingrese el límite del presupuesto`,
      invalidValueBudget: `Valor inválido: No es posible registrar valores negativos.`,
      notificationBudget: `Notificar cuando alcance el valor de`,
      percentageBudget: `Ingrese el porcentaje deseado`,
      percentageErrorBudget: `Valor inválido. Por favor, ingrese un valor entre 0 y 100`,
      pauseProgramBudget: `¿Pausar el programa antes de alcanzar el presupuesto total?`,
      percentagePauseBudget: `Porcentaje de pausa (0-99%)`,
      createCredentialTooltip: `Definir credencial`,
      confirmBtn: `Confirmar`,
      swalCredential: `Credencial guardada con éxito.`,
      labelCredentialForTest: `Las credenciales para probar el sistema y el alcance del programa`,
      labelCredentialForTestContinued: `se enumeran a continuación`,
      labelCredentialIndividual: `Uso individual. No comparta para garantizar su seguridad.`,
      labelCredentialShared: `Uso compartido. Todos los expertos tienen el mismo acceso.`,
      credentials: `Credenciales`,
      confirmPassword: `Confirmar contraseña`,
      confirmPasswordToViewCredential: `Confirme su contraseña de acceso a la plataforma para ver las `,
      confirmPasswordToViewCredentialContinued: `credenciales disponibles`,
      hello: `Hola`,
      doYouHaveCredentials: `tiene credenciales para usar en los sistemas y alcances que se probarán`,
      manageYourCredentials: `Administre sus credenciales genéricas registradas para facilitar el acceso a los expertos que realizarán pruebas en sus sistemas`,
      manageYourCredentialsTooltip: `Administre sus credenciales`,
      credentialPublica: `Credencial Genérica`,
      credentialPrivate: `Credencial Exclusiva`,
      credentialPublicaDescription: `Las credenciales genéricas registradas se enviarán a todos los expertos que participen en el programa, para que se utilicen para realizar pruebas de seguridad.`,
      credentialSentToSpecialist: `Las credenciales exclusivas registradas solo se enviarán al especialista de destino`,
      credentialSentToSpecialistContinued: `para que se utilicen para realizar pruebas de seguridad.`,
      request_review: `Solicitar revisión de la evaluación`,
      request_review_report: `solicitó la revisión de la evaluación`,
      reviewRequestedNotification: `Solicitud de revisión`,
      availableCredential: `Credencial disponible`,
      allActionsAllowed: `Tiene permiso para administrar todos los programas y usuarios.`,
      owner: `Propietario`,
      AreYouSureYouWantToUpdateTheUserRole: `¿Está seguro de que desea aplicar los cambios a los permisos de este usuario?`,
      manageCredentials: `Administrar las credenciales registradas.`,
      setPublicCredential: `Administre sus credenciales públicas`,
      programSpellers: `Expertos del programa`,
      viewCredentials: `Ver credenciales`,
      informPassword: `Ingrese su contraseña`,
      credentialDeleted: `¡Credencial eliminada con éxito!`,
      genericError: `Algo salió mal. Estamos resolviendo esto ahora. Por favor, inténtelo de nuevo más tarde.`,
      delete: `Eliminar`,
      toClose: `Cerrar`,
      labelDeleteCredential: `¿Está seguro de que desea eliminar esta credencial?`,
      credentialsTooltip: `Credenciales disponibles`,
      setPasswordExpiration: `Establecer la expiración de la contraseña`,
      authenticationViaEmail: `Autenticación de dos factores (2FA) por correo electrónico`,
      accessValidation: `Validación de acceso`,
      invalidCodeError: `¡El código ingresado no es válido!`,
      confirmPasswordLabel: `Confirme su contraseña de acceso a la plataforma para completar la acción deseada.`,
      emailAuthenticationInformation: `Aumente la seguridad de todas las cuentas habilitando la autenticación por correo electrónico, protegiendo la información del usuario contra accesos no autorizados.`,
      alertTwoFactory: `<div class="container-two-factory"><p class="two-factory-descrition">Para enviar un informe en este programa, debe habilitar la autenticación de dos factores. Su seguridad es nuestra prioridad, y esta capa adicional de protección es esencial para garantizar la integridad de su cuenta. <span>Siga los pasos de configuración para habilitar la autenticación de 2 factores ahora.</span></p></div>`,
      twoFactoryNewUsersContinuation: `podrán interactuar con los informes.`,
      restriction: `Restricción`,
      warningTwoFactorAuthentication: `¡Advertencia! Se requiere la configuración de autenticación de 2 factores.`,
      labelFeatureTwoFactorAuthentication: `Solo los gerentes con autenticación de dos factores pueden interactuar con los informes del programa.`,
      labelFeatureTwoFactorAuthenticationHacker: `Solo los especialistas con autenticación de dos factores pueden enviar nuevos informes para el programa.`,
      configureNow: `Configurar ahora`,
      enable2fa: `habilitó el requisito de configurar la autenticación de dos factores`,
      disable2faSwal: `deshabilitó el requisito de configurar la autenticación de dos factores`,
      itWas: `Fue`,
      toProgram: `al programa,`,
      translateText: `Traducir texto`,
      openingDate: `Fecha de apertura:`,
      classification: `Clasificación`,
      confidential: `Confidencial`,
      selectProgram: `Seleccionar programa`,
      swalSuccess: `Cambio realizado con éxito.`,
      dateDownloadReport: `descarga`,
      setHallOfFame: `¿Desea activar el salón de la fama en su nuevo programa?`,
      addHackerToHof: `¿Desea agregar al experto al Salón de la Fama?`,
      hallOfFame: `Salón de la Fama`,
      hallOfFameDoesNotHaveEnoughDataYet: `¡El Salón de la Fama aún no tiene suficientes especialistas!`,
      hallOfFameThanksDescription: `quisiera agradecer a los siguientes investigadores por informar fallas de seguridad significativas.`,
      addedAt: `Agregado en`,
      programByObjective: `Programa por objetivo`,
      programObjective: `Objetivo del programa`,
      nowTellUsLittleObjective: `¡Ahora cuéntenos un poco sobre el objetivo del programa!`,
      aGoodObjectiveAvoids: `Un objetivo bien definido evita problemas, si tiene algún problema, consúltenos.`,
      targetProgram: `Objetivo`,
      include: `Incluir`,
      infoTarget: `¡Advertencia! Es necesario informar al menos un objetivo.`,
      aboutTarget: `¡Sobre el objetivo del programa!`,
      setProgramReward: `Establecer la recompensa del programa.`,
      maxProgram: `¡Atención! Se permite un máximo de 10 objetivos por programa.`,
      requiredProgram: `Por favor, registre un objetivo para el programa.`,
      targetRequired: `Por favor, complete el objetivo del programa.`,
      requiredBounty: `Por favor, ingrese un valor.`,
      idConfirmation: `¡Casi está! Confirme su identidad para continuar con el proceso de cambio de contraseña.`,
      titleTarget: `Título del objetivo`,
      targetPlaceholder: `¡Título del objetivo del programa!`,
      titleTargetError: `Por favor, complete el título del objetivo del programa.`,
      updateTarget: `¡Objetivo actualizado con éxito!`,
      swalTarget: `Por favor, verifique si los campos están completos correctamente.`,
      areYouSureYouWantToDeleteThisTarget: `¿Está seguro de que desea eliminar este objetivo?`,
      removeTargetProgram: `¡Objetivo eliminado con éxito!`,
      selectAnObjectiveForTheReport: `¿Qué tipo de objetivo se informó?`,
      informTheTarget: `Informar el objetivo`,
      selectTheProgramTarget: `¡Seleccione un objetivo del programa!`,
      achievedTheObjective: `¿Se logró el objetivo del programa?`,
      reachedIn: `Objetivo alcanzado en`,
      noObjectivesAvailable: `¡No hay objetivos disponibles!`,
      removeIn: `removido`,
      achievedIn: `alcanzado por`,
      pauseProgramSwal: `Programa pausado por falta de objetivo(s) activo(s).`,
      cBoostedProgram: `Programa impulsado`,
      signedAgreements: `Acuerdos firmados`,
      ccpProgObj: `Programa por Objetivo`,
      ccpProgObjDesc: `¡Cree un programa con objetivos predefinidos, donde usted elige quién puede participar y enviar informes!`,
      objectiveProgram: `programa por objetivo`,
      publicPrograms: `programas públicos`,
      privatePrograms: `programas privados`,
      objectivePrograms: `programas por objetivo`,
      alertMessageRemoved: `¡Mensaje eliminado con éxito!`,
      scopeNotFound: `Alcance no encontrado.`,
      usernameOrEmail: `Nombre de usuario o correo electrónico`,
      aboutTheProgramPolicyHacker: `¡Las reglas contenidas en la política del programa deben ser respetadas!`,
      jiraIssueType: `¿Cuál será el tipo de actividad que se registrará en Jira?`,
      conceded: `concedió`,
      toTheSpecialist: `al especialista`,
      getToKnow: `Conozca`,
      solutions: `Soluciones`,
      contact: `Contacto`,
      ourBlog: `Nuestro Blog`,
      doubts: `¿Dudas?`,
      inTheMedia: `En los medios`,
      talkToUs: `Hable con nosotros`,
      understandHowItWorks: `¡Entienda cómo funciona!`,
      managedPrograms: `Programas administrados`,
      vdpPrograms: `Programas VDP`,
      howItWorks: `¡Cómo funciona!`,
      ranking: `Ranking`,
      url: `URL`,
      multipliedScore: `¡Bono! Puntuación multiplicada`,
      codeOfConduct: `Código de Conducta`,
      and: `y`,
      reportConfidential: `Clasificación del documento: Confidencial`,
      securitySystem: `Sistema de Seguridad`,
      emailAlreadyRegisteredInOurDatabase: `Correo electrónico ya registrado en nuestra base de datos`,
      theTokenMustBeEntered: `Se debe ingresar el token`,
      actionAlreadyReported: `¡Acción ya informada!`,
      statusPauseProgram: `El programa ha sido pausado`,
      statusStartProgram: `El programa ha sido reactivado`,
      by: `por`,
      inShort: `en`,
      invalidName: `¡El nombre ingresado no es válido!`,
      includeMoreDetails: `Agregar más detalles...`,
      maxTech: `El máximo permitido es de 10 tecnologías por alcance.`,
      maxLine: `Por favor, limite el mensaje a un máximo de 10 saltos de línea.`,
      includeInfoScope: `Ingrese observaciones sobre el alcance... `,
      includeTech: `Ingrese las tecnologías`,
      editScope: `Editar alcance`,
      scopeDetails: `Detalles del alcance`,
      minMaxScopeCaracter: `El alcance debe tener entre 3 y 40 caracteres`,
      characters: `Caracteres`,
      menuLocker: `Bóveda de Informes`,
      useCodeEmail: `Use el código recibido por correo electrónico`,
      authenticationByEmail: `Autenticación por correo electrónico`,
      accessCredentials: `Credenciales de Acceso`,
      safePassword: `Establecer contraseña de la bóveda de informes`,
      beforeActivating2faAuthentication: `Antes de configurar la contraseña de la bóveda, debe activar su autenticación de dos factores.`,
      beforeActivating2faEmailAuthentication: `Antes de configurar la contraseña de la bóveda, debe activar la autenticación de dos factores (2FA) por correo electrónico.`,
      beforeActivatingSafePassword: `Antes de activar la bóveda, debe establecer la contraseña de la bóveda.`,
      cardHeaderSafe: `Bóveda de Informes`,
      tryAgain: `Por favor, revise la información proporcionada e inténtelo de nuevo.`,
      btnNext: `Siguiente`,
      btnPrev: `Anterior`,
      enableReportVault: `Habilitar Bóveda de Informes`,
      reportVaultSuccessfullyEnabled: `¡Bóveda de informes habilitada con éxito!`,
      reportMovedToVault: `envió el informe a la bóveda`,
      reportMovedOutOfVault: `retiró el informe de la bóveda`,
      userBlockedUntil: `Usuario bloqueado hasta`,
      toThe: `a las`,
      warningLockerActive: `Después de activar la 'Bóveda de informes', no es posible deshabilitar esta funcionalidad.`,
      reportMovedToTheLocker: `El informe se ha movido a la bóveda de informes.`,
      reportMovedToTheLockerQuestion: `¿Desea ser redirigido a la bóveda?`,
      warningAccessCredentials: `Por favor, revise la información proporcionada e inténtelo de nuevo.`,
      receiveCode: `Recibir código`,
      accessLocker: `¡Acceder a la bóveda!`,
      requestNewCodeEmail: `Puede solicitar un nuevo código en`,
      resetPasswordLocker: `Restablecer la contraseña de la bóveda`,
      confirmPasswordLocker: `Confirmar contraseña`,
      errorCaptcha: `El CAPTCHA no fue autorizado. Por favor, inténtelo de nuevo.`,
      rewardsReceivedInReais: `Recompensas recibidas en reales`,
      rewardsReceivedInDollars: `Recompensas recibidas en dólares`,
      onboardingMenuAccount: `Haga clic en el menú "Mi cuenta".`,
      makeYourAccessReportEvenMoreSecure: `Haga que su acceso a los informes sea aún más seguro`,
      toAccessTheVaultEnableTheFollowingSteps: `Para acceder a la bóveda, habilite los siguientes pasos.`,
      registerPhoneOnboarding: `Registre el teléfono.`,
      activeTwoFactorAuthentication: `Habilite la autenticación de dos factores.`,
      registerPasswordLocker: `Registre una contraseña para la bóveda.`,
      methodAppToken: `Proteja el acceso a la bóveda recibiendo el código a través de la aplicación.`,
      methodAppEmail: `Proteja el acceso a la bóveda recibiendo el código por correo electrónico.`,
      methodAppSms: `Proteja el acceso a la bóveda recibiendo el código por SMS.`,
      sendToken: `¡Token enviado!`,
      waitToRequestNewToken: `Por favor, espere 5 minutos antes de solicitar un nuevo token.`,
      phoneNotRegistered: `¡Atención! Teléfono no registrado.`,
      useCodeSms: `Use el código recibido por SMS`,
      titleEmailTwoAuthentication: `Autenticación de dos factores (2FA) por correo electrónico`,
      updateConfigLocker: `¡La configuración de la bóveda ha sido actualizada!`,
      swalRegisterPassword: `¡Contraseña registrada con éxito!`,
      lockerConfig: `Configuración`,
      lockerAccess: `Registros`,
      receiveCodeBySms: `Recibir código por SMS`,
      lockerPassword: `Contraseña de la bóveda`,
      selectUser: `Seleccionar usuario`,
      selectEvent: `Seleccionar evento`,
      USER_LOGIN: `Inicio de sesión realizado`,
      REPORT_MOVED_TO_LOCKER: `Informe movido a la bóveda`,
      REPORT_MOVED_OUT_OF_LOCKER: `Informe removido de la bóveda`,
      REPORT_ACCESS: `Informe accedido`,
      USER_LOGIN_FAILED: `Error al intentar acceder a la bóveda`,
      manyRequestTitle: `Demasiadas solicitudes`,
      manyRequestText: `Está enviando demasiadas solicitudes en un corto período de tiempo. Por favor, inténtelo de nuevo más tarde.`,
      undestand: `Entendido`,
      noRegisterAvailable: `Ningún registro disponible`,
      event: `Evento`,
      swalActiveLocker: `¡La Bóveda de Informes se ha activado con éxito!`,
      swalInactiveLocker: `¡La bóveda de informes ha sido desactivada!`,
      enterTheCode2fa: `Ingrese su código 2FA`,
      labelCodeBackup2faLocker: `Después de descargar el código de respaldo, no podrá generar nuevos códigos. Asegúrese de almacenarlo en un lugar seguro, ya que puede usarse para desactivar la autenticación de dos factores (2FA) si es necesario.`,
      swalWarningDateText: `¡Fecha inválida!`,
      swalWarningDateTitle: `La fecha de inicio debe ser anterior a la fecha de finalización. Por favor, verifique e intente de nuevo.`,
      archiveProgram: `Archivar programa`,
      archive: `Archivado`,
      titleProgram: `Título del programa`,
      statusProgramArchived: `El programa ha sido archivado`,
      waitRequestTitle: `Por favor, espere...`,
      waitRequestText: `Estamos eliminando todos sus informes de la bóveda de informes.`,
      tooltipLocker: `La Bóveda de Informes le permite almacenar de forma segura informes críticos o antiguos, accesibles solo a través de autenticación adicional.`,
      alertInactiveLocker: `Advertencia: Al desactivar la bóveda de informes, todos los informes almacenados se eliminarán permanentemente, volviendo a la lista de informes sin autenticación, como era antes de la activación de la bóveda.`,
      moveReportToLocker: `Para mover el informe a la bóveda, asegúrese de que esté activo.`,
      strongPassword: `Ingrese una contraseña segura`,
      disableSms: `Desactivar código vía SMS`,
      disableEmail: `Desactivar código vía Email`,
      disable2fa: `Desactivar autenticación de dos factores`,
      disableLocker: `Desactivar bóveda de informes`,
      activeLocker: `Activar bóveda de informes`,
      archivedProgramTooltip: `Cuando se archiva, este programa estará inactivo y no estará disponible para los participantes`,
      pauseProgramTooltip: `Cuando se pausa, el programa se desactivará temporalmente para todos los participantes.`,
      LOCKER_ACTIVATED: `Bóveda de informes activada`,
      LOCKER_DEACTIVATED: `Bóveda de informes desactivada`,
      expiredLockerSwal: `Su sesión ha expirado. Por favor, inicie sesión de nuevo para continuar.`,
      countrySelectorLabel: `Código de país`,
      phoneNumberLabel: `Número de teléfono`,
      examplePhone: `Ejemplo:`,
      lockSafe: `Bloquear bóveda`,
      remainingTimeTooltip: `Tiempo restante para bloquear la bóveda`,
      statusProgramUnarchived: `El programa ha sido desarchivado`,
      budgetActive: `Activar costos de recompensas mensuales`,
      alertArchivedProgram: `Al archivar el programa, se pausará, se moverá al submenú "Inactivos" y los participantes perderán el acceso, ya no podrán enviar informes.`,
      alertReactivateProgram: `Al desarchivar el programa, se moverá a la lista de programas activos, pero permanecerá pausado. Los participantes aún no podrán enviar informes hasta que se reanude el programa.`,
      privateComment: `Este comentario se utilizará para comunicarse con el especialista.`,
      internalComment: `Este comentario solo será visible para los empleados.`,
      authenticationRedirect: `Redireccionamiento de Autenticación`,
      redirectPleaseWait: `Redireccionando, por favor, espere.`,
      maximumFilesAuthSSO: `Suba solo un archivo.`,
      replaceFileAuthSSO: `Si necesita reemplazar el archivo, haga clic en el icono "X" y suba el nuevo.`,
      allowedFilesAuthSSO: `Archivo permitido: .xml`,
      swalTotalDays: `¡Advertencia! El número de días debe ser mayor que cero para proceder.`,
      editDomain: `Editar dominio`,
      removeDomain: `Eliminar`,
      activeSSO: `Activar SSO`,
      inactiveSSO: `Desactivar SSO`,
      tooltipSSO: `Acceda a múltiples plataformas con un solo inicio de sesión, de forma práctica.`,
      updateConfigSSO: `¡La configuración de SSO se ha actualizado!`,
      registerDomainSSO: `¡Dominio registrado con éxito!`,
      domainSuccessfullyRemoved: `¡Dominio eliminado con éxito!`,
      swalYouSure: `¿Está seguro?`,
      swalWarningInfo: `¡No podrá revertir esta acción!`,
      swalActionCuccessfully: `Su acción se realizó con éxito.`,
      swalActionPerformed: `¡Acción realizada!`,
      swalTitleCopy: `¡Contenido copiado!`,
      swalTextCopy: `El texto se ha copiado al portapapeles.`,
      domainInvalid: `Por favor, introduzca un dominio válido, por ejemplo, empresa.com`,
      domainIsSame: `Este dominio no es válido o ya ha sido registrado. Por favor, elija otro.`,
      tooltipDescriptionSSSO: `Con SSO (Inicio de Sesión Único), puede acceder a la plataforma de forma práctica, utilizando solo una cuenta.`,
      tooltipActiveSSO: `Antes de continuar, asegúrese de que la configuración necesaria se haya completado en su IdP y de que al menos un dominio esté registrado y validado.`,
      registerSucess: `¡Registrado con éxito!`,
      userPoolId: `Utilice el User Pool ID al configurar su proveedor de identidad (IdP).`,
      userPoolDomain: `Utilice el User Pool Domain al configurar su proveedor de identidad (IdP).`,
      placeholderUrlDomain: `Ingrese el dominio (ej: empresa.com)`,
      labelURLXml: `Ingrese la URL del XML o suba su archivo XML.`,
      manageDomains: `Administrar Dominios`,
      configSSO: `Configuración SSO`,
      placeholderUrlXml: `https://suservidor.com/configuraciones/idp-metadata.xml`,
      attachXMLFile: `Adjuntar Archivo XML`,
      xmlError: `El archivo XML proporcionado no pudo ser procesado. Por favor, verifique que esté bien formado y cumpla con los estándares esperados.`,
      swalActionNotPermitted: `Acción no permitida`,
      swalOneRegisteredDomain: `Necesita tener al menos un dominio registrado y validado.`,
      accountNotFound: `Correo electrónico no encontrado. Por favor, póngase en contacto con su administrador de IDP`,
      enabledPasswordExpiration: `Habilitar expiración de contraseña`,
      edit: `Editar`,
      titleRegisterAccountSSO: `Es simple, ni siquiera toma 1 minuto. Confirme algunos datos y estará completado en instantes.`,
      yourName: `Nombre`,
      updateXML: `Cambiar el archivo XML de integración`,
      getDownloadXML: `Obtener archivo de configuración XML`,
      downloadOrUpdatedXML: `Descargar o modificar el archivo XML de integración del IDP`,
      titleAttachXML: `Ingrese la URL o adjunte el archivo XML de configuración del IdP`,
      alterXML: `Cambiar`,
      paramsConfigIDP: `Parámetros de Configuración del IDP`,
      enterWithSSO: `Entrar con SSO`,
      enterWithoutSSO: `Entrar sin SSO`,
      titleUrlXML: `Proporcione la URL del archivo XML del IdP (Proveedor de Identidad).`,
      copyContent: `Copiar`,
      validateDomain: `Validar dominio`,
      validated: `Validado`,
      validatedDomain: `Valide su dominio dentro de 72 horas para que no sea eliminado.`,
      titleValidateDomain: `¡Valide su dominio!`,
      swalInfoValidateDomain: `Para completar el proceso de validación, registre la siguiente variable como un registro TXT en el DNS del dominio `,
      swalAfterValidateDomain: ` después de registrar, haga clic en Validar para continuar.`,
      swalValidateSuccess: `¡Dominio validado con éxito!`,
      swalErrorValidateDomain: `Error al validar el dominio`,
      swalTryAgain: `verifique e intente de nuevo.`,
      swalTitleError: `¡Error inesperado!`,
      swalTextError: `Ocurrió un error al abrir la validación del dominio. Por favor, inténtelo de nuevo más tarde.`,
      btnValidated: `Validar`,
      loading: `Cargando...`,
      sizeXml: `El tamaño máximo permitido para el archivo es 100KB.`,
      pendingPayments: `Pagos pendientes`,
      completedPayments: `Pagos efectuados`,
      attributeEmailSSO: `Le pedimos que se ponga en contacto con su administrador de IdP para verificar y asegurarse de que el atributo "email" esté configurado correctamente.`,
      emailContentSSO: `Asegúrese de mapear el campo "email" con el valor "email" en su IDP.`,
      emailExSSO: `Ejemplo: email: email`,
      textErrorDomain: `Todos los dominios de los usuarios propietarios deben registrarse y validarse antes de continuar.`,
      swalAlertOwner: `No es posible eliminar un dominio vinculado al propietario.`,
      textWarningDisableSSO: `Al desactivar el SSO, todos los usuarios, excepto los usuarios "Propietario", serán desactivados de la plataforma. La reactivación de estos usuarios debe realizarse a través del menú "Usuarios". Además, el usuario "Propietario" recibirá un correo electrónico para restablecer la contraseña.`,
      requiredRegisterDomain: `Es necesario registrar y validar el dominio del usuario.`,
      authenticationControls: `Controles de autenticación`,
      codeByEmail: `Código por email`,
      enterTheCodeBackup: `Ingrese su código de respaldo`,
      titleModalBackup2fa: `Token de respaldo`,
      awaitNewToken: `¡Espere! Pronto, podrá solicitar un nuevo token.`,
      monthYear: `Mes/Año`,
      provision: `Provisión`,
      monthly: `Mensualidad`,
      management: `Administrado`,
      headerBounty: `Recompensas`,
      noDomainRegistered: `Ningún dominio registrado.`,
      titleSendEmail: `Centro de envío de correos electrónicos`,
      cardPrivateProgram: `Programas privados`,
      sendEmailSuccess: `¡Correo electrónico enviado para análisis!`,
      placeholderMessageEmail: `Escriba su mensaje aquí...`,
      placeholderMessageTopic: `Asunto del correo electrónico`,
      subTitlePageSendEmail: `Envíe correos electrónicos personalizados de forma rápida y eficiente a especialistas de los programas privados.`,
      titleCardSelectedProgram: `Programas seleccionados`,
      titleCardHacker: `Especialistas`,
      hackerListEmpety: `Ningún especialista disponible`,
      programListSelectedEmpety: `Ningún programa seleccionado`,
      placeholderFilterHacker: `Filtrar especialista`,
      placeholderFilterProgram: `Filtrar programa`,
      navCustomEmail: `Envío de correo electrónico`,
      controlEmail: `Administrador de correo electrónico`,
      noEmailsAvailable: `Ningún correo electrónico disponible`,
      rejected: `Rechazado`,
      scheduleDate: `Programe la fecha de envío del correo electrónico`,
      sendForAnalysis: `Enviar para análisis`,
      removeEmailSuccess: `¡Correo electrónico eliminado con éxito!`,
      areYouSureYouWantToDeleteThisEmail: `¿Está seguro de que desea eliminar este correo electrónico?`,
      searchEmail: `Buscar correo electrónico`,
      createEmail: `Crear correo electrónico`,
      editEmail: `Correo electrónico`,
      emailTopic: `Asunto`,
      dateSendEmail: `Fecha programada`,
      tooltipEditEmail: `Editar correo electrónico`,
      tooltipDeleteEmail: `Eliminar correo electrónico`,
      tooltipViewRejectedMessage: `Ver mensaje`,
      tooltipHiddenRejectedMessage: `Ocultar mensaje`,
      sentEmail: `Enviado`,
      continueEmail: `Continuar correo electrónico`,
      temporaryEmailStorage: `Almacenamos temporalmente los datos de su correo electrónico`,
      yourEmailWillBeAnalyzed: `Su correo electrónico será analizado y, después de la aprobación, se enviará en la fecha programada.`,
      hackersSelected: `Especialistas seleccionados`,
      checkAllFields: `¡Verifique que todos los campos estén completos!`,
      recipients: `Destinatarios`,
      emailContent: `Contenido del correo electrónico`,
      viewEmail: `Ver correo electrónico`,
      pentest: `Pentest`,
      pentestCreateSubTitle: `¡Momento emocionante, hora de comenzar a crear su pentest!`,
      pentestType: `Tipo de Pentest`,
      whitebox: `Caja Blanca`,
      blackbox: `Caja Negra`,
      inclusionInWebApplication: `Inclusión en Aplicación Web`,
      inclusionInMobileApplication: `Inclusión en Aplicación Móvil`,
      loggedArea: `Área Logueada`,
      executionPeriod: `Fecha de ejecución`,
      scheduleDatePentest: `Programe la fecha para la ejecución de la prueba`,
      limitScopePentest: `Defina los alcances que se probarán`,
      selectedScopePentest: `Seleccione los alcances para la prueba`,
      addObsOthersPentest: `Añada una observación general...`,
      lblErrorRequiredObs: `Por favor, describa el tipo de alcance.`,
      inPerson: `Presencial`,
      applicationLocation: `Ubicación de la aplicación`,
      credential_access: `Credenciales de Acceso`,
      sourceCode: `Código Fuente`,
      requireFields: `Verifique los campos resaltados en rojo y complételos correctamente.`,
      selectedLocalApplication: `Seleccione la ubicación de la aplicación`,
      selectedOneOption: `Seleccione una opción`,
      securityRetest: `Reprueba de Seguridad`,
      settingsPentest: `Configuración del entorno, las herramientas y el alcance para la ejecución segura de Pentest.`,
      aboutPentest: `Defina el propósito del Pentest, destacando los riesgos y las vulnerabilidades que deben evaluarse.`,
      swalSendPentest: `Enviado para análisis`,
      viewPentest: `Ver`,
      pentestSubTitle: `Realice un seguimiento y gestione sus pentests en BugHunt.`,
      editPentest: `Detalles del pentest`,
      swalDeletedPentest: `¡Eliminado con éxito!`,
      areYouSureYouWantToDeleteThisPentest: `¿Está seguro de que desea eliminar este pentest?`,
      wantSaveChangesPentest: `¿Realmente desea guardar los cambios realizados en este pentest?`,
      swalUpdatePentest: `Cambios realizados con éxito.`,
      scopeListOfThePentest: `Lista de alcance del pentest!`,
      summaryAboutPentest: `Resumen del propósito del Pentest, destacando los riesgos y las vulnerabilidades que deben evaluarse.`,
      canceled: `Cancelado`,
      noPentestAvailable: `Ningún pentest disponible`,
      requireAtLeastOneProfile: `¡Debe registrar al menos un perfil!`,
      profileAlreadyAdded: `Este perfil ya se ha agregado a la lista.`,
      insertUserProfile: `Insertar perfil de usuario`,
      noProfileAvailable: `Ningún perfil disponible.`,
      enterDate: `Ingrese una fecha`,
      testDataProvided: `Datos proporcionados para la realización de las pruebas`,
      selectAnOption: `Seleccione una opción`,
      describeScopeType: `Describa el tipo de alcance`,
      addScopeToContinue: `Por favor, añada un alcance para continuar.`,
      about: `Acerca de`,
      appPurposeDescription: `Haga una breve descripción del propósito de la aplicación`,
      moreDetailsAboutYourApp: `Cuéntenos más detalles sobre su aplicación...`,
      fillAppDetails: `Complete los detalles de la aplicación *`,
      aboutApplication: `Acerca de la aplicación`,
      criticalApplicationDescription: `Se trata de una aplicación crítica, donde las fallas pueden poner vidas en riesgo.`,
      criticalSystemsExamples: `Sistemas de plantas de energía nuclear, aviónica, control industrial y automatización hospitalaria.`,
      criticalApplicationWarning: `Se trata de una aplicación crítica, donde las fallas pueden poner vidas en riesgo.`,
      handlesLargePersonalDataVolumes: `Maneja grandes volúmenes de datos personales.`,
      performsFinancialTransactions: `Realiza transacciones financieras.`,
      paymentsCryptoAssetsSwiftTransactions: `Pagos, criptoactivos y transacciones Swift.`,
      viewersCannotCreatePentest: `¡Los usuarios de tipo visualizador no tienen permiso para crear pentests!`,
      startDate: `Fecha de inicio`,
      endDate: `Fecha final`,
      startDateMustBeEqualOrGreaterThanCurrent: `¡La fecha de inicio debe ser igual o mayor que la fecha actual!`,
      briefApplicationPurpose: `Una breve descripción del propósito de la aplicación`,
      totalPentests: `Total Pentests`,
      descriptionWhiteBox: `Simula un ataque real, donde el probador tiene muy poca o ninguna información previa sobre el sistema, evaluando la eficacia de las medidas de protección y la respuesta a los ataques.`,
      descriptionBlackBox: `Simula un ataque real sin acceso previo a la información del sistema, probando la seguridad externa, la eficacia de las defensas y la respuesta a posibles invasiones.`,
      createPentest: `¿Vamos a crear un pentest?`,
      ssoLoginMethodForOrganizations: `Este método de inicio de sesión es exclusivo para empresas que utilizan SSO en BugHunt. Si no formas parte de una organización con SSO, utiliza la opción "Entrar sin SSO".`,
      budgetSwal: `Presupuesto actualizado con éxito.`,
      managerSwal: `Gestores actualizados con éxito`,
      urlDomain: `Utilice la URL de redireccionamiento al configurar su proveedor de identidad (IdP).`,
      defineAtLeastOneGoalBeforeReactivating: `¡Antes de reactivar el programa, define al menos un objetivo!`,
      view: `Visualizar`,
      additions: `Adiciones`,
      removals: `Eliminaciones`,
      minLengthUpdateProgram: `¡La descripción debe contener al menos 10 caracteres!`,
      submitAgreementNotice: `Al hacer clic en "Enviar para Análisis", aceptas los`,
      ourLabel: `nuestros`,
      confirmReadOur: `y confirma que ha leído nuestros`,
      youAgree: `Estás de acuerdo con los`,
      help: `Ayuda`,
      errorUserNameIdp: `El valor en 'userName' no cumple con la restricción: El miembro debe satisfacer el patrón de expresión regular: [\p{L}\p{M}\p{S}\p{N}\p{P}]+`,
      causeFormatUserName: `El problema radica en el formato del atributo userName que el IdP está enviando en la aserción SAML. Cognito espera un patrón específico, y el IdP está enviando algo diferente.`,
      solutionFormatUserName: `En el IdP, configura el mapeo de atributos para asegurar que el atributo requerido se envíe en la aserción SAML y que su valor sea válido.`,
      causeAttributeEmail: `Cognito está configurado para requerir un atributo de correo electrónico específico, pero el IdP no lo está enviando en la respuesta SAML, o el valor enviado no es válido para Cognito.`,
      solutionAttributeEmail: `Ajusta el mapeo del atributo userName en el IdP para que su valor coincida con la expresión regular requerida por Cognito.`,
      causeCertificate: `El certificado utilizado por el IdP para firmar la respuesta SAML ha expirado, está revocado o no coincide con el certificado configurado en Cognito. También puede haber un problema con la cadena de confianza del certificado.`,
      solutionCertificate: `Actualiza el certificado en el IdP y en Cognito. Asegura que el certificado del IdP sea válido y que Cognito confíe en él.`,
      causeClocks: `Hay una diferencia de tiempo significativa (desfase de reloj) entre el servidor del IdP y los servidores de Cognito. SAML define un período de validez para las aserciones.`,
      solutionClocks: `Sincroniza los relojes de los servidores del IdP y de Cognito (utilizando NTP, por ejemplo) para minimizar el desfase.`,
      causeAudienceRestriction: `El atributo AudienceRestriction presente en la aserción SAML del IdP no coincide con el Entity ID exacto configurado y esperado por Cognito. Esto asegura que la aserción esté destinada al proveedor de servicios (Cognito) correcto.`,
      solutionAudienceRestriction: `En el IdP, verifica la configuración de la "Restricción de audiencia" para el cliente SAML y asegura que coincida con el Entity ID de tu User Pool de Cognito.`,
      causeAssertionSAML: `Cognito ha detectado que una aserción SAML con el mismo ID ya ha sido procesada anteriormente. Esta es una medida de seguridad para prevenir ataques de repetición.`,
      solutionAssertionSAML: `Generalmente, no es un error de configuración. Puede ser un problema de caché del navegador, múltiples envíos de la misma solicitud o un intento malicioso. Limpiar la caché y las cookies del navegador del usuario puede ayudar.`,
      causeMalformed: `La respuesta SAML enviada por el IdP no es un XML SAML válido, está corrupta o hay un problema en su codificación/compresión.`,
      solutionMalformed: `Inspecciona el XML bruto de la respuesta SAML utilizando un SAML Tracer para identificar problemas de sintaxis o estructura. Verifica los registros del IdP para errores internos en la generación de la respuesta SAML.`,
      causeSAMLAssertion: `Cognito está configurado para requerir que las aserciones SAML estén firmadas digitalmente, pero el IdP las está enviando sin firmar.`,
      solutionSAMLAssertion: `Configura el IdP para firmar digitalmente las aserciones SAML que envía a Cognito.`,
      causeRelayState: `El parámetro RelayState, utilizado en flujos de inicio de sesión iniciados por el proveedor de servicios (SP-Initiated) para redirigir al usuario después de la autenticación, falta o ha sido modificado durante la comunicación.`,
      solutionRelayState: `Verifica si hay algún proxy o firewall que esté cambiando la URL de redireccionamiento. En algunos casos, puede ser un problema de configuración en el IdP o en la aplicación que inicia el flujo.`,
      suspendedAccount: `Su cuenta estará temporalmente suspendida de`,
      termsAcceptWithSuccess: `¡Términos aceptados con éxito!`,
      scopeRequired: `Campo obligatorio. Se debe definir un alcance previamente.`,
      unsolicited: `No solicitado`,
      author: `Autor`,
      authorName: `Nombre del autor`,
      sent_at: `Fecha de envío`,
      updatedAt: `Fecha de actualización`,
      closed_at: `Fecha de cierre`,
      bounty_value: `Valor del pago`,
      company_bounty_status: `Estado del pago para la bughunt`,
      company_bounty_payment_date: `Fecha del pago para la bughunt`,
      hacker_bounty_status: `Estado de la transferencia del pago al especialista`,
      hacker_bounty_payment_date: `Fecha del pago`,
      weakness: `Debilidad`,
      tags: `Etiquetas`,
      createdAt: `Fecha de creación`,
      current: `Actual`,
      campaign: `Campaña`,
      suggestedValue: `El valor debe ser mayor o igual al valor sugerido.`,
      needsValueInformed: `¡El valor debe ser informado!`,
      reportYithActiveCampaign: `Informe enviado mientras la campaña estaba activa`,
      doubleScore: `Puntuación doble`,
      doubleScoreAndBounty: `Recompensas y puntuación doble`,
      warningFinalDate: `La fecha final debe ser posterior a la fecha inicial.`
      //translation_script_end_es
    }),
  ],
});
